let sets = {
  'Ainsworth':
  {
    name: 'Ainsworth',
    jpCaption: 'エーンズ・ワース',
    level: 'advanced',
    notices: 'This new set dance was composed in 2017 by Manchester set dancer Charlie Kiely. 最初のLead AroundはLock hold。〜"Come West Along the Road", Pat Murphyより抜粋。',
    referenceSite: '',
    thumbnail: '',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Change Places',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', caption: ['すべてのカップルはwaltz holdになり、sevensの動きで一つ右のカップルのところへ移動する（2 bar）、時計回りに90度周って後ろ向きにsevensし、元いた位置からoppositeの位置へ行く（4 bar）', '同じ動作を繰り返して元の位置へ戻る（4 bar）'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Change Places', caption: ['すべてのカップルはcross handで手を繋ぎ、セットの内側を向き、Advance & Retireする（4 bar）', 'もう一度Advanceし、Retireするときにジェンツはレディーを両腕で回す(4 bar）', 'レディーはジェントの前を通って、ジェントの左側へ移動する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Change Places', caption: ['すべてのカップルはcross handで手を繋ぎ、セットの内側を向き、Advance & Retireする（4 bar）', 'もう一度Advanceし、Retireするときにジェンツはレディーを両腕で回す(4 bar）', 'レディーはジェントの前を通って、元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone & Tops', summary: 'Adv-Ret & Ladies; Moves opps', caption: ['すべてのカップルはAdvance & Retireする（4 bar）', 'その後、Leading Couplesはもう一度Advanceし、ジェンツはレディーを両腕で時計回りに回す(2 bar）', 'レディーはジェントの前を通って、oppositeのジェントのところへ移動する', 'その後、新しいパートナーと一緒にRetireする(2 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone & Sides', summary: 'Adv-Ret & Ladies; Moves opps', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Ladies; Moves left', caption: ['すべてのカップルはAdvance & Retireする（4 bar）', 'もう一度Advanceした後、ジェンツはRetireするときにレディーを両腕で時計回りに回す', 'レディーはジェントの前を通って、一つ左隣のジェントのところへ移動し、新しいパートナーとcross handで手を繋ぐ'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Ladies; Moves left', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Line of Four',
      rythmn: 'Reel',
      description: 'よせては返すさざ波のよう…',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' },
        { bar: 8, subject: 'Tops → Sides', summary: 'Adv-Ret (open)', caption: ['すべてのカップルはopen holdになってセットの内側を向く', 'open hold: ジェンツは右手をレディーの腰にまわし、レディーは左手をジェンツの左肩に置く', 'Leading CouplesはAdvance & Retireする。Leading CouplesがRetireするとき、Leading CouplesでないカップルはAdvanceする(4 bar)', 'Leading CouplesはAdnvanceし、Leading CouplesでないカップルはRetireする。その後、Leading CouplesでないカップルがRetireするとき、Leading CouplesはAdvanceする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv & Swing', caption: ['Leading Couplesでないカップルは元の位置へRetireし(2 bar)、Swingする(6 bar)', 'Leading Couplesはセットの中央でSwing Fourする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line of Four', caption: ['Leadingでないカップルは自分のパートナーと離れてLeading Couplesのライン状に並ぶ', 'Leading Couplesは自分のパートナーと向き合い、その他の人は同じライン上のLeading Coupleの側を向く', 'Leading GentとLeading Ladyは右手をとってChainし、ラインの端にいるジェントとレディーと位置を交換する(4 bar)', 'Leading GentとLeading Ladyはリーディングでないダンサーの側を向く', 'リーディングでないダンサーは互いに向き合って右手でChainし、Leading GentまたはLeading Ladyと向き合う(2 bar)', '左手をとってChainし、Leading Couplesは右手をとる。リーディングでないダンサーは元の位置のoppositeの位置でLeading Couplesの方へ向く(2 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line of Four', type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Adv, Dance on the spot', caption: ['ジェンツはセットの中央へAdvanceし、レディーはRetireし、その場でステップする(4 bar)', 'その後、ジェンツはRetireし、レディーはAdvanceし、Leading Couplesの位置でライン状に並び、ステップする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Adv, Dance on the spot', caption: ['レディーはセットの中央へAdvanceし、ジェンツはRetireし、その場でステップする(4 bar)', 'その後、ジェンツはAdvanceし、レディーはRetireし、Leading Couplesの位置でライン状に並び、ステップする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', caption: ['Adv, Dance on the spotはSides Leadingのときはレディーが先にAdvanceする'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Circle Chain',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Star, Gents; Moves', caption: ['レディーはRight Hand Starをし(4 bar)、Left Hand Starで元の位置へ戻る(4 bar)', 'ジェンツは反時計回りに一周し、元の位置へ戻る', '元の位置へ戻ったら自分のパートナーと右手を合わせてTurnする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Gents; Star, Ladies; Moves', caption: ['ジェンツはLeft Hand Starをし(4 bar)、Right Hand Starで元の位置へ戻る(4 bar)', 'レディーは反時計回りに一周し、元の位置へ戻る', '元の位置へ戻ったら自分のパートナーと左手を合わせてTurnする'], type: 'repeat' },
        { bar: 32, subject: 'Everyone', summary: 'Circle Chain', caption: ['ジェンツはセットの内側を、レディーはセットの外側を向き、その場でステップする(4 bar)', 'その後ジェンツは反時計回りに、レディーは時計回りにChainし、新しく出会ったジェント/レディーと右手をとってHalf Turnする。ジェンツはセットの外側、レディーはセットの内側を向き、その場でステップする(4 bar)', '元の位置に戻るまでこの動作を繰り返す(24 bars)', '自分のパートナーと再開したら、ジェンツはレディーを左手で時計回りにTurnし、Lock holdになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 64, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Star',
      rythmn: 'Reel',
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Star, Gents; Star', caption: ['レディーはRight Hand Starをし、3番目のジェント（元の位置の一つ右側の位置にいるジェント）と左手を合わせてTurnし、ジェントの隣へ行く(4 bar)', 'ジェンツはRight Hand Starをし、3番目のレディー（元の位置の一つ右側の位置にいるレディー、自分のパートナー）と左手を合わせてTurnし、レディーの隣へ行く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Star, Gents; Star', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', caption: ['ホームポジションのoppositeで自分のパートナーとHomeする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waist) & Crossover', caption: ['Leading Couplesは左側のカップルと、Leading Couplesでないカップルは右側のカップルと向き合う', 'ジェンツは右手をレディーの腰に回し、Advance & Retireする(4 bar)', 'レディーは右肩で、ジェンツは左肩ですれ違うようにしてCrossoverし、次のカップルと向き合う(4 bar)', 'その際、ジェンツは時計回りに少し体の向きを変える'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waist) & Crossover', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'An Sean Chistin':
  {
    name: 'An Sean Chistin',
    jpCaption: 'アン・シャン・キスティン',
    level: 'advanced',
    county: ['Laois'],
    notices: 'このセットはLaois州のBallyfinで、Maureen Culletonにより作られた。"The Sean Chistin(Old Kitchen)"とはMaureenの旧家で、現在はRambling HouseとしてMaureenの指導の下、セッションや歌やダンスが定期的に開催されている。すべてのSwingはwaltz holdで行う。1st Sideは1st Topの左側のカップル。〜"Toss The Feathers", Pat Murphyより抜粋。',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Back to back',
      rythmn: 'Polka',
      description: 'Leading は時計回りに Tops - Sides - Tops - Sides の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=zMVyTZ2q4Rs',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Slide In, Out & Turn to right', caption: ['すべてのカップルはセットの中心に向かってSlide In, Outする', 'その後、時計回りに2周しながら一つ右隣へ移動する'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', caption: ['waltz holdになり、Houseする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Back to back & Move', caption: ['Leading Couplesは左隣のカップルと、Leadingでないカップルは右隣のカップルと向き合う', '向き合ったレディー同士でBack to backする(6 bars)。その間、ジェンツはその場でステップする', 'ジェンツは右手で向かいのレディーの右手をとり、自分の隣に引き寄せる(2 bars)。その間、レディーはジェンツの腕の下で反時計回りにTurnする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', caption: ['出会ったパートナーとSwingする'], type: 'repeat' },
        { bar: 48, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', caption: ['自分のパートナーとSwingするまで、レディーは各ジェンツを巡る'], type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Balance & Turn to right', caption: ['"Balance"とは相手に近づいて離れること'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Show the lady',
      rythmn: 'Jig',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=tfLPVLF5BtM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Slide In, Out & Turn to right', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Show the lady & Turn the Ladies', caption: ['Leading CoupleはHouse insideする', 'この時、その他のレディーはジェンツの腕の下で時計回りに2回Turnする。ジェンツは左手でTurnさせる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond House', caption: ['すべてのカップルはDiamond Houseする', '1, 2, 123のリズムで動き、方向転換する', '進むときはジェンツは左足、レディーは右足から動かし、後退するときはジェンツは右足、レディーは左足から動かす'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Adv-Ret & Turn to right', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Sevens',
      rythmn: 'Hornpipe',
      description: 'Sevensするとき、Topsは左側、Sidesは右側のカップルと向き合う',
      youtube: {
        url: 'https://www.youtube.com/watch?v=OUP7OySn82Q',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret (hornpipe)', caption: ['hornpipeのステップ、hop 123でAdvance-Retireする'], type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body (hornpipe) & Double to right', caption: ['hornpipeのステップでBodyする(4 bars)。hop 123でセットの中心へ進み、hop 123で後退する', 'その後、hop, 1, 2, 3, 4のリズムで一つ右隣の位置へDoubleで移動する'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Sevens & Change Places', caption: ['すべてのカップルはwaltz holdになる', 'Topsは左側のカップルと、Sidesは右隣のカップルと向き合う', '向き合ったカップルとsevensですれ違う(4 bars)。行きはジェンツが背中合わせ、帰りはレディーが背中合わせになる', 'waltz holdを解き、レディーは一歩左側へ、ジェンツは一歩右側へ移動する', '向かってくるジェントまたはレディーとすれ違い、新しいパートナーと出会ったら、ジェンツは右手でレディーの左手をとり、時計回りに一周する', 'このとき、手は下げたままで一周する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond House (sevens)', caption: ['すべてのカップルはDiamond Houseする', 'sevensのリズムで動き、方向転換する', '進むときはジェンツは左足、レディーは右足から動かし、後退するときはジェンツは右足、レディーは左足から動かす'] },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body & Double to right', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'House with Left',
      rythmn: 'Reel',
      description: 'Leading は時計回りに Tops - Sides - Tops - Sides の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=x9m0QamPVuI',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Adv-Ret & Turn to right', caption: ['パートナーとwaltz holdになる', 'すべてのカップルはセットの中心に向かってAdvance & Retireする', 'その後、時計回りに2周しながら一つ右隣へ移動する'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House with Left/Right', caption: ['Leading Couplesは左側、Leadingでないカップルは右側のカップルと向き合う', '向き合ったカップルとHouseする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Move to Left/Right', caption: ['waltz holdのまま、向き合っているカップル同士でAdvance & Retireする(4 bars)', 'ジェンツはoppositeのレディーの元へ向かう', '互いに右手をとって、その場で時計回りに1周し、ジェンツはoppositeのジェンツと位置を交換する(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 32, subject: 'Everyone', summary: 'Adv-Ret & Turn to right', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Antrim Square':
  {
    name: 'Antrim Square',
    jpCaption: 'アントリム・スクウェア',
    level: 'beginner',
    county: ['Antrim'],
    notices: 'すべてのフィガーで Antrim Square を2回する',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/antrsq'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Ladies star',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=KfcoycPbBCI',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (shoulder)', caption: ['すべてのカップルは反時計回りに Lead Around する(8 bar)', '元の位置へ戻ったら、その場で反転し、反時計回りに Lead Back する(8 bar)', 'ジェンツは女性の右肩の上でレディーの右手に手をのせ、前方で左手で手を繋ぐ', '元の位置へ戻ったら両手を話してwaltz holdになる'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies Star (R→L)', caption: 'すべてのレディーは右手を挙げて時計回りに Star をし(4 bar)、左手を挙げて反時計回りに Star をして元の位置に戻る(4 bar)' },
        { bar: 8, subject: 'Gents', summary: 'Gents Star (R→L)', caption: 'すべてのジェンツは右手を挙げて時計回りに Star をし(4 bar)、左手を挙げて反時計回りに Star をして元の位置に戻る(4 bar)' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', caption: 'Leading Couples は右側のカップルに向かい(2 bar)、元の位置から opposite の位置へバックで向かう(2 bar)。その後 House で元の位置へ戻る(4 bar)', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Antrim Square', caption: 'Leading Couples は自分のパートナーと内側の手をつなぎ、中央へ向かう。opposite のカップルと近づいたら手を離し、自分のパートナーと向き合いながら Leading Couples ではないカップルがいた位置へ向かう(4 bar)。その後、opposite のパートナーと向き合いながら元いた位置へ向かい、自分のパートナーと再会する(4 bar)。このとき Leading Couples ではないカップルは向き合ってからお互いに離れるようにバックし、opposite のパートナーで出会う(4 bar)。その後中央へ向かい、自分のパートナーと再会したら元の位置へ戻る(4 bar)。残りの 8 bar は今行った動作とは逆の動作をして元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' }
      ]
    },
    {
      order: 2,
      summary: 'Swing in four',
      rythmn: 'Rising Jig',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=h--KbE5HS2w',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (shoulder)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Crossover', caption: 'Leading Ladies は右肩ですれ違い(2 bar) opposite へ向かう。その後 Leading Gents は左肩ですれ違い opposite へ向かう(2 bar)。残りの 4 bar は同じ動作を繰り返し元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Antrim Square', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Swing your corners',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=FckzKInepOk',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (shoulder)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/your corners', caption: 'ジェンツは自分の左側のレディーと、レディーは自分の右側のジェントと Swing する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', caption: '2 bar かけて自分のパートナーと出会い、残りの 6 bar を Swing する', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Antrim Square', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Baile Bhuirne Jig':
  {
    name: 'Baile Bhuirne Jig',
    jpCaption: 'バリー・ボニー・ジグ',
    level: 'basic',
    county: ['Cork'],
    notices: 'このセットはKillarneyとMillstreetの間にある、コーク州西部のBaile Bhúirne周辺のセット。Clondrohid、Kilnamartyr、Ballingearyなど地方によりいくつかバリエーションがある。元来はJig SetでありJigで踊られていたが近年はSlideまたはSingle Jigsとして踊られており、5つのフィガーが休憩なしで連続して踊られる。 〜"Toss The Feathers", Pat Murphyより抜粋。504 bars + 8 bar Lead in (16 bars × 32)',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/ballbh',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/ballyvourneyj.htm'
    },
    hasLeadIn: false,
    needsSet: true,
    figures: [{
      order: 1,
      slideId: 'slide1',
      summary: 'Swing',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ehDHrBaYhPE',
        start: 8
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Hook & House', caption: ['Leading Couples はセットの中心の方向へ進み(1 bar)、セットから外れるように進み(1 bar)、House する(6 bar)', 'その他のバリエーションは DanceMinder 参照'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', caption: ['Leading Couples は右側のカップルの方へ進み(2 bar)、90度時計回りに反転し後ろ向きに opposite の位置へ向かう(2 bar)', 'その後 House across で元の位置へ戻る(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', caption: ['Leading Couplesはセットの中央へ向かってSlide Inし、元の位置へ向かってSlide Backする(4 bar)', 'その後、oppositeの位置へ向かってHouseする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      slideId: 'slide2',
      summary: 'Swing Opps.',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Hook & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Crossover & Swing', caption: 'Leading Gents は opposite のレディーのところへ行って(2 bar)、Swing する(6 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Cross back & Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      slideId: 'slide3',
      summary: 'Double Christmas',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Hook & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 16, subject: 'Tops', summary: 'Little Christmas x 2', caption: ['Leading Couplesはセットの中央で時計回りにLittle Christmasする(8 bar)', '8小節目に全員でジャンプし、続けてLittle Christmasする(6 bar)', 'その後、元の位置へ戻る(2 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      slideId: 'slide4',
      summary: 'Swing Next Lady',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Hook & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Top Gents', summary: 'Swing w/new Lady', caption: 'Leading Gents は左側にいるレディーのところへ行って Swing する', type: 'nested-repeat' },
        { bar: 24, subject: 'Top Gents & Every Lady', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      slideId: 'slide5',
      summary: 'Chain',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる。Sides Leading になったとき、各カップルは opposite と位置が逆になる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Hook & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Half Turn, Chain & Swing ', caption: ['すべてのカップルは自分のパートナーと向き合って右腕を掴み、時計回りに180度反転する(2 bar)', 'その後、ジェンツは時計回り、レディーは反時計回りに左手→右手で Chain する', 'opposite の位置で自分のパートナーと再開したらSwingする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Ballinascarty Half':
  {
    name: 'Ballinascarty Half',
    jpCaption: 'バリナースカーティ・ハーフ',
    level: 'advanced',
    county: ['Cork'],
    notices: 'このセットはコーク州南西部のもの。This set is from the South West of County Cork.〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'http://setdanceteacher.ie/ballinascarty.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'The Polka',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=oq3p5LyV5tE',
        start: 74
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['両腕でTurnさせる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Square (waltz)', caption: ['1, 2, 123のリズムで、ジェンツは前に、レディーは後ろ向きに右へ進む(2 bars)', '時計回りに少しまわり、先ほどとは逆の足から、レディーは前に、ジェンツは後ろ向きにもう一つ右の位置へ進む(2 bars)', '同じ動作を繰り返してホームポジションへ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Change partners →opps.', caption: ['レディーはセットの中央へ進み、左肩ですれ違い(2 bars)、左に動き(2 bars)、後退して右肩ですれ違い(2 bars)、その場で時計回りにまわってジェントと向き合う(2 bars)', 'その間、ジェンツは8 bars かけて反時計回りにoppositeへ向かう'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new P.', caption: 'いらっしゃいませSwing', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'The Jig',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=oq3p5LyV5tE',
        start: 190
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Square (open)', caption: ['パートナーとopen waltz holdになる', '右側へ進み(2 bars)、時計回りに体を向きを変えてoppositeへ向かって後退する(2 bars)', '同じ動きを繰り返してホームポジションへ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Change partners (L→R)', caption: ['レディーはoppositeのレディーと左肩ですれ違うようにしてoppositeのジェントのところへ向かい、左手でTurnし、oppositeのレディーと右肩ですれ違うようにしてホームポジションへ戻り、右手でTurnし、再びoppositeのレディーと右肩ですれ違ってジェントの向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new Partners', caption: 'いらっしゃいませSwing', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'The Hornpipe',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=oq3p5LyV5tE',
        start: 346
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing or Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Square', caption: ['パートナーとwaltz holdになり、SevensでDiamond Squareする', 'ジェンツがセットの中央に背を向けるようにして、右側へ移動し、時計回りに向きを変えてレディーがセットの中央に背を向けるようにして、後退して元の位置からoppositeへ行く(4 bars)', '同じ動作を繰り返してホームポジションへ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: '1, 2, Double', caption: ['右側へ進み(2 bars)、Doubleでoppositeへ行く(2 bars)', '同じ動作を繰り返してホームポジションへ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Change partners', caption: ['レディーはセットの中央へ進み、oppositeのレディーと右手をとって1と1/2周まわり、oppositeへ行く', 'その間、ジェンツは反時計回りにセットの周囲を歩いてホームポジションへ戻り、oppositeのレディーと出会う'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 56, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double', caption: 'Leading Couples は House し(6 bar)、最後の 2 bar は Double する' }
      ]
    }]
  },
  'Ballycommon':
  {
    name: 'Ballycommon',
    jpCaption: 'バリーコモン',
    level: 'beginner',
    county: ['Tipperary'],
    notices: 'このセットはティペラリーとリムリックの東部で伝統的に踊られるセットです。セットの名前はティペラリー州Nenaghの外にあるバリーコモンの丘に因んでいます。はじまりのハウスなど、地域によっていくつかバリエーションがあります。いくつかのフィガーはBallagh Plain Setとして知られるハーフセットと似通っています（Ballagh Plain Setはティペラリー州のDrombane、Clonouly / Cashelのセット）。Drombaneの近辺ではPlain Setと呼ばれることもあります。 〜"Toss The Feathers", Pat Murphyより抜粋。映像のプレイリスト→https://goo.gl/xVfaE6',
    referenceSite: {
      irishSetDancing: 'http://setdanceteacher.ie/ballycommon.htm'
    },
    needsSet: true,
    thumbnail: '',
    figures: [{
      order: 1,
      slideId: 'slide1',
      summary: 'Link arm',
      rythmn: 'Polka',
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House or Slide across & House Back', caption: ['Reverse HouseまたはSlide across & House Backする。', 'Reverse Houseの場合、waltz holdになってジェンツは最初の2 bars はレディーを後ろ向きにした状態で一つ右側の位置へ行く。残りの 6 bars は House をして元の位置へ戻る', 'Slide across & House Backの場合、すべてのカップルは Slide in, Slide back で opposite へ移動し、House across で元の位置へ戻る', 'また、Baile Bhuirne Jig Setのように2 barその場でDanceし、6 barでHouseするバージョンもある'] },
        { bar: 8, subject: 'Everyone', summary: 'Link arm', caption: 'ジェンツは左側のパートナーと、レディーは右側のパートナーと腕をつかんで2周する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', caption: '自分のパートナーと Swing する', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 2,
      slideId: 'slide2',
      summary: 'Swing all around',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House or Slide across & House Back' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz)', caption: ['パートナーとwaltz holdになり、Advance & Retireを2回する', '2 bars目、6 bars目でジェンツは右足を、レディーは左足を軽く上げる。4 bars目、8 bars目でジェンツは左足を、レディーは右足を軽く上げる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; move→R, Swing', caption: 'レディーはセットの内側を通って一つ右側のジェンツのところへ移動し、Swing する', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 3,
      slideId: 'slide3',
      summary: 'Circle',
      rythmn: 'Slide',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House or Slide across & House Back' },
        { bar: 8, subject: 'Everyone', summary: 'Link arm', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle (acw)', caption: ['Link armをしたパートナーと左手同士で手を繋ぎ、右手は自分のパートナーと繋ぐ', 'その際レディーは右肩越しにジェンツと右手を繋ぐ。ジェンツはレディーの方に右手を回す', '手を繋いだら反時計回りに一周する', 'この動きは「象の鼻」とも呼ばれる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R)', caption: ['ジェンツは右手をレディー頭上を超えるようにして、右肩からセットの内側に持ってきて、Right hand in right、右手同士をつないでAdvance & Retireを2回する '], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', caption: ['Slide Inした後の2バーズ目に軽く足を上げる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      slideId: 'slide4',
      summary: 'Half Slide',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House or Slide across & House Back' },
        { bar: 8, subject: 'Everyone', summary: 'Link arm', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      slideId: 'slide5',
      summary: 'Full Silde',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House or Slide across & House Back' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    }]
  },
  'Barnane Jig':
  {
    name: 'Barnane Jig',
    jpCaption: 'バーナン・ジグ',
    level: 'advanced',
    // county: [''],
    notices: 'Barnane Jig Setは2018年1月にNenaghで発表された。このセットはコークの美しいJig Set、Jenny LindとTelevaraのスタイルで踊られる。 〜YouTubeより抜粋。',
    referenceSite: {
      // irishSetDancing: 'http://setdanceteacher.ie/ballycommon.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Half Chain',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=imPwcDpvZQA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Square to Right & Home', caption: ['すべてのカップルはwaltz holdになる', 'スライドの動きで一つ右の位置へ移動し(4 bars)、Homeする(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Half Chain', caption: ['すべてのカップルは自分のパートナーと向き合う', 'ジェンツは反時計回りに、レディーは時計回りに、右手→左手の順番で Chain する', 'oppositeでパートナーと出会ったらwaltz holdになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Little Christmas',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UBL28noSxNA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Square to Right & Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (R-in-R)', caption: ['Leading CouplesはRight hand in right、右手をとってAdvance & Retireを2回する', '2回目にRetireするとき、ジェンツはレディーを自分の左隣へ連れ、左腕をレディーの腰に回す'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', caption: ['Leading Couplesはセットの中央でLittle Christmasする', 'ブレイクするとき、レディーはoppositeのジェンツのところへ行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Ladies Star',
      rythmn: 'Jig',
      description: 'LeadingはTops Gents - Tops Gents - Sides Gents - Sides Gentsの順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UoOzkmej0j8',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Square to Right & Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (open) & Ladies: Star', caption: ['すべてのカップルはwaltz holdでAdvance & Retireする(4 bars)', 'レディーはRight hand Starをしてoppositeの位置へ行く', 'その間、ジェンツは一つ右の位置へ移動する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ladies Move',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=9Avgtz5t-fQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Square to Right & Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Ladies; Move to Right', caption: ['すべてのカップルはRight hand in right、右手をとってAdvance & Retireをする(4 bars)', 'そのままパートナーとその場で時計回りに回る', 'その後、レディーは一つ右隣のジェンツのもとへ行き、waltz holdになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: '', subject: '' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Back to back',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=unZq1YfONQk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (lock)', caption: ['すべてのカップルはLock holdでLead Aroundする', 'Lock hold：ジェンツは自分の前にいるジェンツの左肩に自分の左手を置き、右手をレディーの腰に回す'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Diamond Square', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Back to back & Gents; Crossover', caption: ['Leading Couplesはセットの中央を向き、oppositeのパートナーとBack to Backする(4 bars)', 'Leading GentsはCrossoverし、oppositeのレディーの右手をとり、反時計回りに腕の下でTurnさせる(4 bars)', '最後の2 barsで、Leadingでないカップルはパートナーと向き合うようにして離れ、Leading Couplesと4人で列になる'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Line Adv-Ret', caption: ['Line Advance & Retireし、2回目にRetireするとき、Leading Couplesの位置でLittle Christmasの形になる'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Little Christmas', caption: ['Little Christmasする(6 bars)', 'ブレイクするとき、自分の右側にいるレディーの自分の位置へ連れる(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 168, subject: 'Tops - Sides - Sides', summary: '<<Repeat x 3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Battle Of Affane':
  {
    name: 'Battle Of Affane',
    jpCaption: 'バトル・オブ・アファン',
    level: 'advanced',
    county: ['Waterford'],
    notices: 'このセットは1565年、ウォーターフォード州のLismore近くのAffaneで起こったBattle of Affaneを記念してAmie Landersにより作られました。また、2015年のTraleeで開催されたSweets of May Dance Festibalで実演されました。This set was composed by Amie Landers for a celebration to commermorate the Battle of Affane, which took place in 1565 at Affane, near Lismore in County Waterford. The set demonstrated at the Sweets of May Dance Festival in Tralee in 2015. ~ from Come West Along the Road',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/affane'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Tha Battle',
      rythmn: 'Jig',
      description: 'All couples lead around as if leading into battle. Top couples advance and retire, representing the Earl of Desmonds approacch to seize Maurice Fitzgerald\'s cattle, then swing in four to show the alliance between Maurice Fitzgerakd and the Earl of Ormond. Top gent steps back to show that Maurice Fitzerald took no part in the battle and he stamps and taps his knee to represent the shooting of the Earl of Desmond.',
      youtube: {
        url: 'https://www.youtube.com/watch?v=7rrAqeWZ2cw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', caption: ['すべてのカップルは crossed hand になり、Lead Around する', '一周したらセットの中央へ体を向ける。レディーはTurnしない', 'All couples lead around holding crossed hands and finish facing the centre.', 'Ladies do not turn under the arms.'], type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Kick', caption: ['Leading Couples は crossed hand のまま、1,2,3, Kick (or Lift)、1,2, 123 のリズムで Advance & Retire する(4 bars)', 'その後、もう一度 Advance し、Basket のかたちになる(4 bars)', 'Top couples advance dancing 1,2,3, kick or lift and retire dancing 1,2, 123 (4 bars),', 'then advance again and ladies turn in to face each other from side positions to form a circle of four in the centre (4 bars).', 'Ladies place their hands on the gents\' shoulders. (8 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing in Four (basket)', caption: ['Leading Couples は Swing in Four する(6 bars)', 'その後、ジェンツはもとの位置へ戻る(2 bars)', 'このとき、レディーは Leading Gent の opposite の位置へ行く', 'Top couples swing in four in the centre (6 bars)', 'then both gents retire to place, both ladies going with the second gent so that the three of them are facing the top gent. (2 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Cross', caption: ['Leading Lady (the visiting lady) はその場で時計回りに Turn する(2 bars) ', 'Leading Gent の opposite のレディーはその場で反時計回りに Turn する(2 bars)', 'Leading Gent は右足でスタンプし、ひざを叩く(2 bars)', 'Leading Lady はもとの位置へ戻り、Leading Couples はそれぞれパートナーと向き合う', 'As all dance on the spot, first top lady (the visiting lady) turns clockwise in place (2 bars), ', 'then second top lady (on the gent\'s right) turns anticlockwise in place (2 bars),', 'then, as first top lady dances across to her own position, top gent stamps with his right foot and taps his right knee, then all face their partners in place (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'The Community / The Years After',
      rythmn: 'Hornpipe',
      description: 'The second figure symbolises scenes from life in the area after the battle. All house, showing the importance of Dromana House in the lives of the community. The arches represent Dromana Bridge and the advance and retire represent the tides and importance of the River Blackwater.',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Id_Thne2M74',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Chain, Ladies In', caption: ['レディーは3人目のジェンツと Chain したら、セットの中央へ進む', 'Taking their partner\'s right hand in right, all chain around the house.', 'As ladies touch hands with the last gent they meet, the step to the centre.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Wheel & Gents; Arch', caption: ['すべてのレディーは Right Hand Star で3/4周歩いて、元の位置からひとつ右の位置へ行く(4 bars)', 'その間、ジェンツはその場でステップする', 'その後、ジェンツは互いに手を繋いでアーチをつくり、レディーを2回通す(4 bars)', 'レディーは時計回りに Turn しながら新しいジェンツの隣へ行く', 'Ladies join raised right hands in the centre and dance three quarter way around to the next ladies position right of their own', ', while gents dance on the spot (4 bars).', 'Gents now step in to join hands, then raise their arms to make arches', ', under which the ladies reverse into their new positions and turn clockwise in place (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: '7\'s In, Out & Double', caption: ['すべてのカップルは waltz hold になり、セットの中央へ向かって Sevens In し、Home (Double) する(4 bars)', 'その後、Sevens Out し、Home (Double) する(4 bars)', 'In waltz hold with their new partners, all couples dance sevens towards the centre, then turn once in place, dancing 1,2, 3,4 (4 bars).', 'Then they dance sevens outwards from their positions and turn in place again (4 bars).'], type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Doubling House', caption: ['すべてのカップルは céilí hold になり、Double House する', 'Taking céilí hold, all couples double around the house.'] }
      ]
    },
    {
      order: 3,
      summary: 'Today',
      rythmn: 'Polka',
      description: 'The third figure dances to polkas symbolises set dancing in the Waterford and South Tipperary areas today, as represented by the local Ballyduff Set, the Sliabh gCua Set, Dungarvan Set, Cashel Set and many others.',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ex5Wq5ieOZU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret (raised)', caption: ['すべてのカップルは手を上にあげた状態で手を繋いで Circle になり、Advance & Retire を2回する', 'All advance and retire twice holding raised hands in a circle'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain to opps. (under)', caption: ['Leading Ladies は手をあげた状態で、セットの中央で右手、opposite Gent　と左手でLow Chain する(4 bars)', 'その後、セットの中央で opposite lady と一周 Chain して、元の位置から opposite の位置へ向かい、ジェントと向き合う', 'With raised hands, top ladies chain with right hands in the centre and turn left hand in left around opposite gents (4 bars).', 'They now turn around each other in the centre and finish in the opposite lady\'s position, facing opposite gent (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Waterford Steps & Ladies; Cross home', caption: ['Leading Couples は waltz hold になり、セットの中心へ向かって Waterford steps する(4 bars)', 'その後、Leading Ladies は右肩ですれちがい、元の位置へ戻る(4 bars)', 'Gent: Step in L, Tap R heel in front, Hop L, tap R toe to side, Hop L, Tap R heel in front, Hop L (2 bars)', 'Gent: Step out R, Tap L heel in front, Hop R, tap L toe to side, Hop R, Tap L heel in front, Hop R (2 bars)', 'In waltz hold with their new partners, top couples dance the Waterford steps as they dance to the centre and back: Gent: Step in L, Tap R heel in front, Hop L, tap R toe to side, Hop L, Tap R heel in front, Hop L (2 bars)', 'Gent: Step out R, Tap L heel in front, Hop R, tap L toe to side, Hop R, Tap L heel in front, Hop R (2 bars)', 'The lady dances the same steps starting on her opposite foot.', 'Top ladies cross to home, passing right shoulder to right.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Side - Top - Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret (raised)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' }
      ]
    }]
  },
  'Borlin':
  {
    name: 'Borlin',
    jpCaption: 'ボーリン',
    level: 'basic',
    county: ['Cork'],
    notices: 'この元気のいいポルカセットはコーク州Bantry近くのBorlin Valleyのセット。This lively Polka set from the Borlin Valley, near Bantry Co. Cork. 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/borlin'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Ladies Chain',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=B9V4qDR81kc',
        start: 27
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross handで反時計回りにLead Aroundする', '最後の2小節で、レディーはジェンツの腕の下で時計回りにTurnする', 'Turn させるとき両手はつないだままで行う'], type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', caption: ['すべてのカップルはwaltz holdになる', 'セットの中心に向かって、大きくジャンプまたはheel dropする', 'その後、外側の足、ジェンツは右足、レディーは左足でKickする', '2 bars目でセットの中心から離れ、その後一つ隣の位置へHouseする', 'Pattern:  Jump, KICK, out-2-3; turn-2-3 and turn-2-3'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', caption: ['Leading Couplesは1, 2, 3, Kickのステップで右側へ進み、', '時計回りに90度反転し、1, 2, 3, Kickのステップで後退してoppositeの位置へ行く', 'ジェンツは前身→後退し、レディーは後退→前身する', 'その後、House acrossでHome positionへ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain', caption: ['Leading CouplesのレディーはoppositeのレディーとChainする', 'その後、oppositeのジェントとChainする', 'その後、oppositeのレディーと右肩ですれ違い、元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Two Squares',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=2AoL9IgiBU8',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Adv-Ret & Pass through',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ARb8BFnonDw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Pass through', caption: ['Leading CouplesはパートナーとRight hand in right、右手をつないでAdvance & Retireする', 'Retireするとき、レディーはジェントの前を通ってジェントの左隣へ行き、互いに位置を交換する', 'その後、向かいのパートナーと右肩ですれ違い、セットの内側を向く'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Pass through', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body (jump & kick)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Four Squares',
      rythmn: 'Slide',
      youtube: {
        url: 'https://www.youtube.com/watch?v=C2kWz67rO9s',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Ring Lead Around', caption: 'Leading Gent は左手を opposite のジェントとつなぎ、右手をレディーに回して Lead Around する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House across', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Doubles',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=EdG7bs7mgkU',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Barn dance', caption: ['ジェンツは右手をレディーの腰に回し、レディーは左手をジェンツの肩に乗せた状態でhop-1-2-3, hop-1-2-3のステップで一つ右側の位置へ行く', 'その後、double hold、ジェンツは両手をレディーの腰に回し、レディーは両手をジェンツの肩に置き、Doubleでひとつ隣へ行く', 'この動作を4回繰り返して（2周して）元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Double', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Walk on', caption: 'すべてのレディーは右隣のジェントのところへ行く。ジェンツはその場で待つ', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Barn dance' },
        { bar: 8, subject: 'Everyone', summary: 'Double' }
      ]
    }]
  },
  'Caledonian':
  {
    name: 'Caledonian',
    jpCaption: 'カレドニアン',
    level: 'beginner',
    county: ['Clare'],
    notices: 'このセットはクレア州で最も伝統的なセットで、最も人気のあるバージョンのものを掲載している。 〜"Toss The Feathers", Pat Murphyより抜粋。Tops と Sides が入れ替わるときは Advance & Retire → Home',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/caledo',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/caledonian.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'House',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 37
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', caption: 'Leading Couples は waltz ホールドになり、Advance & Retire を一度行い、House で opposite へ向かう', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Home', caption: 'すべてのカップルは waltz ホールドになり、Advance & Retire を一度行い、その場で Home する', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Home',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 215
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Home', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Home & House',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 347
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Home', caption: 'Leading Couples は waltz ホールドになり、Advance & Retire を一度行い、その場で Home する', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Home', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & House each other', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'repeat' },
        { bar: 32, subject: 'Tops', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Home', type: 'repeat' },
        { bar: 80, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Post-It Note',
      rythmn: 'Jig',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 567
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops & Gents', summary: 'Adv-Ret, Turn across', caption: 'Leading Couples は waltz ホールドになり、Advance & Retire を一度行う。その後、Leading Gents は時計回りに回りながら opposite のレディーのところへ行く', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops & Gents', summary: 'Adv-Ret, Turn back', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'repeat' },
        { bar: 40, subject: 'Tops', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Home', type: 'repeat' },
        { bar: 96, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: '? Mark',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 790
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Top Gents Leading', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Top Gents Leading', summary: 'Adv-Ret, Gents; moves→Left', caption: 'Leading Couples は waltz ホールドになり、Advance & Retire を一度行う。その後、Leading Gents は時計回りに回りながら「？」マークを描くように元いた位置の一つ左隣のカップルのところへ行く', type: 'nested-repeat' },
        { bar: 8, subject: 'Top Gents Leading', summary: 'House w/new Ladies', caption: 'Leading Gents は新しく出会ったレディーと House する', type: 'nested-repeat' },
        { bar: 48, subject: 'Top Gents Leading', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Home', type: 'repeat' },
        { bar: 80, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Body <Short>',
      rythmn: 'Hornpipe',
      description: 'Short version.',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pw1IidMR96c',
        start: 1027
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Changeover <Long>',
      rythmn: 'Hornpipe',
      description: 'Long version.',
      youtube: {
        url: 'https://www.youtube.com/watch?v=eMor3gn3DBo',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Ladies move→1/4R', caption: ['すべてのカップルはwaltz holdで Advance & Retireを一度行う(4 bars)', 'その後、ジェンツはセットの中央に向かって時計回りに半回転する(4 bars)', 'その間、レディーは反時計回りに自分の一つ右側の位置へ移動する', 'それぞれのカップルは向き合いwaltz holdになる'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Camus':
  {
    name: 'Camus',
    jpCaption: 'カムス',
    level: 'advanced',
    county: ['Galway'],
    notices: 'このセットはSeamus Ó Mealóidによって作られ、2015年にWestportで発表された。セットの名前は彼の家があるコネマラ地方CaslaのCamusに由来します。「Camus」という名前は、「cam uisce」または「crooked water」から来ています。これは、Dun ManusからCamus Bayへと狭い海峡を斜めに通って流れ込む潮のことです。This set was composed by Seamus Ó Mealóid and was first presented by Seamus in Westport in 2015. It takes its name from his home in Camus, near Casla in Connemara. The name "Camus" comes from "cam uisce" or "crooked water", a reference to the tides that flow at an angle through the narrow strait at Dun Manus into Camus Bay',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/chamus'
    },
    thumbnail: '',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Clover Chain',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)', caption: ['すべてのカップルはcrossed handになってAdvance & Retireを2回する', 'All couples advance and retire twice holding crossed hands.'] },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', caption: ['最後の2 barsでレディーはジェンツの左腕の下で時計回りにTurnする', 'All couples, still holding crossed hands, lead around.', 'During the last two bars, each lady turns clockwise under the gent\'s left hand.'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Cross & Change Partners', caption: ['Leading Ladiesは真っ直ぐoppositeのレディーと左肩ですれ違い、oppositeのジェントと左腕をつかみ合ってその場で半周する(4 bars)', 'その後、セットの中央でoppositeのレディーと右腕をつかみ合って半周し、再びoppositeのジェントと左手をつないで半周し、crossed handになる(4 bars)', 'ジェンツはセットの内側に入り、左手は体の前で、右手は体の後ろ側でレディーと手を繋ぐ', 'Top ladies cross left shoulder to left and turn left arm in left around the opposite gents (4 bars).', 'They then turn right arm in right around each other in the centre', 'take the opposite gent\'s left hand in left, hand low and turn around him into the lead around position (4 bars).', 'Gents are on the inside, right hand in right at the lady\'s hip and left hand in left raised in front.'], type: 'repeat' },
        { bar: 16, subject: 'Leading Couples', summary: 'Lead across', caption: ['Leading Couplesは一つ右側のカップルに向かって進み、その場でステップする(4 bars)', '同じ動きを繰り返して、oppositeを経由して元の位置まで一周する(12 bars)', 'ホームポジションに戻ったら、ジェンツは左手でレディーを時計回りに2回Turnさせる', 'Top couples lead forward one position to the right inside, then dance on the spot (4 bars).', 'They repeat this movement twice while moving around to the other side position (8 bars),', 'then the lady turns clockwise twice under the gent\'s left hand as they move back to the gent\'s original position (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí) w/new Partner', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' }
      ]
    },
    {
      order: 2,
      summary: 'Wheelbarrow',
      rythmn: 'Reel',
      youtube: null,
      description: 'Leadingは時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side。',
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Corner Chain', caption: ['パートナーと向き合って右腕をつかみ合い、その場で半周してCorner Partnerに向き合う(4 bars)', 'その後、Corner Partnerと左腕つかみ合い、その場で半周する(4 bars)', 'Taking right arm in right, partners dance a half turn around each other to face the person in the other corner.', 'Gents are on the outside facing the lady on their left while ladies are on the inside facing the gent on their right (4 bars).', 'All now take left arm in left with the person facing them in the corner and dance'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Wheelbarrow', caption: ['Leading Couplesはcrossed handになり、Advance & Retireする(4 bars)', 'Leading CouplesはAdvanceする(2 bars)', 'Leading GentはRetireするときLeading Gentは左手を離す(2 bars)', 'その際、Leading Ladyは体を反転してLeading Gentと向き合う', 'その際、opposite LadyはLeading Gentの左手を自分の左手でとる', 'その間、opposite Gentは一人でRetireする', 'Holding crossed hands, top couples advance to the centre and retire (4 bars)', 'then advance again (2 bars) and as first top gent retires, both ladies go forward with him, holding his hands and facing him', 'while second top gent retires alone (2 bars).', 'First top lady holds her partners right hand in right and second top lady holds his left hand in her left.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Change Ladies', caption: ['4人はAdvance & Retireする(4 bars)', 'このとき、ジェンツはセットの中心を向き、レディーはセットの中心に背を向ける', 'Retireするとき、レディーはLeading Gentに向かってTurnしてセットの中央を向く', 'このとき、Leading Gentは両腕を左右のレディーの肩の上に置く', '4人は再びAdvance & Retireする(4 bars)', 'Retireするとき、レディーはAdvanceし、空いている手で向かいのジェントの手をとる', 'Both gents advance to the centre with the ladies reversing to the centre (2 bars)', 'then gents retire to place, ladies going with the first top gent again and turning in towards him to finish with his arms on their shoulders (2 bars).', 'All advance to the centre again (2 bars)', 'then the two ladies give their free hands to second top gent and advance with him as both gents retires to place (2 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Change Ladies Back', caption: ['4人はAdvance & Retireする(4 bars)', 'Retireするとき、レディーはLeadingでないGentに向かってTurnしてセットの中央を向く', 'このとき、Leading Gentは両腕を左右のレディーの肩の上に置く', '4人は再びAdvanceする(2 bars)', 'その後、繋いでいる手を離し、レディーはジェンツの横に並び、ジェンツの肩に手を置く', 'ジェンツは両腕をレディーの腰に回す', 'Both gents advance to the centre with the ladies reversing to the centre (2 bars)', 'then gents retire to place, ladies going with the second top gent and turning in towards him to finish with his arms on their shoulders (2 bars).', 'All advance to the centre again (2 bars), then release all hands and ladies step to the side placing their hands on the gents\' shoulders', 'while the gents take hands around the ladies\' waists.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', caption: ['Leading Ladiesは互いに右手をとってChainし(2 bars)、', 'oppositeのジェントの左手の下をまわり(2 bars)、', 'oppositeのレディーと右肩ですれ違い、ホームポジションへ戻る(4 bars)', 'ジェンツはレディーをTurnさせるときにレディーを追いかけない', 'Top ladies chain with right hands and turn under the opposite gents left hand while dancing around him, then pass right shoulder to right as they dance back to face their partners in place. Each gents turn with the opposite lady, facing her as she dance around him.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 144, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Corner Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' }
      ]
    },
    {
      order: 3,
      summary: 'Pass through',
      rythmn: 'Reel',
      description: 'Leadingは1st Top Lady - 1st Side Lady - 2nd Top Lady - 2nd Side Ladyの順。',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Dance around', caption: ['Leading LadyとoppositeのジェントはAdvance & Retireする(4 bars)', 'その後、右手をとってセットの中央で一周し、ホームポジションへ戻る(4 bars)', 'Leading Ladyはセットの中央を向き、パートナーと近い方の手で手を繋ぐ', 'oppositeのカップルは互いの間に人2人分のスペースを空けるようにして、セットの中央を向く', 'Top lady and opposite gent advance, bow and retire (4 bars)', 'then take right hands low and dance a full turn around each other (4 bars).', 'Top lady now takes her partners right hand in her left facing the centre', 'while opposite couple move apart and face forward into the set.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through', caption: ['Leading CouplesはLeading Coupleを中心にPass throughする', 'oppositeへ着いたら反転する', 'このとき、Leading Coupleは互いに背を向けるようにして反転し、Leadingでないカップルは互いの方を向くようにして反転する', 'Leading CouplesはLeadingでないカップルを中心にPass backする', 'ホームポジションへ戻ったらwaltz holdになり、右側のカップルの方を向く', 'Top couples pass through with fist top couple in the centre.', 'At the other side, first top lady turns clockwise away from her partner to face back on the ouside', 'while first top gent turns anticlockwise to face back on the other side.', 'At the same time, second top couple turn in towards each other taking inside hands and face back towards home.', 'Top couples then pass back to home with the second couple in the centre and take waltz hold, facing the side couples on the right.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Square over & Turn the Lady Home', caption: ['Leading Couplesは右側へ向かって進み、oppositeへ向かって後退する(4 bars)', '同様の動きでホームポジションまで戻る(4 bars)', '最後の2 barsでジェンツはレディーを左手で2回Turnさせる', 'Top couples each advance to face the side couple on their right, then reverse into opposite positions (4 bars).', 'From there, they dance back to home with the ladies in front of their partners', 'each lady turning clockwise twice under the gent\'s left hand (4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 96, subject: '1st Side Lady - 2nd Top Lady - 2nd Side Lady', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' }
      ]
    },
    {
      order: 4,
      summary: 'Ladies move on',
      rythmn: 'Hornpipe',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz)', caption: ['すべてのカップルはwaltz holdになり、Advance & Retireを2回する', 'Retireするときはバタリングする', 'All couples advance and retire twice in waltz hold', 'dancing battering steps as they retire.'], type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Left Hand Star & Move→1/4R', caption: ['すべてのレディーはセットの中心でLeft Hand Starする(4 bars)', 'その後、Right Hand Starで元の位置より一つ右側のジェントのところへ向かう(4 bars)', 'Ladies join left hands in a star in the centre and dance around', 'then join right hands and dance back, moving into the lady\'s position right of their own in the set.'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Right Hand Star', caption: ['すべてのジェンツはセットの中心でRight Hand Starする(4 bars)', 'その後、Left Hand Starで元の位置へ戻る(4 bars)', 'Gents join right hands in a star in the centre and dance around', 'then join left hands and dance back to place.'], type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (waltz)' }
      ]
    }]
  },
  'Camp':
  {
    name: 'Camp',
    jpCaption: 'キャンプ',
    level: 'advanced',
    county: ['Kerry'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/campse'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Christmas',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=algBxZsrRag',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (shoulder)' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Tops Leading', summary: 'Ladies Chain (arm) into Christmas', caption: ['Leading Ladies はセットの中央を進み出て、右腕を組み Full turn する(4 bar)', 'その後、Leading Ladies は opposite のジェントと左腕を組んで半周し、元いた位置の一つ左側のカップルのところへ行く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Swing in three', caption: ['Leading Ladies と Leading でないカップルはそれぞれ Little Christmas する(8 bar)', 'その間、Leading Gent はセットの中央へ進み出て、右腕を組み1と1/2周して opposite へ向かう'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Adv-Ret', caption: ['Leading Gent は一人で、それ以外の6人はそれぞれ列になって Advance & Retire を2回する', '誰とも手は繋がない', 'Leading Gent は最後に Retire するときに、右側のカップルにいる opposite のレディーを連れて帰る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 120, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Ladies Chain & Crossover',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=CgyxZWYuzlc',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under) → shoulder', caption: ['Leading Ladies は右手 - 左手 - 右手 - 左手の順で Chain する(8 bar)', '最後に自分のパートナーと Chain するとき、ジェンツはレディーを追いかけるように回り込み、shoulder hold になる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Ladies; Crossover', caption: ['Leading Couples は shoulder hold で Advance & Retire を1回する(4 bar)', 'Leading Couples は再び Advance し、Leading Ladies は opposite のジェントのところへ行く(4 bar)', 'Leading Gents は Retire しながら opposite のレディーを迎え入れ、waltz hold になる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 72, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret & Ladies; Move on', caption: ['すべてのカップルは円状になって手を繋ぎ、Advance & Retire を1回する(4 bar)', 'その後、再び Advance し(2 bar)、すべてのレディーは左手だけを離し、セットの内側を通るようにして一つ右側のジェントのところへ行く(2 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 3,
      summary: 'Ladies Star & Move on',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5Fqahl9M3nM',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Star & Move on', caption: ['すべてのレディーはセットの中央へ向かって Right hand Star する(2 bar)', 'opposite のジェントと出会ったら左腕を組んで反時計回りに1周する(2 bar)', 'その後、元いた位置から一つ右側のジェントのところへ向かう(4 bar)', 'その際、ジェントはレディーを右手で反時計回りに Turn させ、そのまま waltz hold になる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 4,
      summary: 'Sevens & Threes',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=gsgHH7aCk-k',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Sevens In, Out & Threes across', caption: ['Tops は左側のカップルに、Sides は右側のカップルに向き合い、waltz hold になる', 'すべてのカップルは向き合ったカップルに向かって Sevens In, Sevens Out する(4 bar)', 'その後 1-2-3 のリズムで In, Out し、Double で opposite へ向かう(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Sevens In, Out & Threes back', type: 'repeat' },
        { bar: 40, subject: 'Everyone', summary: '<<Repeat>>', caption: '2回目に Sevens & Threes across するとき、Tops は右側のカップルに、Sides は左側のカップルに向き合う', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Castle':
  {
    name: 'Castle',
    jpCaption: 'キャッスル',
    level: 'basic',
    county: ['Tipperary'],
    notices: 'この人気のあるバージョンセットはティペラリー州のセットで、Cashelセットと呼ばれることもある。 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/castle',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/CASTLE.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Slide',
      description: 'いきなり House！繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Y8BgTuq2PKY',
        start: 45
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through ↑↓', caption: ['Leading Couples は opposite のパートナーと右肩ですれ違う', '反対側まで行ったら時計回りに Turn して再び右肩ですれ違い、元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing Corners (L/R)', caption: 'Leading Couples が Tops のときはジェンツは左側(L)、レディーは右側(R)のパートナーと Swing、Leading Couples が Sides のときはジェンツは右(R)側、レディーは左(L)側のパートナーと Swing する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 144, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Wheel in line',
      rythmn: 'Polka',
      description: 'いきなり House！繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=uYK3mWzUDtM',
        start: 33
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, L; Cross, Swing', caption: 'Leading Couples は右手を繋いで Advance & Retire は一度する。その後、Leading Lady は opposite のジェントのところへ向かい Swing する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead Around (r.h. / cw)', caption: 'Leading Lady は右手を中央で握り合い、ジェンツは右手をレディーの腰に添えて時計回りに Lead Around する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'lines of 3',
      rythmn: 'Polka',
      description: 'いきなり House！繰り返し部分は 1st Tops - 2nd Tops - 1st Sides - 2nd Sides の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=tJB3PxSXp00',
        start: 46
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', caption: ['Leading Ladyはoppositeのレディーと右手、oppositeのパートナーと左腕、再びoppositeのレディーと右手、そして自分のパートナーと左手でChainする', 'oppositeのパートナーとChainするときは肘を掴む', '次にSwingするジェント / レディーは自分のパートナーとChainした後そのまま中央に残る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing & moves→L', caption: 'Leading Gent と opposite Lady は Swing を終えたら、元の位置から一つ左側のカップルの間へ向かう', type: 'repeat' },
        { bar: 8, subject: 'Leading Lady & opposite Gent', summary: 'Adv-Ret', caption: 'Leading Lady と opposite Gent は Advance & Retire を2回する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Three Adv-Ret, moves→R', caption: '一つ前の動きで Advance & Retire しなかったすべてのジェンツとレディーは Advance & Retire を2回する。Leading Gent とその opposite の Lady は Advance & Retire を終えた後、元いた位置（右側）へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 144, subject: '2nd Tops - 1st Sides - 2nd Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'The hop',
      rythmn: 'Hornpipe',
      description: '「Square & Double」と「House & Double」の2バージョンがある。繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IiS__JMEIZU',
        start: 41
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Square & Double, clap & stamp', caption: ['Leading Couples は opposite まで House で向かい、Double で元の位置へ戻る(4 bar)', 'その後、Leading Gent は左肩ですれ違い、opposite のレディーと Clap & Stamp する(4 bar)', 'Hop step-2-3, hop step-2-3, hop step, hop step, hop step, hop step.  Pass-2-3, pass-2-3.  Clap-clap-clap, stamp-STAMP, stamp, stamp.', 'ジェンツは左足から、レディーは右足から stamp する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & Double, clap & stamp', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & Double, clap & stamp', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & Double, clap & stamp', type: 'repeat' },
        { bar: 4, subject: 'Tops', summary: 'Square & Double, Double', type: 'repeat' },
        { bar: '' },
        { bar: 108, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Slide & Change',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=F5s_P9f8pqk',
        start: 57
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (shoulder)', caption: 'すべてのカップルは右側を向いて反時計回りに Lead Around する。ジェンツはレディーの右肩越しに右手を握り、前側で左手を握る。一つ右側の位置へ進んだら dance on the spot する(2 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain, Chase Ladies', caption: 'Ladies Chain で自分のパートナーと出会ったら左手を握ったまま、ジェンツは自分のレディーを追うようにして Lead Around の構えをする', type: 'repeat' },
        { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (shoulder)' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' }
      ]
    },
    {
      order: 6,
      summary: 'Catch the bus',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=2rzK5QGp1z4',
        start: 26
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Catch the bus', caption: 'ジェンツは Lead Around をするように、反時計回りに回る。レディーはジェンツを追いかけるようにして自分の一つ右側のジェントに追いつき、ジェントの左肩に手を置く(2 bar)。ジェンツはレディーの腰に手をあて、元の位置へ戻るまで Lead Around する', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    }]
  },
  'Cavan Reel':
  {
    name: 'Cavan Reel',
    jpCaption: 'キャヴァン・リール',
    level: 'advanced',
    county: [],
    notices: 'Cavan Reel Set はコンペティションでよく踊られるセット。セットの動きそのものは難しくないが、専用のステップをしながら動くのは難しい。ステップには Old Style と Modern Style があり、男女ともにどちらも右足から始める。Modern variation は 2 Figures、Traditional variation は 5 Figures からなるが、Modern variation の Figure 1 は Traditional variation の Figure 1, 2, 4 で構成されており、Modern variation の Figure 2 は Traditional variation の Figure 3, 5 で構成されている。（Traditional Irish Dancing Weekend with Patrick O\'Dea 2017/12/09 より）。',
    referenceSite: {
      // http://setdanceteacher.ie/cavan.htm
      // danceminder: 'https://danceminder.com/dance/show/cavare'
      danceminder: 'https://danceminder.com/dance/show/cavar2'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: '<Modern variation>',
      rythmn: 'Reel',
      description: '3回目の繰り返し部分は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ueD5sd7X6v8',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', caption: 'Top Couples が Advance & Retire を1回した後に(4 bar)、Side Couples も Advance & Retire する(4 bar)。同じ動作を繰り返す(8 bar)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (step)', caption: 'すべてのカップルは Swing を 6 bar したら、手を離してその場で Dance する(2 bar)', type: 'common' },
        { bar: 16, subject: 'Tops', summary: 'Arches (R-in-R)', caption: 'Leading Couples は right hand in right, 右手で手をつないで Advance & Retire を1回する(4 bar)。その後、1st Top Couple がアーチを作り、2nd Top Couple がアーチをくぐる(4 bar)。2nd Top Lady はアーチをくぐるとき反時計回りに2回転 Turn して opposite の位置へ行く。1st Top Couple は 2nd Top Couple をくぐらせた後、右手をつないだまま右肩ですれ違って opposite の位置へ行く。このとき 1st Top Gent は反時計回りに自分のレディーを Turn させる。向かい合うカップル同士が互いに位置を交換したら同じ動作を繰り返して元の位置へ戻る(8 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (step)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', caption: 'Leading Couples のレディーは右手を軽くにぎって Chain し、opposite のジェントのところへ向かう。Leading Gent は opposite のレディーを左手で時計回りに Turn させる。この時レディーはジェントの腕の下を通る。その後、もう一度 opposite のレディーと右肩ですれ違い、元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Tops', summary: 'Wheelbarrow into Bascket', caption: 'Leading Gent は右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。もう一度 Advance した後(6 bar)、Leading Gent は opposite のレディーの左手をとり、レディーの左肩の上で手をつなぎながら、Retire する(8 bar)。このとき 2nd Gent も Retire する。3人と1人は Advance する(10 bar)。このとき、2nd Gent はレディーの空いている方の手をとる。2人のレディーは 2nd Gent の方へ進み(11 bar)、Turn する。2nd Gent は各レディーの肩の上で両手をつなぐ(12 bar)。3人と1人は再び Advance し(13 bar)、2nd Gent は握っていたレディーの手を離す(14 bar)。ジェンツ同士で手をとり、レディーの頭上を通す(15 bar)。レディーは両手をジェンツの肩の上に置いて Basket になる(16 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', caption: '時計回りに Swing し(6 bar)、元の位置へ戻る(2 bar)', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (step)', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: '<Modern variation>',
      rythmn: 'Reel',
      description: '2回目の繰り返し部分は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ueD5sd7X6v8',
        start: 236
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', caption: 'ジェンツは右手、レディーは左手で自分のパートナーと手をつなぐ。このとき手は下げたままにする。Advance し隣の人と手をつなぎ、上にあげる(2 bar)。手を上げたまま Retire し(4 bar)、もう一度 Advance する(6 bar)。パートナーとつないでいない方の手を離し、Retire する(8 bar)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (step)', caption: 'すべてのカップルは Swing を 6 bar したら、その場で Dance する(2 bar)', type: 'common' },
        { bar: 16, subject: 'Tops', summary: 'Train', caption: 'Leading Couples のジェントは右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。もう一度 Advance したとき、レディーはそのままパートナーを連れて opposite へ向かう', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (step)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Do-Si-Do', caption: 'Leading Gent と opposite Lady のレディーは右肩→左肩で Back to back して向き合う(6 bar)。レディーは時計回りに、ジェントは反時計回りに Turn して再び向き合う', type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing (step)', type: 'repeat' },
        { bar: 48, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through', caption: 'Leading Couples はセットの中心に向かい、opposite のパートナーと右肩ですれ違い(2 bar)、反対側まで行ったら時計回りに反転する(2 bar)。再びセットの中心に向かって opposite のパートナーと右肩ですれ違い(2 bar)、元の位置へ戻ったら反転する(2 bar)', type: 'repeat' },
        { bar: 8, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Dance to corner and partner', caption: 'Corner のパートナーと向き合ってその場で Step する(4 bar)。その後、自分のパートナーと向き合い、その場で Step する(4 bar)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (step)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (step)', type: 'common' }
      ]
    },
    // {
    //   order: 1,
    //   summary: '<Traditional variation>',
    //   rythmn: 'Reel',
    //   description: '3回目の繰り返し部分は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
    //   youtube: null,
    //   movements: [
    //     { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
    //     { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: 'すべてのカップルは céilí hold で Swing する', type: 'common' },
    //     { bar: 16, subject: 'Tops', summary: 'Arches (R-in-R)', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
    //     { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
    //     { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
    //     { bar: 16, subject: 'Tops', summary: 'Three & One', caption: 'Leading Gent は右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。もう一度 Advance した後(6 bar)、Leading Gent は opposite のレディーの左手をとり、レディーの左肩の上で手をつなぎながら、Retire する(8 bar)。このとき 2nd Gent もレディーの空いている手とつなぎ、Leading Couple の方に向かって Advance する。レディーは Leading Gent から Leading Gent の opposite のジェントの方へ Turn し、Leading Couple ではない方へ Retire する。(12 bar)。このとき、Leading Gent はその場でステップする。その後、4人はセットの中央で集まり円状になる(14 bar)。ジェンツ同士で手をとり、レディーの頭上を通す(15 bar)。レディーは両手をジェンツの肩の上に置いて Basket になる(16 bar)', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Bascket, Little Christmas', caption: '時計回りに Swing し(6 bar)、元の位置へ戻る(2 bar)', type: 'repeat' },
    //     { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
    //     { bar: '' },
    //     { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
    //     { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
    //   ]
    // },
    // {
    //   order: 2,
    //   summary: '<Traditional variation>',
    //   rythmn: 'Reel',
    //   description: '2回目の繰り返し部分は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
    //   youtube: {
    //     url: 'https://www.youtube.com/watch?v=ueD5sd7X6v8',
    //     start: 236
    //   },
    //   movements: [
    //     { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
    //     { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
    //     { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Crossover', caption: 'Leading Couples のジェントは右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。その後、Leading Couples は反時計回りに opposite へ行って向き合う(4 bar)', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Cross home', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
    //     { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
    //     { bar: 8, subject: '1st Top Gent & opposite Lady', summary: 'Dance around', caption: 'Leading Gent と opposite Lady のレディーは右肩ですれ違い、反時計回りに Turn 、再び右肩ですれ違い、反時計回りに Turn し元の位置へ戻る', type: 'repeat' },
    //     { bar: 8, subject: '2nd Top Gent & opposite Lady', summary: 'Dance around', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
    //     { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Pass through', caption: 'Leading Couples は行きはレディーを内側に、帰りはジェンツを内側にして Pass through する。反対側まで行ったときは時計回りに反転する', type: 'repeat' },
    //     { bar: 8, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
    //     { bar: 8, subject: 'Everyone', summary: 'Dance to corner and partner', caption: 'Corner のパートナーと向き合ってその場で Step する(4 bar)。その後、自分のパートナーと向き合い、その場で Step する(4 bar)' },
    //     { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
    //     { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
    //     { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
    //   ]
    // }
    {
      order: 1,
      summary: '<Traditional variation>',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: 'すべてのカップルは céilí hold で Swing する', type: 'common' },
        { bar: 16, subject: 'Tops', summary: 'Arches (R-in-R)', caption: 'Leading Couples は right hand in right, 右手で手をつないで Advance & Retire を1回する(4 bar)。その後、1st Top Couple がアーチを作り、2nd Top Couple がアーチをくぐる(4 bar)。2nd Top Lady はアーチをくぐるとき反時計回りに2回転 Turn して opposite の位置へ行く。1st Top Couple は 2nd Top Couple をくぐらせた後、右手をつないだまま右肩ですれ違って opposite の位置へ行く。このとき 1st Top Gent は反時計回りに自分のレディーを Turn させる。向かい合うカップル同士が互いに位置を交換したら同じ動作を繰り返して元の位置へ戻る(8 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: '<Traditional variation>',
      rythmn: 'Reel',
      description: 'ステップをしながらHouseをするのは難しいので、Diamond Squareで良いとパトリックは言っていた',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: 'すべてのカップルは céilí hold で Swing する', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', caption: 'Leading Couples のレディーは右手を軽くにぎって Chain し、opposite のジェントのところへ向かう。Leading Gent は opposite のレディーを左手で時計回りに Turn させる。この時レディーはジェントの腕の下を通る。その後、もう一度 opposite のレディーと右肩ですれ違い、元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Diamond right or House inside', caption: 'Leading Couples は Diamond right または House inside する。Diamond right は一つ右側のカップルの方へ Advance し、opposite へ Retire する(4 bar)。その後、同じ動作を繰り返して元の位置へ戻る(4 bar)。戻るときは元いた位置の一つ左側のカップルの方へ Advance する', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: '<Traditional variation>',
      rythmn: 'Reel',
      youtube: null,
      description: '繰り返し部分は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
      movements: [
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: 'すべてのカップルは céilí hold で Swing する', type: 'common' },
        { bar: 8, subject: '1st Top Gent & opposite Lady', summary: 'Singles', caption: 'Leading Gent と opposite Lady のレディーは右肩ですれ違い、時計回りに Turn 、再び右肩ですれ違い、反時計回りに Turn し元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: '1st Top Gent & opposite Lady', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 48, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Tops & Sides', summary: 'Adv-Ret (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: '<Traditional variation>',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 16, subject: 'Tops', summary: 'Wheelbarrow into Bascket', caption: 'Leading Couples のジェンツは右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。もう一度 Advance した後(6 bar)、Leading Gent は opposite のレディーの左手をとり、レディーの左肩の上で手をつなぎながら、Retire する(8 bar)。このとき 2nd Gent も Retire する。3人と1人は Advance する(10 bar)。このとき、2nd Gent はレディーの空いている方の手をとる。2人のレディーは 2nd Gent の方へ進み(11 bar)、Turn する。2nd Gent は各レディーの肩の上で両手をつなぐ(12 bar)。3人と1人は再び Advance し(13 bar)、2nd Gent は握っていたレディーの手を離す(14 bar)。ジェンツ同士で手をとり、レディーの頭上を通す(15 bar)。レディーは両手をジェンツの肩の上に置いて Basket になる(16 bar)', type: 'repeat' }, // , caption: 'Leading Gent は右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。もう一度 Advance した後(6 bar)、Leading Gent は opposite のレディーの左手をとり、レディーの左肩の上で手をつなぎながら、Retire する(8 bar)。このとき 2nd Gent もレディーの空いている手とつなぎ、Leading Couple の方に向かって Advance する。レディーは Leading Gent から Leading Gent の opposite のジェントの方へ Turn し、Leading Couple ではない方へ Retire する。(12 bar)。このとき、Leading Gent はその場でステップする。その後、4人はセットの中央で集まり円状になる(14 bar)。ジェンツ同士で手をとり、レディーの頭上を通す(15 bar)。レディーは両手をジェンツの肩の上に置いて Basket になる(16 bar)'
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', caption: '時計回りに Swing し(6 bar)、元の位置へ戻る(2 bar)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: '<Traditional variation>',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Train', caption: 'Leading Couple は Right hand in right、右手同士で手をつなぎ、Advace & Retire を1回する(4 bar)。Retire するとき、ジェンツは右手をレディーの肩に回す。反時計回りに Lead Around し、opposite に着いたらジェントはレディーを反時計回りに Turn させてセットの中心を向く(4 bar)', type: 'repeat' }, // , caption: 'Leading Couples のジェントは右手をレディーの右肩の上でレディーの右手とつなぎ、Advance & Retire を1回する(4 bar)。その後、Leading Couples は反時計回りに opposite へ行って向き合う(4 bar)'
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Train', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Doubles', caption: 'Leading Couples ジェンツとレディーは opposite のパートナーと右肩ですれ違い、反時計回りに Turn 、再び右肩ですれ違い、反時計回りに Turn し元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Face corner and partner', caption: 'Corner のパートナーと向き合ってその場で Step する(4 bar)。その後、自分のパートナーと向き合い、その場で Step する(4 bar)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (circle)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' }
      ]
    }
    ]
  },
  'Charlestown':
  {
    name: 'Charlestown',
    jpCaption: 'チャールズタウン',
    level: 'advanced',
    notices: 'This set was written by Julia Smith of the Newcastle Irish Set Dancers who dance in the Charlestown suburb of Newcastle in NSW, Australia and is dedicated to these dancers. While this set is composed mainly of traditional elements, newer elements reflect some of the diversity of dancing enjoyed in Australia in the 21st century. First side couple is on the left of first top couple. Swings are in hold. Some sections suit battering steps. このセットは、オーストラリアのニューサウスウェールズ州ニューキャッスルのチャールズタウン地方で踊っているNewcastle Irish Set DancersのJulia SmithによりNewcastle Irish Set Dancersのために書かれた。このセットは伝統的な動きから構成されているが、21世紀のオーストラリアで多様に楽しまれている様子も反映されている。1st Sideは1st Topの左側。Swingはwaltz hold。ときどきバタリングを入れるのも良い。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/charse'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Greet your opposite',
      rythmn: 'Reel',
      description: '"Greet your opposite"のときは"keeping eye contact all the time"',
      youtube: {
        url: 'https://www.youtube.com/watch?v=oWLPaLl4DRM',
        start: 538
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', caption: ['パートナーとcross handsになり、反時計回りにLead Aroundする(8 bars)', 'ジェンツはもとの位置に戻ったらレディーを両手でTurnさせる'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Greet your opposite', caption: ['Leading Couplesはoppositeのパートナーに向かってAdvance & Retireを2回する', '1回目は右肩を近づけ、2回目は左肩を近づける', '相手の瞳を見つめながら'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through & Back to back', caption: ['Leading Couplesはレディーが内側になるようにPass throughでoppositeへ行き、自分のパートナーと向き合う(2 bars)', '左肩→右肩ですれ違うようにしてBack to backし、互いに右手をとる(4 bars)', 'Leading Gentsはレディーを右腕の下で反時計回りにTurnさせて位置を入れ替える(2 bars)', 'Leading Couplesはもとの位置からoppositeに移動したことになる', '最後の2 barsで、Leadingでないカップルはパートナーと向き合って右手をとってその場でステップする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Quarter Chain', caption: ['パートナーと右手をとって、ジェンツは反時計回り、レディーは時計回りにChainする', '右手→左手でChainし、3人目と出会ったら右腕を掴んで半周する(4 bars)', 'ジェンツは時計回り、レディーは反時計回りになる', '左手でChainし、パートナーと出会ったらジェンツは右手でレディーを反時計回りにTurnさせる(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Sqaure',
      rythmn: 'Rising Jig',
      description: '"Up" style, using the skip step throughout',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UV9T2UE0n-0',
        start: 190
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Square', caption: ['Leading Couplesはopen waltz holdになる', 'Leading Couplesは左側のカップルに向かって進み、oppositeへ後退する(4 bars)', '同じ動作を繰り返して元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Sevens in, out & House across', caption: ['Leading Couplesはwaltz holdになり、セットの中央へ向かってskip sevensする', 'その後、House acrossする'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', caption: ['Leading Ladiesはセットの中央でoppositeのレディーと右手をとってChainする(2 bars)', 'その後、ジェンツの左腕の下を反時計回りに通り(2 bars)、oppositeのレディーと右手をとってChainしてパートナーと向き合う(4 bars)', 'ジェンツはレディーをTurnさせるときセットの中央を向く', '最後の2 barsはハイタッチするアレンジあり(?)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', caption: ['Leading Couplesはoppositeの位置でSwingする'], type: 'repeat' },
        { bar: 120, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Circle in',
      rythmn: 'Polka',
      description: 'Circle in, out & Releaseは活き活きとやる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UV9T2UE0n-0',
        start: 360
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Back to back', caption: ['Leading Couplesはoppositeのパートナーと右肩ですれ違い、反時計回りにTurnし(4 bars)、', '後退しながら左肩ですれ違い、反時計回りにTurnする(4 bars)', 'あるいは、Leading Couplesはoppositeのパートナーと右肩→左肩でBack to backする(8 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Circle in, out & Release', caption: ['Leading Couplesはセットの中央で手をつなぐ', 'Polka stepでIn, Outし(2 bars)、', '手を離して時計回りにまわりながら一つ右へ移動する(2 bars)', '同じ動きを繰り返してoppositeへ行く(4 bars)', '一連の動きは活き活きとやる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', caption: ['Leading Couplesはoppositeの位置でSwingする'], type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Body & Stamp',
      rythmn: 'Hornpipe',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UV9T2UE0n-0',
        start: 501
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Body (stamp)', caption: ['すべてのカップルはwaltz holdになる', 'North Kerry SetのようにStamp入りのBodyをする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Ladies & Everyone', summary: 'Ladies Star & Back to back', caption: ['すべてのレディーはセットの中央で3/4 Right hand starをして、もとの位置から一つ右側のジェントのところへ行く(4 bars)', '右肩→左肩でBack to backし、waltz holdになる(4 bars)'], type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: ['レディーがもとの位置にもどるまで繰り返す'] },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Body (stamp)' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Claddagh':
  {
    name: 'Claddagh',
    jpCaption: 'クラダー',
    level: 'basic',
    county: ['Galway'],
    notices: 'ゴールウェイ系のセットは Ladies Chain で opposite と絡むときは”投げ縄”。Leading は反時計回り',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/cladda'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'House & Swing',
      rythmn: 'Reel',
      description: 'Leading は 1st Tops から反時計回りに 1st Side - 2nd Top - 2nd Side の順番',
      youtube: {
        url: 'https://www.youtube.com/watch?v=kn94A4otfAs',
        start: 77
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (cross)', caption: ['すべてのカップルは cross hand で Lead Around & Lead Back する(16 bar)', '6 bar 目に元の位置へ戻ったらジェンツはレディーを Turn させずに方向転換する', '14 bar 目に元の位置へ戻ったら、ジェンツはセットの内側に入りセットの外側を向き、レディーはセットの内側を向く'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Dance (cw)', caption: ['Leading Gent とその opposite の Lady は時計回りに1周する', '各カップルに挨拶しながら一周することもあるそうです'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross)', caption: ['中央で Swing していたジェントとレディーはそれぞれ左手、右手を名残惜しそうに離しつつ、自分のパートナーと cross hand になる', 'Leading Couple とその opposite のカップルは Advance & Retire を2回する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House (cross) & Lead Back', caption: ['Leading Couples は cross hand で House で opposite の位置へ行く(4 bar)', '反対側まで行ったらジェンツは手をレディーの頭上で回す', 'その後、Lead Back で元の位置へ戻る(4 bar)', 'Lead Back を終えるときにお互いをぐいっと引きよせるようにして Swing に移る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', caption: '2nd Leading のときは全員で Swing する' }
      ]
    },
    {
      order: 2,
      summary: 'Wheel & Swing',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=kn94A4otfAs',
        start: 365
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', caption: ['レディーは opposite のジェントと会ったら左手をとって、ジェントの左腕をくぐるようにして時計回りに Turn する(4 bar)', 'このときジェントはレディーを追いかけない', 'レディーは自分のパートナーのところへ戻ったら右手をとってジェントの右腕の下で反時計回りに Turn する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Lead Back', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops Gents', summary: 'Gents; Wheel (R→L)', caption: ['Leading Gents は右手を挙げて時計回りに Star する(4 bar)', 'その後、左手を挙げて反時計回りに Star をして元の位置に戻る(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead Around (acw)', caption: ['Leading Gents は Wheel で重ねた左手を離さずに、自分のパートナーの腰に右手を当てる', 'Leading Ladies は左手をジェントの肩に載せる', 'Leading Couples は反時計回りに Lead Around する(8 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (open), Circle', caption: ['Leading Couplesはopen holdでAdvance & Retireを2回する(8 bar)', 'Leading Gents は右手を自分のパートナーの腰に手をあてる', 'Leading Ladies は左手をジェントの肩に載せる', 'Advance を2回したら Little Christmas の構えになる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas (basket)', caption: 'レディーはジェンツの肩に手をのせて Little Christmas する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Lead Back', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', caption: 'Sides が Leading Couples のときは Tops も一緒に Swing する', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', caption: 'Sides Leading のときは全員で Swing する', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Cross Chain',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=kn94A4otfAs',
        start: 725
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'House & Lead Back' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Wheel (R→L)', caption: ['すべてのレディーは右手 → 左手の順で Wheel する', 'レディーは自分のパートナーところへ帰ってきたら右手を合わせて反時計回りに1回転する'] },
        { bar: 8, subject: 'Gents', summary: 'Gents; Wheel (L→R)', caption: ['すべてのジェンツは左手 → 右手の順で Wheel する', 'ジェンツは自分のパートナーところへ帰ってきたら左手をあげて時計回りにレディーを1回転させる'] },
        { bar: 8, subject: 'Everyone', summary: 'House & Lead Back' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops Leading', summary: 'Cross Chain', caption: ['Leading Lady はセットの中央に進み出て、レディー同士で右手をとり時計回りに1と1/4周し、元いた位置の一つ左側のジェントのところへ向かう(4 bar)', 'その間、Leading Lady の左側にいるジェントは時計回りに Turn しながらレディーを待ち(4 bar)。Leading Lady が来たら Ladies Chain のように投げ縄を回すようにレディーを Turn させる。レディーはジェントの左腕の下をくぐるように反時計回りに一周し、opposite のジェントのところへ向かう(2 bar)', 'Leading Lady は再びセットの中央に向かい、レディー同士右手でハイタッチして、元いた位置の一つ右側のジェントのところへ向かう(2 bar)', 'Leading Gent とその左隣のレディーは向き合って Advance & Retire する(4 bar)。その後、レディーはセットの内側を通るようにしてジェントの隣へ行く(4 bar)。この間、Leading Gent は時計回りに Turn してレディーが自分のところへ来るのを待つ', 'すべての移動が終わったとき、レディーは元いた位置の一つ右側のジェントのところへ移動したことになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/n Partners', type: 'repeat' },
        { bar: 48, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'House & Lead Back' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    },
    {
      order: 4,
      summary: 'Crossover',
      rythmn: 'Jig',
      description: 'Leading は反時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=kn94A4otfAs',
        start: 977
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', caption: ['ジェンツは反時計回りに、レディーは時計回りに Chain する', 'ジェンツは自分のパートナーと出会ったら右手で反時計回りにレディーを回す'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, Crossover', caption: ['Leading Couple の opposite のカップルが手を上げてアーチを作り、Leading Couple のジェントはレディーを時計回りに2回 Turn させながらアーチの下をくぐる', 'アーチを作ったカップルは opposite に着いたら位置を交換する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, Cross home', caption: '戻るときは Leading Couple が手を上げて opposite のカップルを中に通す', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Lead Back', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: '1st Tops から反時計回りに 1st Side - 2nd Top - 2nd Side の順番で繰り返す' },
        { bar: 16, subject: 'Everyone', summary: 'Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    }]
  },
  'Clare Lancers':
  {
    name: 'Clare Lancers',
    jpCaption: 'クレア・ランサーズ',
    level: 'beginner',
    county: ['Clare'],
    notices: 'このセットはクレア州のCrusheen Set Dancersに関連付けられています。ジャンプやバタリングはせず、明るく生き生きと踊りましょう。〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/clarla',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/clarelanc.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=xioqOc-3RmE',
        start: 38
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross handで反時計回りにLead Aroundする', '最後の2小節で、レディーはジェンツの腕の下で時計回りにTurnする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Adv, Swing (L.shoulder, cw)', caption: ['Leading Gent とその opposite の Lady は左肩ですれ違い(2 bar)、時計回りに回転し(2bar)、残りの Swing をする(4 bar)', 'Swing の後は元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square', caption: ['Leading Couples は右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違う(4 bar)', 'その後、再び右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違い、元の位置へ戻る(4 bar)', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing Corners', caption: ['レディは右側、ジェンツは左側を向き、コーナーパートナーとスイングする', 'スイングを終えるときはホームポジションを向いて終わる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', caption: '最後の 2 bar は Double する', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Turn the Ladies',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=q9KtfLrf44Y',
        start: 52
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Turn the Ladies ×4 (r.h.)', caption: ['Leading CoupleはRight hand in right、右手同士をつなぎ、レディーはジェンツの腕の下で時計回りに4回Turnする', 'その際、ジェンツはその場でステップする'], type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Dance into line', caption: ['Leading Couple はお互いに向き合い、元の位置の逆側へ移動する(4 bar)', '移動したら半回転してもう一度向き合い、再びすれ違う', 'その後、1st Top Couple と同じように他のカップルも向かい合うように4人で1列になる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret', caption: ['2列になり、隣合った人と手を繋いでAdvance & Retireする', '最後の 2 bar で Leading Couples はRetireせずに元の位置で留まり、それ以外のカップルはRetireを続ける'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Big Christmas',
      rythmn: 'Reel',
      description: 'このフィガーはカップルの数にかかわりなくできる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=qCMkTN_vTgs',
        start: 67
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Adv-Ret', caption: ['レディーはセットの中央へ向かってAdvance & Retireする'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Adv-Ret', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (waist)', caption: ['すべてのカップルは 6 bar 反時計回りに Lead Around する。6 bar 目で180度方向転換し、今度は時計回りに Lead Around する', '方向転換するとき、ジェンツは時計回り、レディーは反時計回りに Turn する', 'Lead Around するとき、ジェンツは opposite のジェントと空いている方の手を合わせる'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Big Christmas', caption: '時計回りに 8 bar、反時計回りに 8 bar、全員で Christmas する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Lead Around, Christmas',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=BJb34-fKQ9E',
        start: 54
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top Leading', summary: 'Lead Around (cw)', caption: ['Leading Couples は cross hand で Lead Around する', '1st Top(Side) が Leading Couple の時は時計回り。2nd Top(Side) が Leading Couple の時は反時計回りに1周し、元いた位置の一つ左（右）側のカップルに合流する'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Wheel (R→L)', caption: ['1st Top(Side) が Leading Couple の時は右手から、2nd Top(Side) が Leading Couple の時は左手から Star する', 'Star を 4 bar したら、逆方向でも Star する'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Little Christmas', caption: ['Wheelした4人でLittle Christmasする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', caption: ['Little Christmasをしていたカップルと別れて、ホームポジションで自分のパートナーとSwingする'], type: 'repeat' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Chain',
      rythmn: 'Reel',
      description: 'Line up するときは Leading Couple が先頭に、Leading Couple の opposite のカップルが最後尾に並ぶ。間に入るカップルは常に右側に入る。レディーが前、ジェンツは後ろ。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=xJDv1BKUDqA',
        start: 60
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain → Line-up', caption: ['自分のパートナーと向き合い、右手→左手の順番で Chain する', 'ジェンツは反時計回り、レディーは時計回り', 'opposite の位置で自分のパートナーと再開したら Swing し、再び Chain で元の位置へ戻る', '元の位置へ戻ったら Leading Couple を先頭に Line up する', 'Line up するときはレディーが前。ジェンツが後ろ。', '1回目：1st Top - 1st Side - 2nd Side - 2nd Top', '2回目：2nd Top - 2nd Side - 1st Side - 1st Top', '3回目：1st Side - 2nd Top - 1st Top - 2nd Side', '4回目：2nd Side - 1st Top - 2nd Top - 1st Side', '間に入るときは常に右側に入る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide', caption: ['Leading Lady を先頭にライン上になって 1 2, 1 2, 1 2, 1 2 3 のリズムでジェンツは左へ、レディーは右へ Slide する(4 bar)', 'その後、先ほどとは逆方向へ Slide し、隣合う人と手を繋ぐ'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lines Adv-Ret', caption: '隣あう人と手をつないで Advance & Retire を2回する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', caption: ['1回目：1st Top - 1st Side - 2nd Side - 2nd Top', '2回目：2nd Top - 2nd Side - 1st Side - 1st Top', '3回目：1st Side - 2nd Top - 1st Top - 2nd Side', '4回目：2nd Side - 1st Top - 2nd Top - 1st Side', '間に入るときは常に右側に入る'], type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Clare Orange and Green':
  {
    name: 'Clare Orange and Green',
    jpCaption: 'クレア・オレンジ・アンド・グリーン',
    level: 'advanced',
    county: ['Clare'],
    notices: 'このセットは近年Crehan家が復興させたクレア州のセット。This is another Clare Set revived in recent years. Its revival is associated with the Crehan family.〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/claror',
      irishSetDancing: 'http://setdanceteacher.ie/CLAREOG.htm'
    },
    needsSet: true,
    // https://www.youtube.com/watch?v=yQoH4_Wgghk
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 118
      },
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Pass through', caption: ['Leading Couplesはcross hand holdになる', 'Leading CouplesはAdvance & Retireを一回する(4 bars)', 'その後、向かい合うパートナーと右肩ですれ違い、自分のパートナーと左肩ですれ違う'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Pass through', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (underarm)', caption: ['Leading Ladyはセットの中央でoppositeのレディーと右手でChainし、', 'oppositeのジェントと左手でChainし、', 'oppositeのレディーともう一度Chainしてホームポジションへ戻る', 'oppositeのジェントとチェインするとき、レディーはジェントの腕の下でTurnする'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Contrary', caption: ['Leading Coupleとoppositeのカップルはそれぞれ左側のカップルと手を繋ぎサークル状になり、時計回りに歩き(4 bars)', 'Leading Gentは左腕を上げてレディーを反時計回りにTurnさせ、元の位置へ戻る(4 bars)', 'その後、Leading Couplesは左側のカップルとHouse aroundする(8 bars)'], type: 'repeat' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Swing in Three',
      rythmn: 'Rising Jig',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 388
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Back to back', caption: ['パートナーと向き合い、時計回りに回りながら、反時計回りにBack to backする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', caption: ['Leading CoupleはHouse insideする(8 bars)', 'Leading Gentはoppositeのジェントの左隣に自分のレディーをそっと置いて離れる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Lady & opposite Couple', summary: 'Swing in three', caption: ['Leading Gentのoppositeのジェントは3人でSwingする', 'その際、Leading Gentは時計回りに4回まわりながらホームポジションに戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent', summary: 'Adv-Ret', caption: ['Leading GentはAdvanceし、oppositeのレディーに一礼し、Retireする', 'もう一度Leading GentはAdvanceし、自分のパートナーに一礼する', 'Leading Gentはそのままその場に残り、4人でSwing Fourの構えになる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing in four', caption: ['Swing Four または、little Christmasする'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Contrary', type: 'repeat' },
        { bar: 192, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'The Knot',
      rythmn: 'Reel',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 692
      },
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Square', caption: ['ジェンツは外側、レディーは内側でCrossし、自分のパートナーと左肩ですれ違う', 'oppositeの位置へ行ったら振り返る', 'その後、同じ動作を繰り返して元の位置へ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (underarm)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Square & Face out', caption: ['Squareで元の位置へ戻り自分のパートナーとすれ違ったら、', 'Leading Gentsはセットの外側を向き、Leadingでないジェンツは右側のカップルに背を向けるようにして、セットの中央へ進み出て、4人で手を繋ぎサークル状になる', 'ジェンツはサークルの外側、レディーはサークルの内側を向く形になる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'The Knot', caption: ['各サークルは時計回りにまわり(4 bars)、反時計回りにまわる(4 bars)', '最後の2 barsでジェンツは右手を上げてTurnし、セットの内側を向く', 'ジェンツは右腕を上に手をクロスさせた状態になる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Dance in place', caption: ['各サークルの4人はその場でステップする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Contrary', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 56, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Turn the Lady Around',
      rythmn: 'Polka',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 881
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross hand holdになり、Lead Aroundする', 'ホームポジションに戻ったらジェンツはレディーをTurnさせる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies wheel', caption: ['すべてのレディーはセットの中央で時計回りにRight Hand Starする(4 bars)', 'その間、ジェンツはレディーの外側を反時計回りに動く', '全員でTurnし、反対方向に回る', '最後の2barでパートナーと右手をとって半周し、ジェンツはそのままセットの中央へ進み出る'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Step In, Step Out', caption: ['In(2 bars)、Out(2 bars)を4回繰り返す', 'ジェンツは反時計回りに、レディーは時計回りに向かい合って右手をつなぐ', 'このとき、ジェンツはセットの中央へ向かって左手を重ねる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Wheel around', caption: ['ジェンツは左手を重ねたまま、反時計回りに歩いて元の位置まで一周する', 'このときレディーを時計回りに4回Turnさせる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Contrary', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 56, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Gallop',
      rythmn: 'Jig',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 1068
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Gallop', caption: ['Leading CouplesはGallop(Sevens)し、Leadingでないカップルもそれに続く(4 bars)', 'その後、Leading Couplesは後ろ向きにGallop(Sevens)し、Leadingでないカップルもそれに続く(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Double Ladies Chain', caption: ['Leading Ladyはセットの中央でoppositeのレディーと右手でChainし、', 'oppositeのジェントと左手でChainし、', 'oppositeのレディーともう一度Chainしてホームポジションへ戻る', 'oppositeのジェントとチェインするとき、レディーはジェントの腕の下でTurnする', 'Leadingでないレディーは2 bars遅れてChainを始める'], type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Gallop', type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Double Ladies Chain', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Contrary', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 64, subject: 'Sides Ladies Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: ['2回目はSides Leading'] },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 6,
      summary: 'Dance Around',
      rythmn: 'Reel',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=yQoH4_Wgghk',
        start: 1292
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Gents; Dance Around', caption: ['すべてのカップルはwaltz holdになり、In, Backを2回する(4 bars)', 'その後、ジェンツはセットの外側を回るようにして時計回りに2回まわりながら一つ右へ行く', 'その間、レディーはセットの中央へIn, Outし、その場で時計回りに1回まわる'], type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: ['ジェンツが元の位置へ戻るまで3回繰り返す'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Dance Around', caption: ['すべてのカップルはwaltz holdになり、In, Backを2回する(4 bars)', 'その後、レディーはセットの外側を回るようにして反時計回りに2回まわりながら一つ左へ行く', 'その間、ジェンツはセットの中央へIn, Outし、その場で時計回りに1回まわる'], type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: ['レディーが元の位置へ戻るまで3回繰り返す'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Connemara':
  {
    name: 'Connemara',
    jpCaption: 'コネマラ',
    level: 'basic',
    county: ['Galway'],
    notices: 'コネマラで踊られていたものをミース州のRathcairnでメレット一家が再流行させた。〜"Toss The Feathers", Pat Murphyより抜粋。Swing は céilí hold。House は cross hand。ステップは Connemara ステップ。ゴールウェイ系のセットは Ladies Chain で opposite と絡むときは”投げ縄”。Leading は反時計回り',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/connre',
      irishSetDancing: 'http://setdanceteacher.ie/connr.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Ladies Chain',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる。Ladies Chain - Swing の後は最初の Advance & Retire - House - Swing を Tops → Sides の順で繰り返す',
      youtube: {
        url: 'https://www.youtube.com/watch?v=E9xlePekhxA',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (cross)', caption: ['すべてのカップルは cross hand で Lead Around & Lead Back する(8 bar)', '6 bar 目に元の位置へ戻ったらジェンツはレディーを Turn させて方向転換する'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: 'すべてのカップルは céilí hold で Swing する', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross)', caption: 'Leading Couples は cross hand で Advance & Retire を2回する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House inside (cross)', caption: 'Leading Couples は cross hand で House する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', caption: ['Ladies Chain のとき、Leading Gent は opposite のレディーを左手で時計回りに回しながら自分も反時計回りに Turn する', 'その後、時計回りに Turn し、自分のパートナーと向き合う', 'レディーは opposite と Chain するとき、ジェントの腕の下を通る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House inside (cross)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: 'Advance & Retire - House - Swing を繰り返す。Sides が最後に Swing をするときは Tops も含めて全員で Swing する' }
      ]
    },
    {
      order: 2,
      summary: 'Back to back',
      rythmn: 'Reel',
      description: 'Leading Gent は反時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=bXSHp2GmXVc',
        start: 40
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Back to back (cw)', caption: 'Leading Gent とその opposite のレディーは右肩ですれ違い、バックで左肩ですれ違う。その後、時計回りに Turn して向き合う', type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House inside (cross)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 120, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: 'Leading Couple が 2nd Side で最後に Swing をするときは Tops も含めて全員で Swing する' }
      ]
    },
    {
      order: 3,
      summary: 'Swing',
      rythmn: 'Reel',
      description: 'Leading は反時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5-T870LmA28',
        start: 39
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: '1st Top', summary: 'Adv-Ret & Turn', caption: 'Advance - Retire - Advance を行い、最後の 4 bar は自分のパートナーとは逆向きに1回転して向き合う', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: 'Leading Couple が 2nd Side で最後に Swing をするときは Tops も含めて全員で Swing する' }
      ]
    },
    {
      order: 4,
      summary: 'Magie in the woods',
      rythmn: 'Polka',
      description: '自分のパートナーと出会うまで繰り返す',
      youtube: {
        url: 'https://www.youtube.com/watch?v=MjWuNDaLeGQ',
        start: 27
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone & all Ladies', summary: 'Circle, Adv-Ret, Ladies; move', caption: ['Circle Advance & Retire を一度行い、その後レディーは自分の一つ右側のジェンツの下へ移動する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home to right', caption: ['Home twice しながら自分たちの一つ右側のカップルの位置へ移動する', 'じわじわ右に移動するタイプと一度に動くタイプなど流派あり'], type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing or Big Christmas' }
      ]
    }]
  },
  'Corofin Plain':
  {
    name: 'Corofin Plain',
    jpCaption: 'コロフィン・プレーン',
    level: 'basic',
    county: ['Clare'],
    notices: 'このバージョンのプレイン・セットはクレア州のCorofin地方のもの。 〜"Toss The Feathers", Pat Murphyより抜粋。Set & Swing のときはみつめて clockwise',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/corfpl',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/COROFIN.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Crossover',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=wGPSJPZuVkA',
        start: 36
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: 'すべてのカップルは cross hand で反時計回りに Lead Around する。元の位置へ戻ったらジェンツは右手でレディーを Turn させる', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', caption: ['すべてのカップルは互いに見つめながら時計回りに Full Turn する(4 bar)', 'その後、Swing する(4 bar)'], type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Crossover & Back', caption: ['Leading Ladiesは右肩ですれ違いoppositeの位置へ行く(2 bar)', 'その後、Leading Gentsは右肩ですれ違いoppositeの位置へ行く(2 bar)', '反対側へ行ったらパートナーの側を向くようにして反転する', '同じ動作を繰り返して元の位置へ戻る(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', caption: ['Leading Ladiesはoppositeのレディーと右手でChainし、', 'oppositeのジェントと左腕でChainし、', 'oppositeのレディーと右手でChainし、', 'パートナーと向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Set & Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Crossover & Back', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Adv-Ret, Cross',
      rythmn: 'Jig',
      description: '繰り返し部分は Leading Couples が変わらず、常に Tops から Advance & Retire, Cross を始める。 ',
      youtube: {
        url: 'https://www.youtube.com/watch?v=CNv2Dk3kK1M',
        start: 35
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Cross', caption: 'Tops は右手をつないで Advance & Retire を一度行い(4 bar)、ジェンツはレディーを時計回りに2回回しながら opposite へ向かう(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Cross', type: 'repeat' },
        { bar: 8, subject: 'Sides', summary: 'Adv-Ret & Cross', type: 'repeat' },
        { bar: 8, subject: 'Sides', summary: 'Adv-Ret & Cross', type: 'repeat' },
        { bar: 32, subject: 'Tops Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: '繰り返すときも Tops → Sides の順で行う' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'The Line',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=uj0Vb79q_0s',
        start: 47
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Set & Swing', caption: ['Leading Gentとそのopposite Ladyは中央で時計回りに半周し(4 bar)、Swing する(4 bar)', 'Swing を終えるときは opposite の位置で終えるようにする'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Line & Move to Opps.', caption: ['Leading Gentとopposite Ladyはwaltz holdで繋いだ手を離さず（それぞれ左手、右手で手をつなぎ）、時計回りに周り、自分のパートナーへ近づき、空いている手で自分のパートナーと手を繋ぐ(2 bar)', '反時計回りに opposite へ向かう(6 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Adv-Ret', caption: ['Leading Gentとopposite LadyはAdvance & Retireを2回する', 'Advance & Retireをする前に自分のパートナーに会釈する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz), Cross home', caption: ['Leading Couplesは自分のパートナーとwaltz holdになる', 'Advance & Retireを一度行い(4 bar)、House acrossして元の位置へ戻る(4 bar)'], type: 'repeat' },
        { bar: '' },
        { bar: 32, subject: '2nd Top Gent & 1st Top Lady', summary: '<<Repeat>>' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Little Christmas',
      rythmn: 'Jig',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Her4h_SbSyM',
        start: 57
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Set & Swing', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 16, subject: 'Tops', summary: 'Three & One ', caption: ['Leading CouplesはThree & Oneする', 'レディーは隣のジェントとは手を繋ぐが、向かい合っているジェントとは手を繋がない', 'ジェントは一人でいるときは一度Retireした後、Advanceしない'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 48, subject: '2nd Top Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 96, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Ladies chain',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=q3qCra2_R7s',
        start: 58
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz) & Home', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz) & House', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz) & Home', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz) & House', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Set & Swing', type: 'repeat' },
        { bar: 32, subject: 'Tops', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: 88, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Mixer',
      rythmn: 'Polka',
      description: '自分のパートナーと出会うまで繰り返す',
      youtube: {
        url: 'https://www.youtube.com/watch?v=N_6SfggFxWA',
        start: 44
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret, Ladies; moves→R', caption: '円状になって Advance & Retire する。レディーは2度目の Retire のときに一つ右隣のジェントのところへ行く', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new Partner', caption: 'レディーは右隣のジェンツのところ行って Swing する', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 120, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Derradda':
  {
    name: 'Derradda',
    jpCaption: 'デラーダ',
    level: 'advanced',
    county: ['Mayo'],
    notices: 'セット名の由来はメイヨー州のデラダ地方。This popular Mayo set gets its name from Derradda, in County Mayo.',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/derrad'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Diamond',
      rythmn: 'Jig',
      description: '1st Sideは1st Topの左側。Swingはcéilí hold。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=O23NcRAYEwo',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Left (crossed)', caption: ['Leading Couplesは左側のカップルに向かって進み、元の位置からoppositeの方へ後退する(4 bars)', '同じ動きを繰り返して元の位置へ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (arm)', caption: ['Leading Ladiesはoppositeのレディーと右腕でChainする(2 bars)', 'その後、oppositeのジェントと左腕でChainし(2 bars)', 'oppositeのレディーと右肩ですれ違って元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí) & Dance in place', caption: ['Leading CouplesはCeili holdでSwingする', 'その間、Leadingでないカップルはその場でステップする'], type: 'repeat' },
        { bar: 32, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing (céilí)', caption: ['Leading Gentとoppositeのレディーはセットの中央でSwingする(6 bars)', '最後の2 barsで元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Left (crossed)', type: 'repeat' },
        { bar: 8, subject: 'Leading Lady & opposite Gent', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Left (crossed)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (arm)', caption: ['Leading LadiesはジェンツとChainしたあとそのままジェンツの左隣へ移動し、セットに向き合いSwing Fourの構えになる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing Four (bascket?)', caption: ['Leading Couplesはセットの中央でSwing Fourし(6 bars)、元の位置へ戻る(2 bars)', 'その間、Leadingでないカップルはその場でステップする'], type: 'repeat' },
        { bar: 48, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' }
      ]
    },
    {
      order: 2,
      summary: 'Bus stop',
      rythmn: 'Polka',
      description: 'Swingはwaltz hold。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Sld7c7eFrXg',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Short Sevens', caption: ['すべてのカップルはwaltz holdになる', 'セットの中心に向かってSevens In, セットの外側に向かってSevens Outを2回する', '体重は常に先に出す足にかける'], type: 'common' },
        { bar: 8, subject: 'Ladies', summary: 'Bus stop', caption: ['すべてのレディーはセットの中央で時計回りに1周するように歩く', 'ジェンツの横を通り過ぎるときはお辞儀する'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Sevens across', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Sevens across', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (arm)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz) & In, Out', caption: ['Leading Couplesはその場でSwingする', 'その間、Leadingでないカップルはwaltz holdでIn, Outを4回繰り返す'], type: 'repeat' },
        { bar: 48, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Short Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'House halfway' },
        { bar: 8, subject: 'Everyone', summary: 'Short Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'House halfway' },
        { bar: 8, subject: 'Everyone', summary: 'Short Sevens', type: 'common' },
        { bar: 8, subject: 'Ladies', summary: 'Bus stop', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Wheel',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=g1aPrh3WJYU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Ladies', summary: 'Star (R→L) & Move to Right', caption: ['すべてのレディーは右手をあげてRight Hand Starする(4 bars)', 'その後、左手をあげてLeft Hand Starをしながら、パートナーを通り過ぎ、一つ右隣のジェントのところへ後ろから回り込む(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Star (R→L)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (shoulder)', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' }
      ]
    }]
  },
  'Fermanagh Quadrilles':
  {
    name: 'Fermanagh Quadrilles',
    jpCaption: 'ファーマナ・カドリールズ',
    level: 'advanced',
    county: ['Fermanagh'],
    notices: 'このセットはファーマナ州のCashel | Belcoo地域でConny Ryanにより記録された。この素晴らしいカドリール・セットの復興にはEamonn & Theresa McKeaneyが厚く貢献している。すべてのSwingはcéilí hold。This Set was recorded by Connie Ryan in the Cashel | Belcoo are of Fermanagh. Eamonn and Theresa McKeaney were central to the revival of this lovely quardrille set. All swing are in céilí hold. 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/fermqu',
      irishSetDancing: 'http://setdanceteacher.ie/FERMQUAD.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Crossover',
      rythmn: 'Reel',
      description: 'Sides が最後に Swing をするときは Tops も含めて全員で Swing する',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rAPf6Bdqm7M',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross handで反時計回りにLead Aroundする', '最後の2小節で、レディーはジェンツの両腕の下で時計回りにTurnする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', caption: ['すべてのカップルは céilí hold で Swing する'], type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (R-in-R)', caption: ['Leading CouplesはRight hand in right、右手同士をつないでAdvance & Retireを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Crossover', caption: ['Leading Ladiesは右肩ですれ違い、oppositeへ行く(2 bars)', 'その後、Leading Gentsも右肩ですれ違い、oppositeへ行く(2 bars)', '同じ動作を繰り返して元の位置へ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', caption: ['Leading Ladiesはセットの中央でoppositeのレディーと右手でChainし(2 bars)', 'oppositeのジェンツと左腕でChainする(2 bars)', 'このときレディーは時計回りにTurnしながら、ジェンツの後ろを反時計回りにまわるように動く(2 bars)', 'ジェンツはTurnしない', 'Leading Ladiesは再びセットの中央でoppositeのレディーと右手でChainする(2 bars)', 'レディーがホームポジションへ戻ってきたら、ジェンツは左腕でレディーを時計回りにTurnさせる(2 bars)', 'このときもジェンツはTurnしない', 'レディーはジェントの後ろを通り元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House around (cross)', caption: ['Leading CouplesはConnemara SetのHouseのように、crossed handでHouse aroundする'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: ['Sides が最後に Swing をするときは Tops も含めて全員で Swing する'] }
      ]
    },
    {
      order: 2,
      summary: 'In, Out, Lead across',
      rythmn: 'Jig',
      description: 'JigのリズムでIn, Outが楽しい',
      youtube: {
        url: 'https://www.youtube.com/watch?v=tyImR6DtDXU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (R-in-R) & In, Out', caption: ['Leading CouplesはAdvance & Retireをする(4 bars)', 'このときジェンツはバタリングする', 'その後、パートナーと向き合い、セットの内に向かってIn, セットの外に向かってOutを2回繰り返す(4 bars)'], type: 'repeat' },
        { bar: 4, subject: 'Leading Couples', summary: 'Lead across (shoulder)', caption: ['Leading Gentsは右手でレディーを反時計回りにまわし、レディーの右肩に右腕を置く', 'その後、Leading Couplesは反時計回りにLead acrossする、レディーは時計回りにTurnしてセットの内を向く'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (R-in-R) & In, Out', type: 'repeat' },
        { bar: 4, subject: 'Leading Couples', summary: 'Lead back (shoulder)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House around (cross)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Flirt with opposite',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hUFppHgUjXw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Dance across, turn, dance back', caption: ['Leading Gentとopposite Ladyは右肩ですれ違い、時計回りにTurnする(4 bars)', 'その後、再び右肩ですれ違い、時計回りにTurnしてセットの中央に近づく(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing (céilí)', caption: ['Leading Gentとopposite Ladyはセットの中央でSwingする', 'Swingを終えるとき、自分のパートナーに向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Link Arms', caption: ['Leading Gentとopposite Ladyは互いに左腕をとって1周する(4 bars)', 'その後、右腕をとって1周して自分のパートナーに向き合う(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', caption: ['Leading Gentとopposite Ladyは自分のパートナーのところへ戻る', 'Leading CouplesはSwingする'], type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Swing in Four',
      rythmn: 'Jig',
      description: 'Leading は時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=0NrKtOK9RgU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'Swing & Dance over', caption: ['Leading CoupleはSwingする(6 bars)', 'oppositeのカップルはその場でDanceする', 'このとき、oppositeのジェントはレディーの右手をとり、レディーはセットの外、ジェントはセットの内を向く', '最後の2 barsでoppositeのカップルはLeading Coupleに近づき、Leading Ladyの左手をとる', 'Leading Ladyはopposite Gentに向き合う'], type: 'repeat' },
        { bar: 8, subject: 'opposite Gent & two Ladies', summary: 'Retire, Advance & Turn', caption: ['Leading Gent以外の3人はoppositeジェントのホームポジションに戻る(2 bars)', 'ジェンツは両腕を回してレディーを引きよせ、両腕をレディーの肩に置く(2 bars)', '4人はセットの中央へ向かってAdvanceする(2 bars)', 'レディーはLeading Gentの手をとってTurnし、Swing in Fourの形になる(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing in Four', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Mixer',
      rythmn: 'Jig',
      description: 'Big Christmasでは、1st Top Gentと1st Side Gentは手のひらを上向きに、2nd Top Gentと2nd Side Gentは手のひらを下向きにする',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5TEaeOGbETM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'House (waltz)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Ladies; Moves right', caption: ['円状になって手をつなぎ、Advance - Retire - Advanceする(6 bars)', '最後の 2 barでレディーはセットの内側を通って一つ右のジェンツのところへ行く(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (waltz) w/new Partner', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Gents & Ladies', summary: 'Adv-Ret & take hands', caption: ['4人のジェンツはセットの中央へ向かってAdvanceする(2 bars)', 'ジェンツは腕を手首のところで交差させ、oppositeのジェントと手をつなぐ(2 bars)', 'このとき、1st Top Gentと1st Side Gentは手のひらを上向きに、2nd Top Gentと2nd Side Gentは手のひらを下向きにする', 'その後、4人のレディーはAdvanceし、自分のパートナーとCorner Partnerの腕にしがみつく(4 bars)'] },
        { bar: 8, subject: 'Everyone', summary: 'Big Chirstmas', caption: ['Swing in eightで2周する'] }
      ]
    }]
  },
  'Flight Of The Earls | Leuven':
  {
    name: 'Flight Of The Earls | Leuven',
    jpCaption: 'フライト・オブ・ジ・アールズ | ルーヴェン',
    level: 'advanced',
    notices: 'The Flight of the Earls set is also known as “The Leuven Set” and is considered as the ‘local’ set in Belgium for set dancers in Brussels and Leuven, given the historical links between the Flight of the Earls and their arrival in Leuven, and the founding of the Irish College that still exists in Leuven to this day under the name of ‘The Leuven Institute for Ireland in Europe’. The set was created by Jim Keenan from Armagh who lived and worked in Belgium and was part of the Irish set dancers in Belgium until going to live in the USA. It was launched in Belgium at a ceili weekend in Leuven in 2006, and it was launched in Ireland, at a festival in Killibegs in 2007, given the link between the Earls leaving from Donegal in 1607 and their arrival in Leuven. Pat Murphy was present at the launch in Killibegs and included the set in his fourth Set dancing book, Apples in Winter.',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/flearl'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Battle',
      description: '1st FigureはO\' NeillとO\' Donnellsの戦いの激しさを描いています。The first figure of the set depicts the furor of many battles of the O\' Neill and O\' Donnells. The story of the flight begins with Hugh O\'Neill, Earl of Tyrone, who brought together the ruling families of Ulster to start a rebellion in 1594. In 1598 at the Yellow Ford - a hundred miles north of Dublin and close to Drumcree, O\'Neill, aided by Spain, inflicted the greatest defeat the English ever suffered at the hands of the Irish. Then in 1601 he marched to the southern port of Kinsale to join an invading Spanish army, and the Irish were routed in unfamiliar country. 〜 by DanceMinder',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=iBxz4YDiWQo',
        start: 29
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)' },
        { bar: 16, subject: 'Everyone', summary: 'Gents; Wheel & Swing In Four, Ladies; Chain', caption: ['ジェンツはRight Hand Starする(6 bars)、その後セットの中央を向く(2 bars)', 'ジェンツはoppositeのジェントと手を結びSwingし(6 bars)、もとの位置へ戻る(2 bars)', 'その間、Tops Ladiesは時計回り、Side Ladiesは反時計回りに2 bars Chain, 2 bars stepを繰り返して1周する', 'Gents join right hands in the center (top gent with top gent and side gent with side gent), wheel for six bars, then dance two bars to face the center of the set.(8) The gents then join left and right hands in the center (top gent with top gent and side gent with side gent) swing for six bars then dance (retire) two bars into their home position. (8) The ladies chain around the set, top ladies clockwise (left) side ladies counterclockwise. Chain right to right, to move to the next position, dance two bars in place (4). Then chain left to left and dance two bars in the opposite position (4). Continue the chain until dancing two bars in home position (8).'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)', caption: ['パートナーと右手をとり、左手をパートナーの右肘にあててSwingする', 'swing in old ceili hold. (Right hand to right and hold partner’s right elbow in left hand)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (crossed)', caption: ['Topsは左側、Sidesは右側のカップルとcrossed handでHouseする(6 bars)', 'その後、Bascketになる', 'Holding crossed hands, top couples and side couple on their left house around each, house for six bars, then dance two bars to form a basket/Christmas'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing In Four', caption: ['ジェンツは向かいのジェントとcrossed handになり、レディーは両脇のジェントの腕に手をかけ、Swing Fourする(6 bars)', 'その後もとの位置へもどる(2 bars)', 'Top couples swing in four with the couple to their left. The gents join left and right hands crossed in the center. The ladies grasp the gents arms by bringing their hands under and up inside of the gents arms. The ladies are holding their partner’s right arm with their left hand and the opposite gents left arm with their right hand. (swing for six bars and retire to place in two bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Pass Through And Return', caption: ['Leading Couplesとその左側のカップルはライン状になる', 'Leading Couplesは左側にいたカップルと向き合い、レディーを内側にしてPass through & Pass backする', 'Top couples and couple to their left pass through with the ladies on the inside, (at the start of this movement, top couples and side couple on their right form a line) after passing through the partners face each other and pass left pass left to left into the opposite position. Then repeat the movement back to home positions.'], type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Gents; Wheel & Swing In Four, Ladies; Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'House (crossed)' }
      ]
    },
    {
      order: 2,
      summary: 'The journey',
      rythmn: 'Reel',
      description: '2nd Figureはドニゴールからルーヴェンへの旅を描いています。The second figure depicts the journey from Donegal to Louvain. James I restored the Earldom of Tyrone to O\'Neill and made O\'Donnell Earl of Tyrconnell, but without any real power the Earls found it impossible to reconcile themselves to the new order. So, on the 14th September 1607, they gave up the struggle and left Ireland for Spain where they hoped to muster support and make a quick return to liberated Ireland. This departure from the shores of Lough Swilly at Rathmullan became known as the Flight of the Earls. They proceeded by sea intending to go to Spain. They were at sea for thirteen days with continuous stormy weather. The voyage ended not in Spain. but in Croisic in Brittany. From Brittany the journey took them to Leuven/Louvain then part of the Spanish lowlands (Flanders). 〜 by DanceMinder',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Zy1CDytgZpc',
        start: 25
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (crossed)', caption: ['Lead Backするとき、レディーを回さない'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)' },
        { bar: 16, subject: 'Everyone', summary: 'Chain & Dance at home', caption: ['12 bars Chainする', 'もとの位置へ戻ったら 4 bars Homeする', 'All face partner, take right hand to right, then chain left to left with the next dancer and continue (Ladies clockwise and gents counter-clockwise) until back in home position (12). All dance at home (in waltz hold) (4).'] },
        { bar: 8, subject: 'Everyone', summary: 'Diamond right', caption: ['すべてのカップルはwaltz holdになりDiamond Rightする', '2 bars歩いたらピボットする', 'All dance sevens into the position on their right, gents facing out of the set. pivot, so that the gents are now facing into the set. Dance sevens to the next (opposite) position pivot, so that the gents now face out of the set. Repeat these movements until back in home position.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Right Hand Star (3/4), Gents; Left Hand Star', caption: ['すべてのレディーはRight Hand Starし、もとの位置のひとつ右のジェントのところへ行く(4 bars)', 'その間ジェンツはその場でステップする', 'すべてのジェンツはLeft Hand Starし、もとの位置へ戻る(4 bars)', 'その間レディーはその場でステップする', 'All the ladies join right hands in the center, wheel/star and dance three fourths of the way around the set to the position to the right of their home position. Gents dance in place.', 'All the gents join left hands in the center, wheel/star to their home position. Ladies dance in place.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (crossed)' }
      ]
    },
    {
      order: 3,
      summary: 'Louvain/leuven',
      description: '3rd Figureはルーヴェンで過ごしたときが描かれています。The third figure captures the time spent in Louvain/Leuven. On Friday, the ninth of November the earls arrived in Louvain/Leuven. The time spent here was one of celebration. 〜 by DanceMinder',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ErD5zsARKow',
        start: 25
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Lead across (crossed)', caption: ['Topsはcrossed handで反時計回りにLead Acrossする(2 bars)', 'その間、SidesはHomeする', '同じ動作を繰り返す(4 bars)', 'Holding crossed hands, top couples exchange places while sides dance in place', 'Holding crossed hands, side couples exchange places while tops dance in place'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Advane & Retire (crossed)', caption: ['Topsはcrossed handでAdvance & Retireする(2 bars)', 'その間、SidesはHomeする', '同じ動作を繰り返す(4 bars)', 'Holding crossed hands, top couples advance and retire while sides dance in place', 'Holding crossed hands, side couples advance and retire while tops dance in place'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Tops; House, Sides; Home', caption: ['Topsはcrossed handでHouseする', 'その間、SidesはHomeする', 'Holding crossed hands, top couples house around each other while side couples dance at home.'], type: 'repeat' },
        { bar: 8, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Tops; Ladies Chain (under), Sides; Home', caption: ['TopsはLadies Chainする', 'その間、SidesはHomeする', 'Top ladies chain, with hands held low, then give left hand to the opposite gent, hands held low, dance around the gent (the gent turns with the lady). Repeat the movements back to place. Holding crossed hands, side couples dance at home'], type: 'repeat' },
        { bar: 8, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House (crossed)' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'House (crossed)' }
      ]
    },
    {
      order: 4,
      summary: 'The diaspora',
      description: '4th Figureはルーヴェンからイタリアへの旅を描くと同時に、何世紀にもわたって世界中に散らばった数百万人のアイルランド人を象徴しています。The fourth figure depicts the journey from Louvain to Italy and is symbolic of the millions of Irish who left Ireland in the centuries to follow, scattered around the world.  On Thursday, the twenty-eighth of February, 1608, the  princes(earls) with their retinue, set out for Italy. They left two of O\'Neill\'s sons, Sean and Brian, the Baron, the Earl of Tyrconnell\'s son, Aodh, the son of Cathbharr, O\'Coinne, Sean O Hagain, and others of their nobles and followers in Louvain. (Most who traveled to Italy died of fever in August of 1608). 〜 by DanceMinder',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=tC4A7hYbNAA',
        start: 24
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Sevnes & Dance at Home', caption: ['すべてのカップルはwaltz holdになり、Sevens in, Sevens outする(4 bars)', 'その後、Homeする(4 bars)', 'All dance sevens into and out of the set in waltz hold (4) Then dance at home for four bars'] },
        { bar: 8, subject: 'Everyone', summary: 'Sevnes & Dance To Position On The Right', caption: ['すべてのカップルはwaltz holdになり、Sevens in, Sevens outする(4 bars)', 'その後、Homeしながら一つ右へ移動する(4 bars)', 'All dance sevens into and out of the set in waltz hold (4) Then dance at the next position in four bars (4)'], type: 'nested-repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'High Gates And Change Partners', caption: ['Leading CouplesはLabasheeda SetのHigh Gateをする', 'レディーは最後のゲートのときに位置を入れ替える', 'Top couples hold inside hand. (a)Top gents give left hand to the lady on the left and make an arch. Top lady goes under the arch followed by the gent. (b)The top couples then make an arch for the side lady to pass under followed by the gent. (c) The top gent and side lady again make an arch for the top lady to pass under and dance into the side lady’s home position while the side lady dances clockwise into the top lady’s position.'], type: 'repeat' },
        { bar: 120, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', caption: ['Except at 4, where the sides, tops and sides alternate dancing the movement.'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Sevnes & Dance at Home' },
        { bar: 8, subject: 'Everyone', summary: 'House (waltz)' }
      ]
    }]
  },
  'Gillen':
  {
    name: 'Gillen',
    jpCaption: 'ギレン',
    level: 'beginner',
    county: ['Offaly'],
    notices: 'このセットはFerbaneのGillen Set Dancersによってまとめられたもの。 〜"Toss The Feathers", Pat Murphyより抜粋。HouseもHomeもなく、パートナーとのwaltz holdもない。全曲Reelで"Step it out"の動きが多いのでセットダンスに慣れるのに良い。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/gillen'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=L8vhMLYpXCM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through', caption: ['Leading Coupleは左右に分かれて、Leading Coupleのoppositeが中央に寄ってPass throughする(4 bar)', '反対側へ行ったらパートナーのいる方とは逆向きに反転する', 'その後、Leading Coupleが中央に寄り、Leading Coupleのoppositeのカップルは左右に分かれてPass throughする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Tap it out', caption: ['パートナーと向き合い、右手同士をとってその場でステップする'], type: 'repeat' },
        { bar: 24, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Tap it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Ladies Chain',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=iO_7Trd-cfg',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', caption: ['レディーはセットの中央でoppositeのレディーと右手でChainし、', 'oppositeのジェントと左手でChainし、', 'セットの中央で再びoppositeのレディーと右手でChainし、', '自分のパートナーと左手でChainして元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Tap it out', type: 'repeat' },
        { bar: 24, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Tap it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Ladies Chain & Lead Around',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=4XUv2DEyq1U',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso) & Lead Around', caption: ['レディーはセットの中央でoppositeのレディーと右手でChainし、oppositeのジェント左手の下でTurnする(4 bar)', 'このときジェンツはセットの中央を向いて、その場に留まる', 'その後、ジェンツは時計回りに少しTurnし、oppositeのレディーとshoulder holdになる', 'ジェンツはレディーの右肩越しに右手を握り、前側で左手を握り、oppositeへ向かってLead Aroundする', '元の位置へ戻ってきたらジェンツは右手をレディーの頭上で回し、互いに右手をとる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Tap it out', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing (Ceili)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain & Lead Back', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Tap it out', type: 'repeat' },
        { bar: 48, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Tap it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Social figure',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=DcUkvJDzca4&t=3s',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', caption: ['すべてのカップルは右側を向いて反時計回りに Lead Around する', 'ジェンツはレディーの右肩越しに右手を握り、前側で左手を握る', '元の位置へ戻ってきたらジェンツは右手をレディーの頭上で回し、互いに右手をとる'] },
        { bar: 8, subject: 'Everyone', summary: 'Tap it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Dance right, Lead Around', caption: ['レディーは右隣のジェントに向かって右手を出す', 'ジェントは反時計回りにTurnし、レディーと向き合う', 'レディーはジェントの腕の下で時計回りにTurnするようにして、ジェントの隣へ行く', 'その後、Lead Aroundする'], type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Tap it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (Ceili)', type: 'common' }
      ]
    }]
  },
  'Inis Oirr':
  {
    name: 'Inis Oirr',
    jpCaption: 'イニシア',
    level: 'advanced',
    county: ['Galway'],
    notices: '"Step it out"のとき、伝統的には"doubled reel step"を用いる。doubled reel stepはコネマラ・ステップに近いが、ヒールではなく足の先の方でシャッフルする。今日ではダンサーは好きなステップを用いている。',
    referenceSite: {
      'irishSetDancing': 'http://setdanceteacher.ie/INISOIRR.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Crossover',
      rythmn: 'Reel',
      description: 'ハーフ・セットのフィガー',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5J0XuTEv8BU',
        start: 3
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Crossover', caption: ['レディーは右肩ですれ違い（2 bar）、ジェンツは左肩ですれ違い（2 bar）、オポジットの位置へ行く', 'その後、同じ動作を繰り返してもとの位置へ戻る'] },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', caption: ['パートナーと向き合い、その場でステップする', '映像ではその場でWest Clare Butteringしている'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies chain (lasso)', caption: ['レディーはセットの中央でoppositeのレディーと右手をとり、oppositeのジェントと左手をとってジェントの腕の下でTurnする', 'その後、再びセットの中央でoppositeのレディーと右手をとり、自分のパートナーと左手をとってジェントの腕の下でTurnする', 'ジェントはレディーをTurnさせる際、レディーを追いかけるように反時計回りに動き、その後時計回りにTurnする'] },
        { bar: 8, subject: 'Everyone', summary: 'Step it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Cross', caption: ['カップルはcross handになりAdvance & Retireする', 'Retireするとき、ジェンツは腕を上げてレディーを通し、レディーはジェントの左側へ行く', 'カップルはジェンツが右肩ですれ違うようにしてセットを横切る', 'oppositeの位置へ行ったら内回りにTurnしてセットの中央へ体を向ける'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Cross', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Ladies chain',
      rythmn: 'Reel',
      description: 'ハーフ・セットのフィガー',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5J0XuTEv8BU',
        start: 122
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Ladies chain (lasso)' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: '1st Lady & 2nd Gent', summary: 'Dance around', caption: ['Leading Ladyとopposite Gentはセットの中央を時計回りに一周する', '一周したら互いに向き合う', '最後の動きは自由に装飾する'], type: 'repeat' },
        { bar: 8, subject: '1st Lady & 2nd Gent', summary: 'Swing (céilí)', caption: ['Leading Ladyとopposite Gentはcéilí holdでSwingする（6 bar）', 'その後、もとの位置へ戻る（2 bar）'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Cross', type: 'repeat' },
        { bar: 8, subject: '1st Lady & 2nd Gent', summary: 'Dance around', type: 'repeat' },
        { bar: 8, subject: '1st Lady & 2nd Gent', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross) & Cross', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 64, subject: '2nd Lady Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Three and One',
      rythmn: 'Reel',
      description: 'ハーフ・セットのフィガー',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5J0XuTEv8BU',
        start: 285
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Ladies chain (lasso)' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' },
        { bar: 8, subject: '1st Couple Leading', summary: 'House', caption: ['Leading CoupleがHouse insideしているとき、oppositeのカップルは右手同士をつなぐ', 'Leading Gentは最後の2 barsで自分のレディーをoppositeのジェントの右に置く。このときLeading Ladyはセットの外側を向く。oppositeのジェントは1st Ladyの左手をとる', '最後の2 barsでopposite coupleのレディーも反時計回りにTurnしてセットの外側を向く', 'Leading Gentはレディーの間に入り、3対1のフォームになる。Leading Gentは隣のレディーと手を繋がない'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Three and One', caption: ['4(3)人はRetire(4 bar)し、Advance(4 bar)する', '最後の2 barsでレディーはoppositeジェントの手を繋いだまま反転し、oppositeジェントの隣へ行き、Leading Gentの手をとる', '4(3)人はAdvance(4 bar)し、Retire(4 bar)する', '最後の2 barsでレディーは手を離し、セットの内側を向き、ジェンツの肩に手を乗せてLittle Christmasの構えになる'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Little Christmas x 2 (Bascket)', caption: ['時計回りにLittle Christmasし（8小節）、反時計回りLittle Christmasする（8 bar）'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)', type: 'repeat' },
        { bar: 64, subject: '2nd Lady Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'The Full Set',
      rythmn: 'Polka',
      description: 'フル・セットのフィガー',
      youtube: {
        url: 'https://www.youtube.com/watch?v=5J0XuTEv8BU',
        start: 447
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', caption: ['隣合う人と手を繋いでAdvance & Retireする'] },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret, Ladies; move→R', caption: ['Circle Advance & Retire を一度行い、その後レディーは自分の一つ右側のジェンツの下へ移動する', 'ジェンツは左隣のレディーを引きよせる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 24, subject: 'Everyone', summary: 'Adv-Ret & Crossover', caption: ['TopsはAdvance & Retireし(4 bar)、open holdで反時計回りにCrossoverし、反転してセットの内側を向き(4 bar)、その場でステップする(2 bar)。再びAdvance & Retireし(4 bar)、反時計回りにCrossoverし、反転してセットの内側を向き(4 bar)、その場でステップし(2 bar)、Homeする(4 bar)。', 'Sidesはその場ステップし(2 bar)、Advance & Retireし(4 bar)、shoulder holdで反時計回りにCrossoverし、反転してセットの内側を向く(4 bar)。再びその場でステップし(2 bar)、Advance & Retireし(4 bar)、反時計回りにCrossoverし、反転してセットの内側を向き(4 bar)、その場でステップする(2 bar)。', 'Adv-Ret & Crossoverの動きをSidesが2 bars遅れて動くイメージ'] },
        { bar: 8, subject: 'Everyone', summary: 'Ladies chain (lasso)', caption: ['TopsがLadies Chainを始めた2 bars後にSidesもLadies Chainを始める'] },
        { bar: 8, subject: 'Everyone', summary: 'Step it out' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí)' }
      ]
    }]
  },
  'Kildownet Half':
  {
    name: 'Kildownet Half',
    jpCaption: 'キルダーネット・ハーフ',
    level: 'advanced',
    county: ['Mayo'],
    referenceSite: {
      'irishSetDancing': 'http://setdanceteacher.ie/kildownet.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Swing Opposites',
      rythmn: 'Reel',
      description: 'Swing は céilí hold。2 bars ステップする動作が頻出する',
      youtube: {
        url: 'https://www.youtube.com/watch?v=PTH0n1ZSodM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond left', caption: 'すべてのカップルは cross hand のまま、左側へ進み出る(2 bar)。その後、後ろ向きに下がり、opposite へ向かう(2 bar)。同じ動きを繰り返して元の位置へ戻る(4 bar)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí) & Step', caption: 'céilí hold で Swing し(6 bar)、その場でステップする(2 bar)' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies Chain (arm)', caption: 'レディーは opposite のレディーと右手で Chain し、opposite のジェントと左腕で Chain し、opposite のレディーと右肩ですれ違う。元の位置へ戻ったら自分のパートナーと céilí hold になる' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí) & Step' },
        { bar: 8, subject: '1st Gent & opposite Lady', summary: 'Adv & Swing', caption: 'Leading Gent とその opposite のレディーは前へ進み出る(2 bar)。Swing し(4 bar)、元の位置へ戻り、自分のパートナーと cross hand になる(2 bar)。その間、残されたジェントとレディーはゆっくりその場で Turn する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond left', type: 'repeat' },
        { bar: 16, subject: '2nd Gent Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies Half Chain (arm)', caption: 'レディーは opposite のレディーと右手で Chain し、opposite のジェントと左腕で Chain し、そのまま反時計回りに Turn しながら、opposite のジェントの左側へ回り込み、basket form になる' },
        { bar: 8, subject: 'Everyone', summary: 'Little Christmas & Step', caption: 'cross arm で Little Christmas する(6 bar)。その後、元の位置へ戻り、自分のパートナーと cross hand になる(2 bar)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    },
    {
      order: 2,
      summary: 'Walkabout',
      rythmn: 'Polka',
      description: 'House - Walkabout - Swing で始まり、Swing - Walkabout - House で終わる。Swing は waltz hold',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UNFB1XuMpz8',
        // url: 'https://www.youtube.com/watch?v=wWDBAkWvaXA',
        start: 20
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Walkabout', caption: ['レディーは opposite のジェントに向かって、ジェントは自分のレディーに向かって前へ進み、反時計回りに90度回転する(4 bar)', '上の動作を4回繰り返し、四角形を描くようにして元の位置へ戻る', '移動するときは one - two で移動し、角でステップする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Long polka', caption: ['すべてのカップルは waltz hold になる', '行きはジェントが背中合わせになるようにして、opposite へ移動する(4 bar)', '帰りはレディーが背中合わせになるようにして、元の位置へ移動する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies Chain (arm)', caption: 'どこにも記載がないけれどたぶん arm だと思う。Polka だし' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', caption: 'いってらっしゃい Swing' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Change Places', caption: ['ジェンツは前へ進み出て opposite のジェントと左肩で並ぶ(2 bar)', 'その場でステップし(2 bar)、ジェンツ同士で一礼する(4 bar)', 'opposite のレディーのところへ向かう(2 bar)', 'その間レディーはその場でステップする'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', caption: 'いらっしゃいませ Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Pass through', caption: 'crossed hand で Slide In, Slide Out する(4 bar)。その後、右肩 - 左肩で Pass through する' },
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Pass through' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', caption: 'さよなら Swing' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Change Places' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', caption: 'おかえり Swing', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Walkabout', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Three and One',
      rythmn: 'Reel',
      description: '「Lead Around - Hook & Turn - Swing」と「Advance & Retire - Three & One  - Swing - Gents Hook」の2パートでダブルチーズバーガー状の構造になっている',
      youtube: {
        url: 'https://www.youtube.com/watch?v=t6MXhlMlkfI',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: 'ジェンツは元の位置へ戻ったら両手でレディーを Turn させる', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Hook & Turn', caption: '自分のパートナーと左腕を組み、反時計回りに Turn する', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí) & Step', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'Adv-Ret (shoulder)', caption: 'Leading Couple は右手をレディーの右肩の上で、左手を手前でにぎり、Advance & Retire する(6 bar)。opposite のカップルは同じように右手だけにぎって待つ。Leading Gent は左手を離し、レディーを時計回りに Turn させながら、opposite のジェントのところへ送り出す(2 bar)。その際、右手は離さない。opposite のジェントはレディーが来たら左手をレディーの左肩に回して手をにぎる', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Three & One, Change Partners', caption: 'Leading Gent の opposite の3人は Advance & Retire する(6 bar)。その後、レディーは左肩ですれ違い、opposite のジェントのところへ向かう(2 bar)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí) & Step', type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Hook with Left arm', caption: 'ジェンツは opposite のジェントと中央で反時計回りに Turn する(6 bar)。最後の 2 bar は Double で Turn し、元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Hook & Turn', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (céilí) & Step', type: 'repeat' },
        { bar: 56, subject: '2nd Couple Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'The Fling',
      rythmn: 'Fling',
      youtube: {
        url: 'https://www.youtube.com/watch?v=1PI9s7Zekcg',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Dance', caption: ['Gents は「前→後→左→右、前→後→右→左」の動作を2回する', 'Ladies は「後→前→右→左、後→前→左→右」の動作を2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double', caption: '最後の 2 bar は Double', type: 'repeat' },
        { bar: 0, subject: 'Everyone', summary: '<<Repeat × ∞>>', caption: '上記の動作を音楽が鳴り止むまで繰り返す', type: 'call-repeat' }
      ]
    }]
  },
  'Kilfenora Plain':
  {
    name: 'Kilfenora Plain',
    jpCaption: 'キルフェノーラ・プレーン',
    level: 'basic',
    county: ['Clare'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/kilfpl',
      irishSetDancing: 'http://setdanceteacher.ie/kilfenora.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fNpJ6OL_PJ4',
        start: 23
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen holdでLead Aroundする', 'open hold: ジェンツはレディーの腰に右手をあて、レディーはジェンツの肩に左手をおく'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common', caption: ['自分のパートナーと向き合ってその場でステップする(4 bar)', 'その後、waltz hold になり Swing する(4 bar)'] },
        { bar: 8, subject: 'Tops', summary: 'Square', caption: ['向かいのカップルとすれ違うときはレディーが内側、ジェンツが外側。自分のパートナーとすれ違うときはレディーが外側、ジェンツが内側', 'レディ−、ジェンツともに右肩 → 左肩 → 右肩 → 左肩ですれ違う'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through & Lead Back (acw)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: '' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Crossover',
      rythmn: 'Jig',
      description: 'さざなみ！繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fNpJ6OL_PJ4',
        start: 135
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Adv-Ret (Tops→Sides)', caption: ['すべてのカップルは Right hand in Right, 右手をつなぐ', 'Leading Couples は Advance & Retire する(4 bar)', 'その後、Leading Couples でないカップルも Advance & Retire する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Crossover (Tops→Sides)', caption: ['Leading Gents はレディーを半回転させながら、opposite のカップルと位置を交換する(4 bar)', 'その後、Leading Couples でないカップルも同じ動作を繰り返す(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Adv-Ret (Tops→Sides)', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Crossover (Tops→Sides)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: 'Sides が Leading の時は Sides から Advance & Retire を行う' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Lineup',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top Gent - 2nd Top Gent - 1st Side Gent - 2nd Side Gent の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=-blLTgTgy9g',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Slow turn (r.h, cw)', caption: 'Leading Gent とその opposite の Lady は右手をつかんで時計回りにゆっくり回る(8 bar)', type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lineup (acw)', caption: ['Leading Gent とその opposite の Lady は Swing した後、それぞれ左手を握って反時計回りにゆっくり回る', '自分のパートナーに出会ったら空いているでパートナーの手を握り、反対側へ連れて行く'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady, then Tops', summary: 'Adv-Ret & Pass through', caption: ['Leading Gent とその opposite Lady は Advance & Retire を一度する(4 bar)', 'Retire するときは互いに軽く一礼する', 'その後、Pass back する(4 bar)', 'opposite のパートナーとすれ違うときは右肩で、自分のパートナーとすれ違うときは左肩ですれ違う(4 bar)'], type: 'repeat' },
        { bar: '' },
        { bar: 32, subject: '2nd Top Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 64, subject: '1st Side - 2nd Side', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: '3 to 1',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fNpJ6OL_PJ4',
        start: 454
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 16, subject: 'Tops', summary: 'Three & One  (switch)', caption: 'レディーは移動するときにジェントの腕の下を通らずにぬるっと移動する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 48, subject: '2nd Top Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 96, subject: '1st Side - 2nd Side', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Sevens',
      rythmn: 'Jig',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fNpJ6OL_PJ4',
        start: 711
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Sevens In, Out & accross', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Set & Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Sevens In, Out & accross', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set & Swing', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Mixer',
      rythmn: 'Quadrilles',
      description: '自分のパートナーと出会うまで繰り返す。Quadrilles(カドリール、カドリーユ)とは Reel よりは遅く、しかし Hornpipe よりは速いスクエアダンスで使われる曲のこと',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fNpJ6OL_PJ4',
        start: 823
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Ladies; Right Hand Star', caption: ['Circle 状になって Advance & Retire を一度する(4 bar)', 'その後、レディーは右手を上げて時計回りに3/4回転 Star をして元の位置から一つ右側へ行く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Kilkenny Lancers':
  {
    name: 'Kilkenny Lancers',
    jpCaption: 'キルケニー・ランサーズ',
    level: 'advanced',
    county: ['Kilkenny'],
    notices: 'このセットはキルケニー州のSlate Quarry Dancersによって作られました。Lead Inの7,8 Bars目ではBatteringします。フィガーはStephen Quigleyにより記録されました。1st Sideは1st Topの右側のカップル。This set was was made famous by the Slate Quarry Dancers in Kilkenny, The batter is danced during the last two bars of each introduction. It is written here as described by Stephen Quigley. First side couple are on the right of first top couple. 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/kilkla'
    },
    thumbnail: 'https://www.youtube.com/watch?v=vlfLYTW6-VI',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Swing with opposite',
      rythmn: 'Polka',
      youtube: null,
      description: 'Leading Gent は反時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      movements: [
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing with opposite', caption: ['Leading gentとopposite ladyはセットの中央でcéilí holdでswingする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Batter, Corner Swing', caption: ['ジェンツは左、レディーは右側のパートナーと向き合う', 'バタリングし(2b)、céilí holdでswingする(6b)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Batter, Swing', caption: ['自分のパートナーと向き合い、バタリングし(2b)', 'céilí holdでswingする(6b)'], type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 72, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat>>, Circle or Huddle', caption: ['最後のswingの後、セット中央に集まってChristmasの構えのように互いに腕を腰に回す'], type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Lancers',
      rythmn: 'Polka',
      youtube: null,
      description: 'Line upするときはLeading Couplesの側',
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', caption: ['Leading couplesはwaltz holdでHouse aroundする', '手は低く構える (hands low)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line up & Adv-Ret (batter, swinging)', caption: ['リーディングでないカップルはパートナーと離れ、Leading Couplesの側でLine upする', 'Advance & Retireする、Advanceするときはbatterし、RetireするときはSwinging stepする (1-2-3-4 or 1-2, 123)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Batter, Swing', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 72, subject: 'Tops - Sides - Sides', summary: '<<Repeat>>, Circle or Huddle', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Lead Around',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couple', summary: 'House inside & Turn the Lady', caption: ['Leading CouplesはHouse aroundする(6 bars)', '最後の2バーズで、ジェンツはは左手でレディーを時計回りにまわす'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing, Batter', caption: ['Leading CouplesはSwingし(6 bars)、Batterする(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen waltz holdでLead Aroundする'], type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 72, subject: 'Tops - Sides - Sides', summary: '<<Repeat>>, Circle or Huddle', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Half Chain',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=NITfUewBI5s',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Half Chain', caption: ['パートナーと向き合い、右手をとってChainでoppositeの位置まで行く'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Half Chain' },
        { bar: 8, subject: '1st Top & 1st Side', summary: 'House each other', caption: ['1st Topと1st SideはHouse aroundする'], type: 'repeat' },
        { bar: 8, subject: '1st Top & 1st Side', summary: 'Adv-Ret', caption: ['1st Topと1st SideはAdvance & Retireを2回する、AdvanceするときはBatterする'], type: 'repeat' },
        { bar: 8, subject: '2nd Top & 2nd Side', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: '2nd Top & 2nd Side', summary: 'Adv-Ret', type: 'repeat' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Half Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Half Chain, Circle or Huddle' }
      ]
    },
    {
      order: 5,
      summary: 'Half Lead Around',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Half Chain', caption: ['パートナーと向き合い、右手をとってChainする', '反対側の位置まで行ったらレディーは反時計回りにパートナーの周りをまわり、open waltz holdになる'] },
        { bar: 8, subject: 'Everyone', summary: 'Half Lead Around (open)' },
        { bar: 8, subject: '1st Top & 1st Side', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: '1st Top & 1st Side', summary: 'Adv-Ret', type: 'repeat' },
        { bar: 8, subject: '2nd Top & 2nd Side', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: '2nd Top & 2nd Side', summary: 'Adv-Ret', type: 'repeat' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Half Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Half Lead Around (open), Circle or Huddle' }
      ]
    },
    {
      order: 6,
      summary: 'In, Out',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Batter In, Out & House across', caption: ['Leading CouplesはBatter In, Batter Outし(4 bars)', 'House acrossする(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Batter In, Out & House across', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open), Circle or Huddle' }
      ]
    },
    {
      order: 7,
      summary: 'Throw the Lady',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=vlfLYTW6-VI&',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Leading Couple', summary: 'Sevens In, Out & Throw the Lady', caption: ['Leading Gentはパートナーとセットの中央に向かってSevens In, Outする(4 bars)', 'その場で時計回りにダンスする(2 bars)', 'このとき、ジェントは一つ右側のカップルに背を向けるようにする', 'その後ダブルでまわり、レディーを一つ右側のジェントのに向かって投げ飛ばす(2 bars)', 'このとき、Leading Gentの右側にいるレディーはパートナーからそっと離れ、Leading Gentとwaltz holdになる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & 1st Side Lady', summary: 'Sevens In, Out & Throw the Lady', type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & 2nd Top Lady', summary: 'Sevens In, Out & Throw the Lady', type: 'repeat' },
        { bar: 8, subject: 'Leading Gent & 2nd Side Lady', summary: 'Sevens In, Out & Dance, Double', caption: ['4人目のレディーは投げ飛ばさず、ダブルでホームポジションへ戻る'], type: 'repeat' },
        { bar: 96, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond to right, Circle or Huddle', caption: ['すべてのカップルはDiamond Sevensで（Sevensで右へ進み、Sevensでoppositeへ後退する）oppositeへ向かう', 'その後、時計回りにまわり、Doubleでホームポジションへ向かい、', 'セット中央に集まってChristmasの構えのように互いに腕を腰に回す'] }
      ]
    },
    {
      order: 8,
      summary: 'Circle',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', caption: ['すべてのカップルは円状に手をつなぐ', 'Advance & Retireを2回する', 'AdvanceするときはBatterする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Moves - right, & Lead Around', caption: ['レディーは一つ右側のジェントのところへ向かう', '新しいパートナーと　Lead Aroundする'], type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing, Circle or Huddle' }
      ]
    }]
  },
  'Kilkenny Quadrilles':
  {
    name: 'Kilkenny Quadrilles',
    jpCaption: 'キルケニー・カドリール',
    level: 'advanced',
    county: ['Kilkenny'],
    notices: '(Full Set Version) このセットは後年のPaddy Stauton、演奏家とダンサーによりKilkenny州のSpringhill Hotelで踊られた。これらはMarble City DancersのPhil Curranにより手配された。Paddyによると、このセットは2列に並び、互いに向き合うようにしてハーフセットで踊られる。2017年7月のタバカリー州で行われたSouth Sligo Summer Schoolでは、フルセットとして初めて踊られた。"Toss the Feathers"ではハーフセットとして書かれている。〜"Come West Along the Road", Pat Murphyより抜粋。',
    referenceSite: {
      crookedriver: 'http://www.personal.kent.edu/~ltaylor1/kilkenny%20quadrilles.htm'
    },
    thumbnail: '',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through', caption: ['Leading Couplesはoppositeのパートナーと右肩ですれ違う', '反対側まで行ったら時計回りにTurnし、再びoppositeのパートナーと右肩ですれ違い、元の位置へ戻る', '元の位置へ戻ったら自分のパートナーと向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', caption: ['Leading Ladyはoppositeのレディーと右手、oppositeのパートナーと左腕、再びoppositeのレディーと右手、そして自分のパートナーと左手でChainする', '自分のパートナーとChainしたらそのままshoulder holdになる', 'oppositeのパートナーとチェインするとき、ジェンツはセットの中央を向いたまま、レディーはジェントの腕の下で時計回りにTurnしながらChainするバージョンもある'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Lead Around (shoulder)', caption: ['Leading CouplesはLead Aroundする', '元の位置へ戻ったらジェンツはレディーを反時計回りにTurnさせ、自分のパートナーと向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 40, subject: 'Sides', summary: '<<Repeat>>', caption: ['Sides Leadingの最後のSwingはAll Swing'], type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Change places',
      rythmn: 'Polka',
      description: '繰り返し部分は 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる。1st Sideは1st Topの左側',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Crossover', caption: ['Leading CouplesはRight hand in right、右手をつないでAdvance & Retireする', 'Leading Coupleはアーチを作り、oppositeのカップルはそのアーチをくぐり、それぞれoppositeの位置へ行く', 'Leading Ladyはジェントの腕の下で反時計回りにTurnし、ジェントはその外側を回る', 'oppositeのカップルは手をつないだまま時計回りにTurnする、このときジェントはレディーはTurnさせない'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Cross back', caption: ['同じ動きを繰り返す。Leadingは入れ替わらない'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat', caption: ['2nd Side Leadingの最後のSwingはAll Swing'] },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Crossover',
      rythmn: 'Single Jig or Slide',
      description: '繰り返し部分は 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing (waltz)', caption: ['Leading Gentとオポジットのレディーはセットの中央でSwingする'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Cross right', caption: ['Leading CouplesはRight hand in right、右手をつないでAdvance & Retireする(4 bar)', 'レディーはジェンツの腕の下で時計回りに2回Turnしながら、oppositeの位置へ行く'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Cross back', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Gallop',
      rythmn: 'Jig',
      description: '繰り返し部分は 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couple が入れ替わる。このフィガーとても長いため、ハーフセットで踊られることがある。',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Lead Around (shoulder)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Gallop', caption: ['Leading CouplesはSlide acrossまたはGallopする(4 bar)', 'もう一度Gallopで反対側へ行き(2 bar)、その場でTurnする(2 bar)', 'Leading Gentは自分のレディーをoppositeのジェントの隣へ置く', 'oppositeのジェントは両手をレディーの肩から回し、手をつなぐ', 'アイルランドのワークショップでは「Sevens」として教えられたそうです'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: '3 & 1', caption: ['3人はAdvanceし、Leading GentはRetireする(2 bar)', '3人はRetireし、Leading GentはそのままRetireし、ホームポジションへ戻る(2 bar)', 'その後、4人はAdvanceし(2 bar)、セットの中央でLittle Christmasの形になる(2 bar)'], type: 'repeat' },
        { bar: 16, subject: 'Leading Couples', summary: 'Little Christmas', caption: ['時計回りにLittle Christmasする(8 bar)', 'その後、反時計回りにLittle Christmasする(8 bar)'], type: 'repeat' },
        { bar: 168, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Lead Around (shoulder)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 24, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Circle',
      rythmn: 'Jig or Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen holdでLead Aroundする'], type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret & Ladies; Move right', caption: ['ジェンツが2回目にRetireするとき、レディーは一つ右隣のジェンツのところへ行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Knockanore':
  {
    name: 'Knockanore',
    jpCaption: 'ノッカノーア',
    level: 'advanced',
    county: ['Waterford'],
    referenceSite: '',
    thumbnail: 'https://www.youtube.com/watch?v=JqLeS41FspI',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'normal ver.',
      rythmn: 'Polka',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone & Tops', summary: 'Balance, Crossover', caption: ['すべてのカップルは waltz ホールドで Balance(In, Out)し(4 bar)、Leading Couples が Crossover する(4 bar)', '"Balance"とは相手に近づいて離れること'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Balance, Crossover', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' }
      ]
    },
    {
      order: 1,
      summary: 'variation ver.',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=JqLeS41FspI',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone & Tops', summary: 'Balance, Crossover', caption: 'すべてのカップルは waltz ホールドで Balance(In, Out)し(4 bar)、Leading Couples が Crossover する(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Balance, Crossover', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Crossover w/Right', caption: 'Tops は右側のカップルと、Sides は左側のカップルと Crossover する。Tops は一つ右側へ移動し、Sides は一つ左側へ移動する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Crossover w/Left', caption: 'Tops は左側のカップルと、Sides は右側のカップルと Crossover して元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm) w/Right', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House w/Right', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat', caption: 'Tops は左側のカップルと、Sides は右側のカップルと繰り返す' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' }
      ]
    },
    {
      order: 2,
      summary: '',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IhTRODCc0Ic',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret (kick)', caption: '2 bar / 6bar のとき、中央に向かって軽くキックする', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Balance, Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Balance, Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm), Chase Ladies', caption: 'Leading Couples のジェントはレディーが戻ってきたら追うように動く。Leading Couples 以外のカップルも最後の 2 bar に反時計回りに Turn する', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Lead Around (cross)', caption: 'ジェンツとレディーは左手をつなぎ、ジェンツは右手をレディーの腰に回して手を繋ぎ、Long Lead Around する', type: 'repeat' },
        { bar: 144, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret (kick)' }
      ]
    },
    {
      order: 3,
      summary: '',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=TcSmvnda3ZQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Balance', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Ladies Chain / Steps', caption: 'Leading Couples が Ladies Chain している間、Leading Couples 以外のカップルはステップを踏む', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through (G; In) & Turn (l.h.)', caption: '往路は左肩ですれ違い、復路は右肩ですれ違うようにして Pass through する。戻ってくるときは opposite のカップルと出会ったら左手で Turn する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Circle, G; reverse, L; Turn', caption: 'ジェンツは内側、レディーは外側を向いて 4 bar 円上になる。ジェンツは元の位置へ戻り、レディーは中央で右手を合わせて Turn する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm)', caption: '中央で Turn していたレディーはそのまま opposite のところへ向かう', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Pass through (G; I/O)', caption: '往路は左肩ですれ違い、復路は右肩ですれ違うようにして Pass through する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' }
      ]
    },
    {
      order: 4,
      summary: '',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Zqt5rad5BUw',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Ladies & Gents', summary: 'L; Balance, moves→R, G; Balance', caption: 'レディーは内側に向かって Balance(In, Out) する。その後、ジェンツも Balance する。その間レディーは外側を通るようにして一つ右側のジェントのところへ移動する', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 5,
      summary: '',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=7UXQUwRWH_g',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone & Top Gents', summary: 'Balance, Gents; Cross', caption: 'すべてのカップルは waltz ホールドで Balance(In, Out) する(4 bar)。その後 Leading Couples のジェントは opposite へ向かう(4 bar)。このときレディーはジェントの位置へ移動する。opposite に来たジェントはレディーと waltz ホールドになりその場で反時計回りに Turn する', type: 'repeat' },
        { bar: 8, subject: 'Tops & Top Ladies', summary: 'Balance, Ladies; Cross', caption: 'Leading Coupls は waltz ホールドで Balance(In, Out) する(4 bar)。その後 Leading Couples のレディーは opposite へ向かう(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops & Top Ladies', summary: 'Balance, Chain (l.h.)', caption: 'Leading Coupls は waltz ホールドで Balance(In, Out) する(4 bar)。その後レディーは Ladies Chain する(4 bar)。レディーは opposite のジェンツと左手で Turn し、元の位置へは戻らない', type: 'repeat' },
        { bar: 8, subject: 'Tops & Top Ladies', summary: 'Turn (l.h.), Ladies; Cross', caption: 'ジェンツとレディーは 4 bar そのまま反時計回りに Turn し、レディーは元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' }
      ]
    },
    {
      order: 6,
      summary: '',
      rythmn: 'Polka',
      description: 'Top が常に Leading Couples',
      youtube: {
        url: 'https://www.youtube.com/watch?v=bHxphuTbQfY',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone & all Ladies', summary: 'Balance, Ladies; Crossover', caption: 'すべてのカップルは waltz ホールドで Balance(In, Out)する(4 bar)。その後 Leading Couples のレディーから Crossover する。ジェンツとレディーは出会ったら右手を合わせる', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Turn & L; moves→R, back (R→L)', caption: 'ジェンツとレディーは右手を合わせてその場で半周する。レディーは一つ右側のジェントのとこへ行き、その場で半周して元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Crossover', caption: 'Tops - Sides の順番でレディーは Crossover する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Turn & L; moves→R, back (R→L→R)', caption: 'ジェンツとレディーは右手を合わせてその場で半周する。レディーは一つ右側のジェントのとこへ行き、その場で半周して元の位置へ戻り、再び右手を合わせて Turn する', type: 'repeat' },
        { bar: 48, subject: 'Tops - Tops - Tops', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' },
        { bar: 16, subject: 'Everyone', summary: 'Chain (G;In, L, Out)', caption: 'ジェンツは内側を反時計回りに、レディーは外側を時計回りに 16 bar かけて1周する。1/4進んでジェントレディーが出会ったら右手でハイタッチする' },
        { bar: 8, subject: 'Everyone', summary: 'Balance' },
        { bar: 8, subject: 'Everyone', summary: 'Circle (no hands)', caption: '円上になって、その場で 8 bar ステップを踏む' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' }
      ]
    }]
  },
  'Labasheeda':
  {
    name: 'Labasheeda',
    jpCaption: 'ラバシーダ',
    level: 'basic',
    county: ['Clare'],
    notices: 'この美しいセットはクレア州のLabasheeda地方のリール・セットとして知られている。このセットはクレア西部で有名なダンシング・マスターのDan Fureyにより教え伝えられた。 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/labare'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Show the Ladies',
      rythmn: 'Reel',
      description: 'Leading GentがすべてのレディーとHouseする',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 209
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross holdでLead Aroundする', '最後の2 barsで、ジェンツはレディーを時計回りに回してwaltz holdになる'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top Gent', summary: 'House inside', caption: ['Leading Gentは自分のレディーとHouse insideする', '6 bars目に左隣のカップルと向き合い、Leading Gentはカップルの間に自分のレディーを置く', 'レディーは最後の2 barsで前に出てLeading Gentのもとへ向かう'], type: 'nested-repeat' },
        { bar: 24, subject: '1st Top Gent', summary: '<<Repeat ×3>>', caption: ['Leading Gentは1st Top Lady → 1st Side Lady → 2nd Top Lady → 2nd Side Ladyの順で4人のレディーとHouse insideする'], type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'High Gates',
      rythmn: 'Reel',
      description: 'Leading Gentが左隣のレディーとHigh Gateする',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 429
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top & Lady on 1st Gent left', summary: 'High Gates', caption: ['Leading Gentは隣り合うレディーと手をつなぐ', 'Leading Gentは左手を上げて自分のレディーを通し、次に右手を上げてビジターパートナーを通し、最後に自分のレディーを通す', 'ジェントはレディーを腕の下で通した後はレディーの後ろを追いかける', 'パートナー、ビジター、パートナーの順'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: '1st Side Gent - 2nd Top Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Little Christmas',
      rythmn: 'Reel',
      description: 'Leading Coupleが左隣のカップルとLittle Christmasする',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 607
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top & left Couple on 1st Top', summary: 'Little Christmas w/Left', caption: 'Leading Couple は自分たちの左側のカップルと Little Christmas する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Show the Gents',
      rythmn: 'Reel',
      description: 'Leading LadyがすべてのジェンツとHouseする',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 772
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top Lady', summary: 'House inside', caption: ['Leading Ladyは自分のジェントとHouse insideする', '6 bars目に左隣のカップルと向き合い、Leading Ladyはカップルの間に自分のジェントを置く', 'ジェントは最後の2 barsで前に出てLeading Ladyのもとへ向かう'], type: 'nested-repeat' },
        { bar: 24, subject: '1st Top Lady', summary: '<<Repeat ×3>>', caption: ['Leading Ladyは1st Top Gent → 1st Side Gent → 2nd Top Gent → 2nd Side Gentの順で4人のレディーとHouse insideする'], type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '1st Side Lady - 2nd Top Lady - 2nd Side Lady', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'The Jig',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 1001
      },
      description: 'Tops Gents Leading - Sides Gents Leading',
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House or Lead Around (cross)', caption: 'すべてのカップルは House または cross hand で Lead Around する', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Top Gents & Top Ladies', summary: 'House inside', type: 'nested-repeat' },
        { bar: 8, subject: 'Top Gents & Top Ladies', summary: 'Adv-Ret, Ladies; Cross', caption: 'Leading Couples は Advance & Retire を1回する。その後、レディーは右肩ですれ違いながら opposite へ向かう', type: 'nested-repeat' },
        { bar: 8, subject: 'Top Gents & Top Ladies', summary: 'House', type: 'nested-repeat' },
        { bar: 8, subject: 'Top Gents & Top Ladies', summary: 'Adv-Ret & Ladies; Cross', caption: 'Leading Couples は Advance & Retire を1回する。その後、レディーは右肩ですれ違いながら元の位置へ戻る。ジェンツは左隣のレディーのところへ移動する', type: 'nested-repeat' },
        { bar: 32, subject: 'Top Gents & Side Ladies', summary: '<< Repeat w/Sides >>', caption: ['ジェンツは4回目のAdvance & Retireの後に元の位置へ戻る '], type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 72, subject: 'Side Gents Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'The Fling',
      rythmn: 'Fling',
      description: 'Tops - Sides - Tops - Sides',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 1204
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', caption: 'Slide in, Slide out, double Home & Slide in, Slide out, double House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Turn w/opposites, Slide & Home', caption: '中央に集まり、向かいのパートナーと左腕をつかんで Turnして元の位置へ戻る。その後 double Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Double', caption: 'Leading Couples は House し(6 bar)、最後の 2 bar は Double する', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 7,
      summary: 'Hornpipe',
      rythmn: 'Hornpipe',
      description: 'レディーは一つずつ右へずれる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3pLtmUEBE_M',
        start: 1414
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Balance & Ladies; move→1/4R, Home', caption: ['Hop-in-two-three, Hop-out-two-three(2 bar)', 'レディーはセットの中央を通って一つ右側のジェンツの元へ移動する(2 bars)', 'ジェンツはその場で時計回りにTurnしてレディーを待つ', '新しいパートナーとHomeを1回する(4 bars)'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Laois Lancers':
  {
    name: 'Laois Lancers',
    jpCaption: 'リーシュ・ランサーズ',
    level: 'advanced',
    county: ['Laois'],
    notices: 'All swings in old céili hold (elbow grip).',
    referenceSite: {
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: '',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=NmdCYJe2Cxk',
        start: 3
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', caption: ['すべてのカップルは円になってAdvance & Retireを2回する', '2回目にRetireするとき、Leading CouplesでないカップルはそれぞれLeading Couplesの方へ別れてライン状になる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line, Adv-Ret', caption: ['全員でAdvance & Retireする', '再びAdvanceしたとき、Top Gentsは右手でopposite Ladyの右手をとって、反時計回りにTurnさせながら自分の隣に招き寄せる', 'Leading Gents以外のジェンツはその場で自分のレディーを反時計回りにTurnさせる(2 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)', type: 'repeat' },
        { bar: 72, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', caption: ['レディーが元に位置に戻るまで繰り返す'], type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: '',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=NjenH35hkWk',
        start: 3
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Face Corner Partners', caption: ['コーナー・パートナーの方へ体を向けてAdvance & Retireする(4 bar)', 'その後、右肩ですれ違うようにしてコーナー・パートナーとBack to backする(4 bar)'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Back to Partners', caption: ['コーナー・パートナーと右手をとり、その場で1周して自分のパートナーの方へ体を向ける(4 bar)', 'その後、右肩ですれ違うようにして自分のパートナーとBack to backする(4 bar)'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Adv-Ret, Gents; Adv-Ret', caption: ['すべてのレディーはAdvance & Retireする(4 bar)', 'その後、すべてのジェンツはAdvance & Retireする(4 bar)', 'その間、レディーは時計回りにTurnしながら一つ右のジェンツのところへ行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (old céili)', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['レディーが元に位置に戻るまで繰り返す'], type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: '',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=evcfNlXt5Co',
        start: 4
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (céili style)', caption: ['すべてのカップルは近い方の手をとり(céili style)、Lead Aroundする(8 bar)', 'その後、Lead Backする(8 bar)'] },
        { bar: 8, subject: 'Everyone', summary: 'House (old céili)', caption: ['すべてのカップルはold céili holdでHouseする'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (céili style), Gents; Steal Ladies', caption: ['すべてのカップルは近い方の手をとり(céili style)、セットの中央へ向かってAdvanceする(2 bar)', 'パートナーに向き合うように180度方向転換をし、手を繋ぎ直してセットの外側へ向かってAdvanceする(2 bar)', 'レディーは左手をコーナー・パートナーの右手の方へ伸ばし、ジェンツはその手をとって反時計回りにTurnさせる', 'レディーはジェンツの腕の下を通り、Lead Aroundする方向へ体を向ける'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (céili style)', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['レディーが元に位置に戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'House (old céili)' }
      ]
    }]
  },
  'Limerick Orange and Green':
  {
    name: 'Limerick Orange and Green',
    jpCaption: 'リムリック・オレンジ・アンド・グリーン',
    level: 'advanced',
    county: ['Limerick'],
    notices: 'このOrange and Greenセットはリムリック州のCappaghに住んでいたMaisie Hannessyによって1980年代初頭のScórでTimmy Woulfeに対して発表された。Maisieは80年をCappaghで過ごし、学生の頃にDavid Wrennというダンシング・ティーチャーからセットを習った。This Orange and Green was presented to Timmy Woulfe for Scór in the early 1980s by Maisie Hannessy, who lived in Cappagh, in county Limerick. Maisie, who was in her eighties at the time, had learned the set as a school girl around seventy years earlier from dancing teacher named David Wrenn. 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      irishSetDancing: 'http://setdanceteacher.ie/limerickog.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Adv-Ret',
      rythmn: 'Slide',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=dm5dGhIbR5A',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (crossed)', caption: ['Leading Couplesはパートナーと向き合ってcross hand holdになる(2 bars)', 'Leading Couplesは1, 2, 123のリズムでバタリングしながらAdvance & Retireを二回する', 'Facing their partners holding crossed hand, top couples dance in and back twice, using battering step (1, 2, 123).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through', caption: ['Leading Couplesは、Leadingでないカップルが内側、Leading Coupleが外側に来るようにライン状になる', 'その場でステップし(2 bars)、', '元の位置からoppositeへ行き、パートナーと左肩ですれ違うようにして位置を入れ替え、ジェンツは時計回り、レディーは反時計回り回りにターンしてセットの中央を向く(4 bars)', 'Top couples dance forward to form a line in the centre, with first top couple on the outside, gent on the left and lady on the right (2 bars).', 'They dance on the spot there (2 bars),', 'then dance to opposite positions, partners passing each other left shoulder to left as they turn into place, gents clockwise and ladies anticlockwise (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (crossed)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass back', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', caption: ['Leading Ladyはセットの中央でoppositeのレディーと右手でChainし、', 'oppositeのジェントと左手でChainし、', 'oppositeのレディーともう一度右手でChainしてホームポジションへ戻る', 'Top ladies chain with right hands in the centre, turn with left hands around the opposite gent then right hands again as they dance back home.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 144, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Swing in three',
      rythmn: 'Slide',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Dance & See-saw', caption: ['Leading Coupleは手を繋がずにパートナーと向き合う', '123のリズムでSlide In, Slide Outする(4 bars)', 'その後、シーソーする = 反時計回りにバック・トゥ・バックする(4 bars)', 'Facing each other without touching, first top couple dance in 123 and back 123 twice (4 bars),', 'then dance back to back, going forward left shoulder to left and reversing back right shoulder to right (4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Adv-Ret & Slide across', caption: ['Leading CouplesはSlide In, Outをする(4 bars)', 'もう一度Slide Inする(2 bars)、', 'Leading Ladyはoppositeのカップルのところへ行く(2 bars)', 'Leading GentはSlide Outする', 'First top couple slide to the centre and back, then slide in again and top lady crosses to join opposite couple, as top gent reverses to place.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Lady & opposite Couple', summary: 'Swing in three', caption: ['Leading LadyとLeading Gentのoppositeの3人はSwing in threeする', 'その間、Leading Gentはセットの中央に向かいながらその場でステップする', 'Top lady swings in three with opposite couple, while top gent dances in place, facing forward'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Bow-Ret & Circle', caption: ['Leading GentはAdvanceし、左側のカップルにお辞儀する(2 bars)、', '次に左側のカップルにお辞儀して(2 bars)、', '向かいの3人にお辞儀する(2 bars)', 'その後、4人で手をとってサークル状になる(2 bars)', 'Top gent advances and bows to first side couple (2 bars),', 'bows to second side couple (2 bars),', 'bows to the opposite three (2 bars),', 'then top couples take hands in a circle of four in the centre.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Contrary', caption: ['Leading Couplesは時計回りに歩き(4 bars)', '反時計回りに歩く(4 bars)', 'The circle dances clockwise (4 bars),', 'then anticlockwise (4 bars)'], type: 'repeat' },
        { bar: 144, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Pass through',
      rythmn: 'Polka',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through', caption: ['Leading Couplesはジェンツを外側、レディーを内側にして前に進み、時計回りにその場でターンする', 'oppositeのパートナーと右手をとり、一周半まわって、もとの位置へ戻る', 'Top couples dance forward, ladies passing between the opposite couple, turn clockwise, take right hands with the opposite lady or gent and dance one and a half turns around them, going back to place.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass back', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Gallop',
      rythmn: 'Jig',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Gallop', caption: ['Leading Couplesはジェンツが背中合わせになるようにSevens acrossする(2 bars)、', 'その後、Leadingでないカップルも同様にSevens acrossする(2 bars)', 'Leading Couplesはレディーが背中合わせになるようにSevens backする(2 bars)、', 'その後、リーディングでないカップルも同様にSevens backする(2 bars)', 'Gents pass back to back as top couples dance sevens across,', 'then side couples dance sevens across.', 'Ladies pass back to back as top couples dance sevens back,', 'then side couples dance sevens back.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Double Ladies Chain', caption: ['Leading Ladiesはセットの中央でoppositeのレディーと右手でChainし(2 bars)、', 'oppositeのジェントと左手でChainしながらターンし(2 bars)、', 'oppisteのレディーともう一度Chainしてもとの位置へ戻る(2 bars)', 'Leadingでないレディーは2 bars遅れて同じ動きを始める', 'With top ladies leading, ladies take right hands in the centre,', 'turn with left hands around the opposite gent,', 'then chain back home (polka step).'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Contrary', caption: ['Leading Coupleとoppositeのカップルはそれぞれ左側のカップルと手を繋ぎサークル状になり、時計回りに歩き(4 bars)', '反時計回りに歩く(4 bars)', 'Top couples form circles of four with the side couple on their left.', 'Both circles dance around clockwise (4 bars),', 'then back anticlockwise (4 bars).'], type: 'repeat' },
        { bar: 32, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Crossover',
      rythmn: 'Polka',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (crossed)', caption: ['パートナーと向き合ってcrossed hand holdになる、', 'Leading CouplesはバタリングしながらAdvance & Retireする'], type: 'repeat' },
        { bar: 4, subject: 'Leading Couples', summary: 'Crossover', caption: ['Leading Couplesは反時計回りにoppositeの位置へ向かう、', 'ジェンツはレディーを時計回りにターンさせる', 'Top couples cross anticlockwise,', 'ladies dancing in front and turning clockwise once under their partners\' raised arms.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (crossed)', type: 'repeat' },
        { bar: 4, subject: 'Leading Couples', summary: 'Cross back', type: 'repeat' },
        { bar: 8, subject: 'Ladies & Gents', summary: 'Ladies; Right hand Star, Gents; Dance', caption: ['レディーはセットの中央でRight Hand Starする、', 'その後、Left Hand Starする', 'Ladies join right hands and dance around clockwise in the centre (4 bars),', 'then join left hands and dance anticlockwise back to place (4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 16, subject: 'Leading Couples', summary: 'Body', caption: ['All dance in and back, then turn one place to the right (4 bars),', 'and repeat the movements three times, dancing around to home (12 bars)'], type: 'repeat' },
        { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'Circle',
      rythmn: 'Reel',
      description: '',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (crossed)', caption: ['すべてのカップルはcrossed hand holdになり反時計回りに Lead Around する(8 bar)', '元の位置へ戻ったら、その場で反転し、反時計回りに Lead Back する(8 bar)', 'All couples lead around anticlockwise, holding crossed hands (4 bars),', 'turn in place without turning the lady and lead back clockwise (4 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Circle, Adv-Ret', caption: ['レディーはサークル状になってAdvnace & Retireを2回する', 'Ladies advance and retire twice in a circle'], type: 'repeat' },
        { bar: 8, subject: 'Gents & Ladies', summary: 'Gents; Circle, Adv-Ret, Ladies; move right', caption: ['ジェンツはサークル状になってAdvnace & Retireを2回する、', 'レディーは最後の2barsで、一つ右のジェントのところへ移動し、手をつなぐ', 'Gents advance and retire twice in a circle.', 'As they retire the second time, ladies move on to join hands with the gent on the right.'], type: 'repeat' },
        { bar: 168, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Lead Around & Back (crossed)' }
      ]
    }]
  },
  'Lough Allen':
  {
    name: 'Lough Allen',
    jpCaption: 'ロッホ・アレン',
    level: 'advanced',
    county: ['Leitrim'],
    notices: 'This new set dance is named for Lough Allen, which is beside Drumshanbo, in county Leitrim, where the Joe Mooney Summer School takes place during July every year. We danced this demonstration in Castletown, county Laois, during the Half Door Festival in May 2017 to the wonderful music of the Swallows Tail Céilí Band. 〜YouTubeより抜粋。',
    referenceSite: '',
    needsSet: true,
    figures: [{
      order: 1,
      summary: '',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fJ-GsCdtppA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Adv-Ret, Pass through w/Left', caption: 'Tops は Left Couple と Advance & Retire, Pass through を行う', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Tops; Pass through, Sides; Home', caption: 'Tops が Pass through をする間、Sides は Home。続けて Sides が Pass through をする間、Tops は Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Adv-Ret, Pass through w/Right', caption: 'Tops は Right Couple と Advance & Retire, Pass through を行う', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Tops; Pass through, Sides; Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 2,
      summary: '',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で行う',
      youtube: {
        url: 'https://www.youtube.com/watch?v=sf7QnJ7k3cc',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Reversing', caption: '反時計回りに半周する' },
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Reversing' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, Turn', caption: 'Advance & Retire を一度行い、ジェンツはレディーを自分の左側に引きよせる', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead Around (r.h.)', caption: 'ジェンツは右手を握ってレディーとともに1周する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Reversing' },
        { bar: 8, subject: 'Everyone', summary: 'Slide In, Out & Reversing' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 3,
      summary: '',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pCj3_GOW3nQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House w/Sides (L)', caption: 'Leading Couple は左側のカップルと向き合う', type: 'repeat' },
        { bar: 8, subject: '1st Top Leading', summary: 'Dance acw', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' }
      ]
    },
    {
      order: 4,
      summary: '',
      rythmn: 'Jig',
      description: '繰り返し部分は Top - Top - Side - Side の順で行う',
      youtube: {
        url: 'https://www.youtube.com/watch?v=8x-ja9MdyjU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square (l.c.→r.c.)', caption: 'Tops/Sides に関わりなく、1回目は Tops は左側、Sides は右側のカップルと、2回目は Tops は右側、Sides は左側のカップルと行う', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    },
    {
      order: 5,
      summary: '',
      rythmn: 'Fling',
      youtube: {
        url: 'https://www.youtube.com/watch?v=58vs2Mo8nzk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Ladies', summary: 'Join in a star (L→R)', caption: '左手で Star、右手で Star の後に元いた位置の一つ右側のジェンツを連れて1/4左側へ移動する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Sevens In, Out & Home', type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Join in a star (R→L)', caption: 'すべてのジェンツは右手で Star、左手で Star の後に元いた位置の一つ左側のレディーを連れて1/4右側へ移動する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens & House', type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Mazurka':
  {
    name: 'Mazurka',
    jpCaption: 'マズルカ',
    level: 'basic',
    county: ['Clare'],
    notices: 'このセットはクレア州のリール・セットです。1983年のScórのためにKilmurry dancersによって踊られたものを記録しました。 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/mazuse'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Christmas',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=GpPUaN6ldaM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops & Left Couples', summary: 'Little Christmas w/Left', caption: 'Leading Couples は左側のカップルと Little Christmas する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Adv-Ret w/Sides',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=j_RTa-ONKRY',
        start: 29
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops & Left Couples', summary: 'Adv-Ret w/Left (R-in-R)', caption: ['Leading Couples は左側のカップルと、それ以外のカップルは右側のカップルと向き合う', '向き合ったカップルと Right hand in right、右手をつないで Advance & Retire を2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'High Gates',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ndu0zzjoR7k',
        start: 28
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House', type: 'repeat' },
        { bar: 8, subject: '1st Top & Left Lady on 1st Gent', summary: 'High Gates', caption: ['Leading Gent は waltz hold を解くときに左手をパートナーとつないだまま、右手を左手の下から通して左隣のレディーと手をつなぐ', '最初に隣り合うレディーを通し、次に自分のレディーを通して自分も Turn する。再び自分のパートナーを通して、最後に隣り合うレディーを通す', 'ジェンツはレディーを4回くぐらせる。ビジター、パートナー、パートナー、ビジターの順'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Swing all Ladies',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=lcUyNM3mT2w',
        start: 40
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 32, subject: 'Top Gents & every Lady', summary: 'Swing w/all Ladies', caption: 'Top Couples のジェンツは自分の左隣のレディーから時計回りにすべてのレディーと Swing する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 48, subject: 'Side Gents Leading', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Chain',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=nE6zAxX0GXQ',
        start: 33
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Chain & Swing', caption: ['右手左手の順番で、ジェンツは反時計回りにレディーは時計回りにChain する(12 bar)', '元の位置に戻ったら自分のパートナーと Swing する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'Circle',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=TNUpObOFXfo',
        start: 47
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 16, subject: '1st Top Leading', summary: 'Face the Wall', caption: ['Leading Couple とその左隣のカップルは House する(8 bar)', 'House を終えたら Leading Couple はセットの中央とは逆向きを向く(Face the wall)', 'Leading Couple の左隣のカップルはその後ろに並ぶ', '残りのカップルも House した後、同じ列に加わる(8 bar)'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Circle', caption: ['Leading Couple は自分のパートナーと離れるようにして列の最後尾へ移動する', 'その他のカップルも同様にして移動し、2周する', 'その後 Leading Couple は両手をつかって自分のパートナーとアーチをつくる。その他のカップルはそのアーチをくぐるように House し、自分の位置へ戻る', 'Leading Couple はすべてのカップルがくぐり終えたら同じように House して元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Merchant':
  {
    name: 'Merchant',
    jpCaption: 'マーチャント',
    level: 'beginner',
    county: ['Dublin'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/mercha'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Crossover',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=fyjI3VBsnbg',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Crossover', caption: ['Tops は左側(Left)のカップルと向き合い、Sides は右側(Right)のカップルと向かい合う', 'Advance & Retire を一度する(4 bar)', 'その後、Crossover で向き合っているカップルと位置を交換する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'The Square',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=OYjqZKTZrHY',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Dance the Square', caption: ['Leading Couple は右手を握り、前に進む(2 bar)', 'ジェントは反時計回りにレディーを回しながら、進んできた方向と逆側を向く。再び前へ進み(4 bar)', '先ほどと同じようにしてレディーを反時計回りに Turn させて元の位置へ戻る(2 bar)'], type: 'repeat' },
        { bar: 8, subject: '1st Top & opposite Couple', summary: 'Little Christmas', caption: ['Leading Couple とその opposite のカップルは Little Christmas する', 'Break するとき、それぞれのカップルは元の位置の一つ右側のカップルに並ぶように位置どる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line Adv-Ret & Circle→R', caption: ['2列に並んで Advance & Retire する', '最後の Retire のとき、列の端にいるジェンツはレディーの手を取って引きよせるようにしてから手を離す'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'The Star',
      rythmn: 'Reel',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=xr7FnGFQSII',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Gents & Lady', summary: 'Gents; Left Star, Ladies; move (cw)', caption: ['ジェンツは反時計回りに1と1/4周する', 'レディーは 2 bar その場で待ってから時計回りに3/4周する', 'ジェンツ、レディーともに一つ右隣の位置へ移動することになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Sevens',
      rythmn: 'Hornpipe',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=3cfJQgWDjA4',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Turn the L (×4, r.h.)', caption: ['Leading Couple のジェントとレディーは右手を握る', 'レディーは前へ進み左に折れる(2bar)', 'この動作を4回行って元の位置へ戻る', 'この間ジェントはレディーを時計回りに回しながら後ろに付いていくように動く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Sevens In, Out & House across', caption: ['Tops は左側(Left)のカップルと向き合い、Sides は右側(Right)のカップルと向かい合う', 'Sevens In, Sevens Out を一度行う(4 bar)', 'その後、House across で向き合っているカップルと位置を交換する(4 bar)'], type: 'repeat' },
        { bar: 72, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Metal Bridge Lancers':
  {
    name: 'Metal Bridge Lancers',
    jpCaption: 'メタル・ブリッジ・ランサーズ',
    level: 'advanced',
    county: ['Tipperary'],
    notices: 'このセットは2014年に作られ、2015年1月にTipperary州のNenaghのConnie Ryan Set Dance Weekendで発表された。Metal BridgeはDrumbaneとUpperchurchの間にある、私が育ったTipperary州の交差路近くにある。このセットは一時期Crossroads Dancersに人気があった。彼らはいつも日曜夜に集まってダンスをしていた。〜"Come West Along the Road", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/metlbr'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through & Line up',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=xUn5OKL6Z4k',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen holdでLead Aroundする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', caption: ['Leading CouplesはHouse insideする'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through & Line up', caption: ['oppositeのパートナーと右手でChainし(2 bars)', '自分のパートナーと左手でChainし(2 bars)', '向き合っているパートナーとRight hand Starする(4 bars)', 'LeadingでないカップルはそれぞれLeading Couples側でLine upする', 'Leading Couplesはそれぞれoppositeの位置へ移動したことになる'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Line, Adv-Ret', caption: ['ライン状になってAdvance & Retireする', 'Leadingでないカップルは最後の2 barsはRetireせずその場に留まる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Star twice',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=gdDBA3Oj1r0',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples Leading', summary: 'Star twice', caption: ['Leading Couplesはセットの中央でRight hand Starし、oppositeの位置へ行く(4 bars)', 'その後、それぞれ向き合っているパートナーとLeft hand Starし、Leading Couplesはセットの中央へ再び集まり、Little Christmasの形になる(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Little Chirstmas (basket)', caption: ['Leading CouplesはLittle Chirstmasする', 'ブレイクしたときはHome positionからoppositeの位置へ行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Corner House',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=InTxfsU0gEE',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples Leading', summary: 'Diamond Left & Pass back', caption: ['Leading Couplesはwaltz holdになりDiamond Leftでオポジットの位置へ行く(4 bars)', 'その後Pass throughで元の位置へ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples Leading', summary: 'House & Pass through & Back 2 back', caption: ['すべてのカップルはwaltz holdになる', 'Leading Couplesは左側のカップルと向き合いHouseする(4 bars)', 'その後Leading Couplesは向き合いPass throughする(4 bars)', '元の位置から一つ右側の位置へ移動したことになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Line up',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=e3ntYvAJpAo',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples Leading', summary: 'Star & Line up', caption: ['Leading Couplesはセットの中央でRight Hand Starでoppositeへ行く(4 bars)', 'その後、ホームポジションから一つ右隣のカップルとLeft Hand Starし、時計回りにTurnして、Leadingでないカップルの側で一列になる(4 bars)', 'Left Hand Starのとき、レディーはジェンツの前を歩く', 'Line upするとき、Leading Couplesはそうでないカップルの右側、LeadingでないカップルはLeading Couplesの左側になるようにする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Line Adv-Ret', caption: ['Line Advance & Retireする(4 bars)', 'その後、再びAdvanceし、ラインの外側にいるダンサーはoppositeのパートナーと向き合ったままその場に留まる', 'ラインの内側にいるダンサーはRetireする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', caption: ['2回目はTopsのポジションにいるカップルがLeading Couplesになる', '4回目はSidesのポジションにいるカップルがLeading Couplesになる'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Mixer',
      rythmn: 'Fling / Quadrilles',
      youtube: {
        url: 'https://www.youtube.com/watch?v=F6v2gaztx6Y',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', caption: ['waltz holdになり、Houseする'], type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies Star Chain', caption: ['すべてのレディーはセットの中央でRight Hand Starし、oppositeのジェンツとLeft Hand Starする(4 bars)', 'その後、レディーは同じ動作を繰り返してもとの位置へ戻る(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents Star Chain', caption: ['ジェンツはセットの中央でRight Hand Starし、oppositeのレディーとLeft Hand Starする(4 bars)', 'その後、もとの位置から一つ左隣のレディーとRight Hand Starし、そのままshoulder holdになる(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond', caption: ['新しいパートナーとshoulder holdで1-2, 1-2-3, back-2, 1-2-3でDiamondしてoppositeへ行く(4 bars)', '同じ動作を繰り返してもとの位置へ戻る(4 bars)', '元の位置に戻るとき、waltz holdに組み替える'], type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['パートナーと出会うまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Moycullen':
  {
    name: 'Moycullen',
    jpCaption: 'モイカレン',
    level: 'basic',
    county: ['Galway'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/moycul'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Square',
      rythmn: 'Reel',
      description: '2回目の繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる。Squareでは斜めにラインナップするバリエーションがあるそうです。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=M-lbIvQXQSs',
        start: 97
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (shoulder)', caption: ['すべてのカップルは右側を向いて反時計回りに Lead Around する', 'ジェンツはレディーの右肩越しに右手を握り、前側で左手を握る', '元の位置へ戻ってきたらジェンツは右手をレディーの頭上で回し、waltz hold になる'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', caption: ['Leading Ladiesはセットの中央で右手をとり、oppositeのジェントと左手をとって半周する', 'その後、oppositeのレディーと右肩ですれ違い、元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross) & Moves Left', caption: ['Leading Couples は手を繋いで Advance & Retire を一度行う', 'その後、手を離して左隣のカップルに向き合う', '最後の2barは全員その場でステップする'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Square to opposite Partners', caption: ['向き合ったカップルと Square する', '向かいのカップルとすれ違うときはレディーが内側、ジェンツが外側。自分のパートナーとすれ違うときはレディーが外側、ジェンツが内側', 'レディ−、ジェンツともに右肩 → 左肩 → 右肩 → 左肩ですれ違う', 'Leading Couples のレディーは Square で自分のパートナーの下へ帰らず元いた位置の opposite のジェンツの下へ向かう'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new Partners', caption: ['すべてのカップルはパートナーと Swing する', 'Leading Couples は opposite のパートナーと Swing する'], type: 'repeat' },
        { bar: 72, subject: 'Top - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Line up',
      rythmn: 'Reel',
      description: '1回目の繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる。レディーは時計回りに一つずつずれる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=M-lbIvQXQSs',
        start: 303
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (shoulder)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross) & Line up', caption: ['Leading Couples は手を繋いで Advance & Retire を一度行う', 'その後、手を離してジェンツが外側、レディーが内側になるように中央に一列で並ぶ'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Full Turn & Square In', caption: ['opposite のパートナーと右手を握ってその場で時計回りに一周する', '一周したら元の位置へは戻らず opposite へ向かう', 'その後、自分のパートナーと左肩ですれ違い、opposite のカップルと向き合う'], type: 'repeat' },
        { bar: 48, subject: 'Top - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Back to Back & Ladies; moves', caption: ['向き合っているパートナーと右肩→左肩ですれ違うように Back to Back する(4 bar)', 'その後、ジェンツはその場で待ち、レディーは Back to back したパートナーと右肩ですれ違い、一つ左側のジェントのところへ移動する(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Twirl',
      rythmn: 'Jig',
      description: '1回目の繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=M-lbIvQXQSs',
        start: 515
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'Ladies; Cross, Twirl', caption: ['Leading Couples のレディーは opposite のジェントのところへ向かう', 'ジェントとレディーは右手を取り合い、レディーは右手をジェントの頭上にかかげたままジェントの周りを時計回りに一周し、waltz hold になる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 48, subject: 'Top - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Ladies & Gents', summary: 'Wheel to opp. (L; cw→G; acw)', caption: ['レディーは右手を出して時計回りに Wheel して opposite のジェントのところへ向かう(4 bar)', 'ジェンツは左手を出して反時計回りに Wheel して自分のレディーのところへ向かう(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    },
    {
      order: 4,
      summary: 'Weave',
      rythmn: 'Polka',
      description: 'Diagonal Crossover するときは常に Tops Leading。Diagonal Crossover, Weaveではジェンツは時計回りに、レディーは反時計回りに一つずつ動いて一周する。自分のパートナーとホームポジションでSwingしたら終わり。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=M-lbIvQXQSs',
        start: 690
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Diagonal Crossover', caption: ['Top Ladies が右肩、Top Gents が左肩で Crossover する(4 bar)', '同じ動作を Sides が繰り返す(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Weave & Swing', caption: ['ジェンツは反時計回り、レディーは時計回りで右肩 → 左肩ですれ違う', 'このとき手は繋がない', '1/4移動したら Swing する', 'Swing の相手は自分のパートナーまたは元いた位置の opposite パートナーに限られる'], type: 'repeat' },
        { bar: 48, subject: 'Tops Leading', summary: '<<Repeat ×3>>', caption: '繰り返すときも順序は変わらず Tops → Sides の順', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', caption: ['自分のパートナーと向き合う', '右手→左手の順番でジェンツは反時計回りに、レディーは時計回りに Chain する', 'opposite の位置で自分のパートナーと再開したらその場で Dance する', '再び Chain で元の位置へ戻る'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Big Christmas' }
      ]
    }]
  },
  'Newmarket Meserts':
  {
    name: 'Newmarket Meserts',
    jpCaption: 'ニューマーケット・メザーツ',
    level: 'advanced',
    county: ['Cork'],
    notices: 'このセットは1992年にコーク州ニューマーケットで行われたWhit WeekendでJer McAuliffeによって伝えられた。This set was taught by Jer McAuliffe in Newmarket, County Cork on Whit Weekend 1992.〜"Come West Along the Road", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/newmar'
    },
    thumbnail: 'https://www.youtube.com/watch?v=8G0agr-Gx7U',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Swing the ladies',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', caption: ['すべてのカップルはopen holdで、3/4 Lead Aroundする(8 bars)', 'ジェンツはセットの中心を背中を向けてLead Aroundを終える、レディーはセットの中央を向く', 'すべてのカップルはセットの角へ向かってSlideし、時計回りに90度回転する、つまり、ジェンツがセットの中心を向き、レディーがセットの中心に背を向ける', 'その後、ホームポジションへ向かってSlideし、Homeを1回する(8 bars)', 'テキストにはスライドすると書かれているが、方向転換後はホームしながらもとの位置へ戻る、とワークショップでは教えられたそうです', 'All lead around three-quarter way,', 'with each gent\'s arm around the lady\'s waist and gents finish with their back to the centre,', 'ladies facing the gents in waltz hold(8 bars).', 'All couples now slide to the corner, turn clockwise slightly so that ladies\' backs are to the center, then slide towards their own positions and turn once in place(8 bars).'], type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'Figure in or House inside', caption: ['Leading CoupleはFigure InまたはHouse Insideする', 'First top couple figure in or house inside'], type: 'repeat' },
        { bar: 32, subject: 'Leading Couple', summary: 'Swing the ladies', caption: ['Leading GentはパートナーとSwingする', 'レディーはホームポジションから一つ左隣のジェントの隣へ行く', '新しいレディーは前に出てLeading Gentとwaltz holdになる', 'Leading Gentはレディーが交代しているとき、好きな方の足でバタリングする', '上記の動作を3回繰り替えす', 'Top gent swings his own partner,', 'then each of the other ladies in turn, starting with the lady on his left. He swings each lady (6 bars),', 'then she moves clockwise around him to the right side of the next gent, ', 'while the next lady moves out in front of the leading gent to face him in waltz hold (2 bars).', 'The gent batters while the ladies are moving.'], type: 'repeat' },
        { bar: 168, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', caption: ['すべてのカップルはSevens SquareでHouseする'], type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Swing in three',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'Figure in or House inside', caption: ['ホームポジションへ戻るとき、最後の2 barsで左隣のレディーを引き寄せ、Leading Gentは左手、Leading Ladyは右手をあげて輪に入れる', 'First top couple house inside, collecting the first side lady under their raised joined hands during the last turn.'], type: 'repeat' },
        { bar: 24, subject: 'Leading Couple', summary: 'Swing in three', caption: ['3人はSwing in threeする(6 bars)', '6 bars目で輪に引っかけていたレディーを離し、新しいレディーを輪に引っかける', 'Top couple swing in three in the centre for 6 bars with each lady in turn,', 'raising their joined hands to let her out from the swing,', 'then dancing on to collect the next lady during the last 2 bars.'], type: 'repeat' },
        { bar: 144, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Turn the lady',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=8G0agr-Gx7U',
        start: 41
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Figure in or House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Turn the lady', caption: ['Leading Gentはレディーと右手をとって時計回りに4回Turnさせる', 'その間、ジェントはその場でバタリングする', '2回目は1st Topと1st Side、', '3回目は1st Topと1st Sideと2nd Top、', '4回目は1st Topと1st Sideと2nd Topと2nd SideもレディーをTurnさせる', 'First top gent turns the lady clockwise four times, right hand in right, while he dances the battering steps on the spot.'], type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'High gates',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ZyxM8Nbq64c',
        start: 7
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Figure in or House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'High Gates', caption: ['Leading Gentはパートナーと左手を、ビジター・レディーと右手をとる。左腕が上、右腕が下。', 'Leading Ladyはアーチをつくり、ビジター・レディーはその下を通る(4 bars)。Leading Ladyはジェントの左側、ビジター・レディー側。', 'レディーはLeading Gentに向き合い、ジェントの腕の下でTurnする。', 'Leading Ladyは時計回り、ビジター・レディーは反時計回り', 'その間、Leading Gentはその場でステップし、右腕の下でTurnし、左手でLeading Ladyを引き寄せる(2 bars)', 'Leading Ladyはアーチの下を通って元の位置へ戻る', 'ビジター・レディーはセットの外側を通って元の位置へ戻る(2 bars)', 'Top gent takes his partner\'s left hand in left and first side lady\'s right hand in right to dance the high gates.', 'Top lady dances to face side couple and side lady comes under the arch (4 bars).', 'Then both ladies face the top gent and turn,', 'top lady clockwise and side lady anticlockwise while the gent steps between them turning anticlockwise under his own right hand, so that all face out (2 bars).', 'Top lady now dances under the arch across to her own place and top gent turns into place, as the side lady crosses outside him to join her partner (2 bars).'], type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Ducks',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Home & Line up', caption: ['Leading CouplesはHomeし、1st Topを先頭にラインナップする', 'このとき、間にカップルが入れるように間を開ける', 'Both top couples dance in place and line up facing first top position. They leave a space between them when lining up.'], type: 'repeat' },
        { bar: 8, subject: 'Sides', summary: 'Home & Line up', caption: ['残る2カップルもホームし、その後間に入るようにラインナップする', '1st Sideが1st Topの後ろ、2nd Sideが2nd Topの後ろへ行く', '1T - 1S - 2T - 2S の順', 'First side couple and second side couple dance in place moving into the line up, first side couple behind first top couple and second top couple behind second top couple.'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Ducks & Lead Around', caption: ['ジェンツはLeading Gentを先頭に反時計回りに、レディーはLeading Ladyを先頭に時計回りにダックする', 'このとき、ジェンツは内周り、レディーは外回りにダックする', 'パートナーと出会ったらopen holdになり、反時計回りにLead Aroundしてホームポジションへ戻る', 'Top gent dances around anticlockwise to the back followed by the other gents, while first top lady dances clockwise to the back, followed by the other ladies (4 bars).', 'Top gent now dances up the centre followed by the other gents(4 bars), while top lady continues clockwise in a circle around outside the gents, to meet, all couples lead around anticlockwise back to place.', 'The leading couple start down the centre inside the rest of the ladies, then continue around to place followed by the other couples (8 bars).'], type: 'common' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', caption: ['2回目のラインナップは 1S - 2T - 2S - 1T の順'], type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: '3 Quarter Lead Around', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Mixer',
      rythmn: 'Hornpipe',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Dance in', caption: ['Standing alone facing in, all dance in and back three times(6 bars),', 'then the gents dance in and back again,', 'while the ladies move on,', 'passing on the outside to the next gent on her right.'] },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['パートナーと出会うまで繰り返す', 'All couples repeat until ladies are back withe their own partners.'], type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Newport':
  {
    name: 'Newport',
    jpCaption: 'ニューポート',
    level: 'advanced',
    county: ['Mayo'],
    notices: 'このセットはMickey Kelly、Jon Joe Geraghty、Eamon ConnollyとMary Connolly、そしてNewport Dancersの手により再流行した。 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      'danceminder': 'https://danceminder.com/dance/show/newpor',
      'irishSetDancing': 'http://setdanceteacher.ie/newport.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Diagonal line',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hJ3IFZ5eEzI',
        start: 14
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross & back)', caption: ['すべてのカップルはcross handでAdvanceし、その場でステップする(4 bar)', 'その後Retireし、右側を向いて次のLead Aroundに備える(4 bar)'] },
        { bar: 8, subject: 'Everyone', summary: 'Slow Lead Around to opps.', caption: ['すべてのカップルはcross handで一つ隣のカップルの位置へ移動し、その場でステップする(4 bar)', 'その後、もう一つ隣のカップルの位置へ移動し、その場でステップする(4 bar)', 'このとき、レディーはセットの中央を、ジェンツはセットの外側を向く'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing', caption: ['すべてのカップルはSwingする(6 bar)', 'その後、再びcross handになる'] },
        { bar: 8, subject: 'Everyone', summary: 'Slow Lead Around to home' },
        { bar: 8, subject: '1st Top', summary: 'Adv & Steal the Lady', caption: ['Leading CoupleはRight hand in right、右手をとってAdvanceする(2 bar)', 'このとき、Leading Gentはoppositeのレディーの左手をとる', 'Leading Ladyはoppositeのジェントの左へ移動してLeading Gentと向き合う', '4人はその場でステップする(2 bar)', 'Leading GentはRetireし、Leading Gentが引く手に合わせてレディーはAdvanceする', 'Leading Gentは両手をそれぞれレディーの肩に回す(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: '3 & 1, Change the Lady', caption: ['Leading Gentとレディーの3人はAdvaneし、その場でステップする(4 bar)', 'その後、Leading GentとそのoppositeのレディーはRetireし、ジェントと向き合う(4 bar)', 'その間、Leading Ladyはoppositeのジェントの隣へ行く'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret to right (cross)', caption: ['Leading Couplesはcross handで右隣のカップルの方へAdvanceし、その場でステップする(4 bar)', 'このとき、4人が一直線になるように肩の向きを合わせる', 'その後、元の位置へ戻り、その場でステップする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret to left (cross)', type: 'repeat' },
        { bar: 8, subject: '1st Gent & opposite Lady', summary: 'Swing', caption: ['Leading GentとそのoppositeのレディーはSwingする(6 bar)', 'その後、元の位置へ戻る(2 bar)'], type: 'repeat' },
        { bar: 72, subject: '2nd Gent - 1st Gent - 2nd Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies; Half Chain (arm)', caption: ['Leading Ladiesはセットの中央で互いに右腕をとって時計回りに1周する', 'その後、oppositeのジェントと左腕をとって反時計回りに一周し、セットの中央でLittle Christmasの構えになる', 'このとき、oppositeジェントの左隣に来るようにする'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', caption: ['Leading Couplesの4人はSwing Fourする(6 bar)', 'その後、元の位置へ戻る(2 bar)'], type: 'repeat' },
        { bar: 16, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (cross)' }
      ]
    },
    {
      order: 2,
      summary: 'Gates',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hJ3IFZ5eEzI',
        start: 448
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R, left hand back)', caption: ['すべてのカップルはRight hand in right、右手をとってAdvanceし、その場でステップする(4 bar)', 'その後Retireし、ステップする(4 bar)', 'ジェンツは左手を腰に回して動く'] },
        { bar: 16, subject: 'Everyone', summary: 'Turn the Lady', caption: ['ジェンツはレディーの右手をとり、反時計回りにTurnさせながら、一つ左隣のカップルの位置へ移動する(4 bar)', 'その後、レディーの左手をとり、時計回りにTurnさせながら、もう一つ左隣のカップルの位置へ移動する(4 bar)', '同じ動作を2回繰り返して元の位置へ戻る(8 bar)', 'ジェンツは元の位置へ戻ったらセットの内側を通ってレディーの左側へ行く'] },
        { bar: 8, subject: 'Tops', summary: 'Slow Diamond to left (cross)', caption: ['Leading Couplesはcross handで左隣のカップルの方へAdvanceし、その場でステップする(4 bar)', 'その後、後ろ向きにoppositeの位置へ向かい、その場でステップする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slow Diamond to left (cross)', type: 'repeat' },
        { bar: 16, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Turn in place (acw)', caption: ['すべてのレディーは反時計回りにTurnしながらセットの中央に入り、自分のパートナーと向き合いcross holdになる(4 bar)', 'その後、パートナーとともにその場で反時計回りに2周する'] },
        { bar: 8, subject: 'Everyone', summary: 'Gents; Turn in place (cw)', caption: ['すべてのジェンツは時計回りにTurnしながらセットの中央に入り、自分のパートナーと向き合いcross holdになる(4 bar)', 'その後、パートナーとともにその場で時計回りに2周する'] },
        { bar: 16, subject: 'Tops', summary: 'Ladies Full Chain', caption: ['Leading Couplesのレディーはセットの中央へ集まり(2 bar)', '右腕をとりあってその場で1周する(2 bar)', 'その後、oppositeのジェントのところへ向かい(2 bar)', '左腕をとりあってその場で1周する(2 bar)', '以上の動作を繰り返して元の位置へ戻る(8 bar)'], type: 'repeat' },
        { bar: 16, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: '1st Top Leading', summary: 'Gates', caption: ['Leading Coupleはそれぞれ近い方の手をつなぐ', 'Leading Couplesはセットの中央へ向かってAdvanceし、4人でライン上になる', 'このとき、Leading Coupleがラインの中央に、oppositeのカップルはそれぞれLeading Coupleの外側に行く(2 bar)', 'oppositeのパートナーと空いている方の腕をつなぎ、その場でTurnする(2 bar)', 'その後、元の位置へ戻り、Turnし、セットの中央を向く(4 bar)'], type: 'repeat' },
        { bar: 24, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 32, subject: 'Everyone', summary: 'Grand Chain', caption: ['ジェンツは左、レディーは右を向いてChainする', '右腕一周Turnして前へ進み、左腕で一周Turnして前へ進みながら一つ隣の位置へ行く(8 bar)', 'この動作を4回繰り返して元の位置へ戻る', '元の位置へ戻ったらジェンツはレディーを時計回りにTurnさせる', 'このときジェンツ自身も時計回りにTurnして自分の位置へ行く'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R, left hand back)' }
      ]
    },
    {
      order: 3,
      summary: 'Sevens around',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hJ3IFZ5eEzI',
        start: 790
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'house' },
        { bar: 8, subject: 'Tops Gents\' Couple', summary: 'Long Sevens', caption: ['Leading Couplesはwaltz holdになり、oppositeへ向かってLong Sevensし、元の位置までLong Sevensで帰る', 'oppositeへ向かうときはジェンツが背中合わせ。元の位置へ向かうときはレディーが背中合わせになる'], type: 'repeat' },
        { bar: 8, subject: 'Tops Gents\' Couple', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Sides Gents\' Couple', summary: 'Long Sevens', type: 'repeat' },
        { bar: 8, subject: 'Sides Gents\' Couple', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', caption: ['レディーは右隣のジェンツのところへ行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'house', type: 'repeat' },
        { bar: 144, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Chain', caption: ['すべてのカップルはRight hand in right、右手同士をつないでAdvance & Retireを一回する(4 bar)', 'その後、右手→左手でChainし、元の位置へ戻る(12 bar)'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    }]
  },
  'North Kerry':
  {
    name: 'North Kerry',
    jpCaption: 'ノース・ケリー',
    level: 'beginner',
    county: ['Kerry'],
    notices: 'この有名なポルカセットの説明はBallybunion Set Dancersの方々が踊っているものを参考に書かれています。〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/nortke',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/NKERRY.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Wheel around',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=vP89HMa_9KE',
        start: 27
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Wheel (R→L)', caption: 'Leading Couples は Right Hand Star をする(4 bar)。その後、Left Hand Star で元の位置へ戻る(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'House inside',
      rythmn: 'Polka',
      description: 'Leading は時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の順。ただし、反時計回りに 1st Top - 1st Side - 2nd Top - 2nd Side の場合もある',
      youtube: {
        url: 'https://www.youtube.com/watch?v=YNH21eCbWFg',
        start: 30
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Slide In, Out & Home', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Slide & Change',
      rythmn: 'Slide',
      description: 'House がないバージョンもある。繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=dArn7fgnls4',
        start: 39
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', caption: ['Leading CouplesはwaltzホールドでSlide In, Slide Outし(4 bar)、Houseでoppositeへ行く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 120, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Wheel & Turn',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=s3qPQn-Z35o',
        start: 20
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Wheel & Turn', caption: 'すべてのレディーはセットの中央で Right Hand Star をして opposite のジェントのところへ向かう(2 bar)。その後、ジェントの左手の下で反時計回りに Turn する(2 bar)。その後、レディーはセットの中央で再び Right Hand Star をして、元の位置へ戻って waltz hold になる(4 bar)。ジェンツはレディーを Turn させるとき自分は Turn しない', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Mixer',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=YQovCNGTruk',
        start: 22
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body (Hop 123, Stamp 123)' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 16, subject: 'Everyone', summary: 'Ladies; moves→1/4R & 3/4 Body', caption: ['すべてのジェンツはBalanceする(2 bar)', 'その間、レディーは一つ右側のジェントのところへ向かう', 'それぞれwaltz holdになり、一つ右側の位置へ1/4 Houseする(2 bar)', 'その後、3度Bodyをして、各ジェントが元いた位置へ戻る(12 bar)', '"Balance"とは相手に近づいて離れること'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Old Mill Lancers':
  {
    name: 'Old Mill Lancers',
    jpCaption: 'オールド・ミル・ランサーズ',
    level: 'advanced',
    county: ['Tipperary'],
    notices: 'この新しいセットは2019年1月のティペラリー州ネナーで行われたConny Ryan Dance Festivalで発表された。1st Sideは1st Topの左側。This new set was presented at the Connie Ryan Dance Festival in Nenagh, County Tipperary in January 2019. First side couple are on the left of first top couple.〜Conny Ryan Dublin Dancing 2019のワークショップより。',
    referenceSite: '',
    thumbnail: '',
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Swing Four',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=nCo3AqJd494',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは両手をつないでLead Aroundする', '最後の2 barsでジェンツは両手でレディーを時計回りにまわす'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Pass through', caption: ['Topsは左側、Sidesは右側のカップルと向き合う、すべてのカップルはwaltz holdになり、Adv-Retする(4 bars)', 'その後、レディーを内側にしてPass throughする(2 bars)', 'ジェンツはopen waltz holdのように右手をレディーの腰にまわし、もう一つ隣のカップルに向かって進む(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing Four × 2', caption: ['Topsは左側、Sidesは右側のカップルとSwing Fourする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Lancers',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Sides - Tops の順で Leading Couples が入れ替わる。1,2回目はTopsの位置にいるカップルから、3,4回目はSidesの位置にいるカップルから動き始める。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=npW2axtifPk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (waltz) & Pass through', caption: ['Leading Couplesはwaltz holdになり、Adv-Retする(4 bars)', 'その後、レディーを内側にしてPass throughする(2 bars)', '自分のパートナーとすれ違うときもレディーを内側にしてすれ違う', '反対側まで進んだらパートナーと向き合い、右肩同士、ジェンツを外側にしてすれ違う、ジェンツは時計回り、レディーは反時計回りにターンしてオポジットのカップルに向き合う(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (waltz) & Pass through → Line up', caption: ['Leading Couplesはwaltz holdになり、Adv-Retをして、Pass throughする(6 bars)', 'Leading Gentsはパートナーとすれ違い(2 bars)、そのまま向き合っているレディーと右手をとって反時計回りにターンさせながら、レディーの右側へ移動しラインナップする(2 bars)', 'Leading Ladiesは向き合っているジェンツの腕の下で反時計回りにターンしてラインナップする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret', caption: ['ラインナップしてAdvance & Retireする(6 bars)', '最後の2 barsでラインの端にいる4人はRetireせずにその場に残る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new Partner', type: 'repeat' },
        { bar: 96, subject: 'Sides - Sides - Tops', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Star',
      rythmn: 'Reel',
      description: 'Tops Leadingのときは時計回りに、Sides Leadingのときは反時計回りに位置を交換する',
      youtube: {
        url: 'https://www.youtube.com/watch?v=lfAjNsUkCA8',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Pass through', caption: ['Leading Couplesは左側のカップルに、Leading Couplesでないカップルは右側のカップルに向き合う', 'すべてのカップルはright hand in right、右手同士をつないでAdv-Retする(4 bars)', 'その後、レディーを内側にしてPass throughし、ジェンツは右手で反時計回りにレディーをTurnさせる(4 bars)', 'Leading Gentsでないジェンツは、レディーをTurnさせながら、自分はパートナーの周りを時計回りにまわる'], type: 'nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Turn around & Star/Swing', caption: ['Leading Couplesはセットの中心でジェンツが前にくるようにRight hand Starする(6 bars)', '1周したらジェンツは右手で反時計回りにレディーをTurnさせ、左側のカップルに向き合う(2 bars)', 'その間、Leading Couplesでないカップルはその場でSwingする'], type: 'nested-repeat' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat ×2>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Pass through', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 72, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Leave the Partner',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 1st Side - 2nd Top - 2nd Side の順で Leading Couples が入れ替わる。Line up、1st TopがLeadingのときは 1st Top - 1st Side - 2nd Top - 2nd Side の順になる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hXb4V2lea2U',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around & Face the wall', caption: ['Leading Couplesはopen waltz holdになり、セットの中心を時計回りにLead Aroundし、Leading Coupleの位置でLine upする(8 bars)', 'Leading Couplesでないカップルは2 bars待って、自分たちの右側のカップルの後ろについてLead Aroundする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Cast off & Leave the partner', caption: ['パートナーと別れるようにして、ジェンツは反時計回り、レディーは時計回りに列の最後尾へ向かう', 'パートナーと再会したら近い方の手をとり合い、手を離してLeading Couplesでない位置でLine upする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv & Face the wall', caption: ['手を繋いでAdvance & Retireを1回する(4 bars)', 'その後、手を離して右手をあげてパートナーと手を合わせてその場で半周Turn aroundする(2 bars)', 'ジェンツはレディーの後ろに回りこみながら、レディーを反時計回りにTurnさせて、Leading Coupleの向きに再びFace the wallする(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen waltz holdでLead Aroundし、home positionへ戻る'], type: 'repeat' },
        { bar: 120, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Gents/Ladies Star',
      rythmn: 'Hornpipe',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=TCz9FlV5T2w',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Face the Corner & Turn/Star', caption: ['Corner Partnerに向き合い、右手をあげてその場でDance aroundする(2 bars)', 'その後、すべてのジェンツはセットの中心でLeft hand Starで、元の位置からoppositeへ行く(2 bars)', 'その後、右手をあげてDance aroundして、レディーを反時計回りにTurnさせてセットの中心を向く(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', caption: ['2回目と4回目は左手でDance aroundを始めて、レディーがStarする', '3回目は右手でDance aroundを始めて、ジェンツがStarする'], type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Paris':
  {
    name: 'Paris',
    jpCaption: 'パリス',
    level: 'basic',
    county: ['Clare'],
    notices: 'このセットはクレア州のラバシーダ地方のセットで、ラバシーダ出身のダンシングマスターDan Fureyにより伝えられた。This set comes from the Labasheeda are of County Clare. It was taught by Dance Master Dan Furey, who lived in Labasheeda.〜"Toss The Feathers", Pat Murphyより抜粋。ReelのフィガーではClare Reel Stepで、JigのフィガーではDown Jigで踊る。"Set Left, Set Right"では別バージョンもある。レディーは時計回りにTurnしてセットの外側を向き、ジェンツは時計回りにTurnしてセットの外側からレディーと向き合う。元の位置へ戻るときはジェンツがセットの外側を向き、レディーがセットの内側を向くようにして向き合ってからHomeする。また2001年11月のWexford workshopでMick Mulkerrinが教えたバージョンもある。レディーはその場で一周し、ジェンツは一つ左隣のジェントがいた場所へ時計回りにまわりながら移動し、Homeは1回する、戻るときは同様の動きでホームポジションへ戻る。The Clare style reel step is used for all the reels and the ‘down’ jig step for the jig. Another way of dancing the Set left, set right is for the ladies to turn clockwise to face out of the set and the gents to dance outside to face them, turning clockwise, before new couples dance at home. They finish in the same position before dancing back to their own partners, but this time the gents face out and the ladies in to start the dance at home. Yet another way was taught by Mick Mulkerrin at his Wexford workshop in November 2001. He had the ladies dancing a full turn in place while the gents dance inside them into the place of the gent on their L, turning clockwise one full turn as they go. The same 2 bar movement is danced back to place. Mick would also have couples dance one turn only when dancing in place.〜setdanceteacherより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/parise',
      irishSetDancing: 'http://setdanceteacher.ie/PARIS.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Set Left & Right',
      rythmn: 'Reel',
      description: 'Leadingは1st Top - 2nd Top - 1st Side - 2nd Sideの順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rFyAgHAkfpw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは cross hand で Lead Around する(8 bar)。', '一周して元の位置へ戻ってきたらジェンツは両手でレディーを時計回りにTurnさせる。'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Left & Home', caption: ['すべてのジェンツは時計回りにTurnして左隣のレディーに向き合う(2 bar)', 'その間レディーはその場で時計回りにTurnする', 'その後、新しいパートナーとHome twiceする(6 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Right & Home', caption: ['すべてのジェンツは時計回りにTurnして自分のパートナーに向き合う(2 bar)', 'その間レディーはその場で時計回りにTurnする', 'その後、Home twiceする(6 bar)'], type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Wheel around',
      rythmn: 'Reel',
      description: 'Leadingは1st Top - 2nd Top - 1st Side - 2nd Sideの順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=eLVvjy6Q7XA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', caption: ['8 bars目に全員で手を叩く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Wheel around', caption: ['ジェンツはRight hand star(4 bar)、Left hand starで元の位置へ戻る(4 bar)', 'レディーはセットの外側を反時計回りに4 bars歩いて反対側まで行き、時計回りに4 bars歩いて元の位置まで戻る', '偶数回は男女が入れ替わる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Left & Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Right & Home', type: 'repeat' },
        { bar: 144, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', caption: ['1回目と3回目はジェンツがWheelし、レディーがセットの外側を歩く', '2回目と4回目はレディーがWheelし、ジェンツがセットの外側を歩く'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'House the Ladies',
      rythmn: 'Reel',
      description: 'Leadingは1st Top - 1st Side - 2nd Top - 2nd Sideの順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ZJHtYoaS_AI',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Gent', summary: 'House inside', caption: ['Leading GentはHouse insideする(6 bars)', 'その後、パートナーを彼女のホームポジションへ残し、時計回りにTurnして一つ左側のカップルの間へ移動する(2 bars)', 'ジェントが移動しているとき、新しいレディーは前に出てジェントと向き合う'], type: 'nested-repeat' },
        { bar: 24, subject: 'Leading Gent', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Left & Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Right & Home', type: 'repeat' },
        { bar: 192, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'All Ladies Chain',
      rythmn: 'Jig',
      description: 'Down Jig。All Ladies ChainはTops - Sides - Tops - Sidesの順でLeading Coupleが入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=D2BLBdyIjPc',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'All Ladies Chain (underarm)', caption: ['Leading Ladiesはoppositeのレディーと右手でChainし、oppositeのジェントと左手でChainし、oppositeのレディーと右肩ですれ違って元の位置へ戻る', 'Leading Gentsはoppositeのレディーが来たときはレディーが腕の下を通るように左手で時計回りにTurnさせながら自身も反時計回りにTurnする', 'Leading CouplesでないレディーはLeading Coupleの2 bars後にLadies Chainを始める'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Left & Home', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Set Right & Home', type: 'repeat' },
        { bar: 144, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', caption: ['All Ladies Chainは1回目と3回目はTops LadiesがLeading', '2回目と4回目はSides LadiesがLeading'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'March',
      rythmn: 'Hornpipe & March',
      description: 'Line upするときは、1st Top - 1st Side - 2nd Top - 2nd Sideの順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pNRsrqqCDZA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Chain & Home', caption: ['自分のパートナーと向き合い、右手→左手の順でChainする(12 bar)', '元の位置へ戻ってきたらHomeする(4 bar)'] },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', caption: ['Leading CoupleはHouse insideする', 'Houseを終えてホームポジションへ戻るとき、セットの外側を向く', 'ジェントは左側、レディーは右側になるようにする', 'このとき、セットの中心に少し寄る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House around', caption: ['Leading Coupleを除くすべてのカップルはLeading Coupleの周りをHouse aroundし、Leading Coupleの後ろに連なる', '順番は常に1st Top - 1st Side - 2nd Top - 2nd Sideの順'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Cast off & March', caption: ['Leading Couple は自分のパートナーと離れるようにしてマーチのリズムで列の最後尾へ移動する(4 bars)', 'その他のカップルも同様にして移動する', 'パートナーに出会ったらopen waltz holdになる', 'その後、左側へ進んで再びセットの中央へ戻り(2 bars)、ホームポジションへ向かう(2 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Plain':
  {
    name: 'Plain',
    jpCaption: 'プレーン',
    level: 'basic',
    county: ['Clare'],
    notices: 'これはWest Clare Plain Setの最も人気のあるリール・セットのバージョン。このセットはもとはポルカとして踊られていた。Plain Reel Setとも呼ばれる。〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/clarpl',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/CLAREP.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=pbNoM0oNJ0c',
        start: 38
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは cross hand で Lead Around する(8 bar)。', '一周して元の位置へ戻ってきたらジェンツは両手でレディーを時計回りにTurnさせる。'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Pass through (underarm)', caption: ['Leading Couples は右肩で opposite のパートナーとすれ違う(2 bar)', 'ジェンツは自分のレディーと向き合ったら、レディーが腕の下を通るように右手で反時計回りに Turn させながら位置を交換する(2 bar)', 'その後、同じ動作を繰り返して元の位置へ戻る', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (underarm)', caption: ['Leading Couples のレディーは opposite のレディーと右手で Chain し opposite のジェントと左手で Chain し、opposite のレディーと右肩ですれ違って元の位置へ戻る', 'ジェントは opposite のレディーが来たときはレディーが腕の下を通るように左手で時計回りに Turn させながら自身も反時計回りに Turn する', '自分のレディーが来たときは右手で反時計回りに Turn させる'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead across & Pass back', caption: ['Leading Couples は反時計回りに Lead Around する(2 bar)', 'ジェントはレディーを腕の下で時計回りに Turn させ、中央を向く(2 bar)', '握っていた手を離して Pass through の後半 4 bar の動作を続ける'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Turn the Lady',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=9DN_kIUtUio',
        start: 25
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, turn ↑', caption: ['Leading Couples は右手をとって Advance & Retire を一度する(4 bar)', 'その後 Leading Gents は自分のレディーを右手で時計回りに1と1/2回転させながら、opposite のジェントと左肩ですれ違い、中央を向く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, turn ↓', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', caption: '2回目、4回目の Home は all couples で行う', type: 'repeat' },
        { bar: 72, subject: 'Tops - Sides -Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Chase the Lady',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops が2回行い、全員で Home をしたら Sides Leading',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IKzund8tmyw',
        start: 38
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Crossover & Home', caption: 'Ledaing Lady は opposite のレディーと左肩ですれ違いながら、opposite のジェントのところへ行き(2 bar)、Home する(6 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Chase & Turn R1L2', caption: ['Ledaing Gent は自分のレディーを opposite へ追いかけ、右手で反時計回りにレディーを回す(2 bar)', 'その後、左手で時計回りにレディーを2回 Turn させながら位置を交換する(4 bar)', 'このときジェンツはセットの内側、レディーはセット外側になるようにして移動する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (cross)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (waltz) & House across', caption: ['Leading Couples は waltz hand で Advance & Retire を一度する(4 bar)', 'その後、House across で元の位置へ戻る(4 bar)'], type: 'repeat' },
        { bar: 32, subject: 'Tops', summary: '<<Repeat>>' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 64, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Three & One',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる。ジェンツは Three & One で、1人のときはバタフライ。3人のときは平泳ぎ',
      youtube: {
        url: 'https://www.youtube.com/watch?v=4zKyiyT8-VE',
        start: 54
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (underarm)', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Home', type: 'nested-repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', caption: ['Leading Couple は House inside する(6 bar)', 'Lading Gent は House を終えるとき、自分のレディーを opposite Gent のそばに置く', 'オポジットのジェントは左手で左の Leadign Lady の左手を、右手で自分のレディーの右手をとる', 'レディーは手をクロスさせることになるが、このときジェント側の手を下から出す'], type: 'nested-repeat' },
        { bar: 16, subject: 'Tops', summary: 'Three & One', caption: ['列になった3人は Advance, Retire, Advance する(6 bar)', 'その間、Leading Gent は一緒に Retire, Advance, Retire する', '3人が2回目に Advance したあと、Leading Gent はレディーを Turn し、反転させる', 'レディーは Leading Gent のそばへ移動する(2 bar)', 'これらの動作は手は握ったままで行う', 'これらの動作を二度行ったら4人で円になり、Little Christmas の構えになる', '手は隣の人の背中に回して、向かい合った人と手をつなぐ'], type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'nested-repeat' },
        { bar: 48, subject: '2nd Top Leading', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (underarm)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 112, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Gallop',
      rythmn: 'Rising Jig',
      description: 'フィガー5のみ Lead Around の後に Swing をする。Gallop, Double Ladies Chain は Leading Ladies がいるカップルから始める。レディーは反時計回りに一つずつ隣のジェントへずれていく。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=WZ7g79-YtAM',
        start: 37
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Gallop', caption: ['すべてのカップルは waltz hold になる', 'Leading Lady がいるカップルからセットの中心を横切るようにして opposite へ行く(2 bar)。このとき、ジェンツが背中合わせになるように移動する', 'その後、Leading Lady がいないカップルも Gallop する(2 bar)', '同じ動作を繰り返して元の位置へ戻る(4 bar)', '戻るときはレディーが背中合わせになるように移動する'], type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Double Ladies Chain', caption: ['Leading Lady は右手→左手で Ladies Chain する', 'Leading Lady が opposite Gent と Chain してセットの中心へ戻ろうとするとき、Leading でないレディーも Ladies Chain を始める', 'ジェントは opposite のレディーが来たときはレディーが腕の下を通るように左手で時計回りに Turn させながら自分の左側のジェントのもとへ促す。このとき、自身も反時計回りに Turn する', 'ジェンツは右側のジェントのところからレディーが来たときは右手で反時計回りに Turn させる', 'すべてのレディーは元いた位置から一つ右のジェントのところへ行くことになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Top Ladies Leading', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: 'Top LadiesがいるカップルからGallop, Double Ladies Chainする' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'Ladies In',
      rythmn: 'Reel',
      description: 'レディーは反時計回りに一つずつ隣のジェントへずれていく。自分のパートナーと出会うまで繰り返す',
      youtube: {
        url: 'https://www.youtube.com/watch?v=UMl3qVciqKM',
        start: 42
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Gents & Ladies', summary: 'G; Star (R→L); L; moves→1/4R', caption: ['ジェンツは 4 bar 右手を挙げて時計回りに Star をし、4bar 左手を挙げて反時計回りに Star をして元の位置に戻る', 'レディーは 4 bar 後に自分の一つ右側のカップルの位置へ移動し新しいジェンツと向き合いwaltz holdになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 120, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['ジェンツは1回目と3回目は右手Star、2回目と4回目は左手Starから始める'], type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Plain Polka':
  {
    name: 'Plain Polka',
    jpCaption: 'プレーン・ポルカ',
    level: 'beginner',
    county: ['Clare'],
    notices: '西部クレア州のプレーン・セットは元来クレア州のポルカで踊られていた。ジェンツはポルカのフィガーではバタリング・ステップする。〜"Toss The Feathers", Pat Murphyより抜粋。最後のHouseの時のステップはPolka StepではなくReel Step',
    referenceSite: {
      irishSetDancing: 'http://setdanceteacher.ie/POLPLAIN.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Crossover',
      rythmn: 'Polka',
      description: 'フィガー1はバリエーションがいくつかある。繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=4sZ_3LrYkVI',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは cross hand で Lead Around する(8 bar)。', '一周して元の位置へ戻ってきたらジェンツは右手でレディーを時計回りにTurnさせ、waltz holdになる。'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Square or Crossover', caption: ['（Squareの場合）Leading Couples は右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違う(4 bar)', 'その後、再び右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違い、元の位置へ戻る(4 bar)', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く', '（Crossoverの場合）Leading Ladiesは右肩ですれ違いoppositeの位置へ行く(2 bar)', 'その後、Leading Gentsは右肩ですれ違いoppositeの位置へ行く(2 bar)', '反対側へ行ったらパートナーの側を向くようにして反転する', '同じ動作を繰り返して元の位置へ戻る(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', caption: ['Leading Ladiesはoppositeのレディーと右手でChainし', 'oppositeのジェントと左手でChainし、', 'oppositeのレディーと右手でChainして元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead across & Square In or Cross back', caption: ['Leading Couplesはcross handになり、反時計回りに Lead Around する(2 bar)', 'ジェントはレディーを腕の下で時計回りに Turn させ、中央を向く(2 bar)', 'その後、Square Inする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Turn the Lady',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=tGEnHtuIyIw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, turn ↑', caption: ['Leading Couples は右手をとって Advance & Retire を一度する(4 bar)', 'その後 Leading Gents は自分のレディーを右手で時計回りに1と1/2回転させながら、opposite のジェントと左肩ですれ違い、中央を向く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret, turn ↓', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', caption: '2回目、4回目の Home は all couples で行う', type: 'repeat' },
        { bar: 72, subject: 'Tops - Sides -Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Dance around',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops が2回行い、全員で Home をしたら Sides Leading',
      youtube: {
        url: 'https://www.youtube.com/watch?v=wRkJa_cDg_4',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: '1st Lady & opposite Gent', summary: 'Dance around', caption: ['Leading Ladyとoppositeのジェントは右肩同士ですれ違い、反対側まで行ったら時計回りにTurnする(4 bar)', '同じ動作を繰り返す(4 bar)'], type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Wheel & Lead across', caption: ['Leading Ladyとoppositeのジェントは左手をとり、反時計回りに一周する(4 bar)', '自分のパートナーの近くへ行ったらパートナーの右手をとり、反対側まで連れて行く(2 bar)', '反対側まで行ったらLeading GentはレディーをTurnさせる(2 bar)', 'その後、自分のパートナーと会釈する'], type: 'nested-repeat' },
        { bar: 8, subject: '1st Lady & opposite Gent', summary: 'Adv-Ret', caption: ['Leading LadyとoppositeのジェントはAdvance & Retireを2回する(8 bar)', '2回目にAdvanceしたとき、oppositeのパートナーと会釈する'], type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Sevens In, Out & Sevens across', caption: [], type: 'nested-repeat' },
        { bar: 32, subject: 'Tops', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 72, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Three & One',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides の順で Leading Couples が入れ替わる。ジェンツは Three & One で、1人のときはバタフライ。3人のときは平泳ぎ',
      youtube: {
        url: 'https://www.youtube.com/watch?v=M2fSff77LUQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (under)', type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'nested-repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', caption: ['Leading Couple は House inside する(6 bar)', 'Lading Gent は House を終えるとき、自分のレディーを opposite Gent のそばに置く', 'オポジットのジェントは左手で左の Leadign Lady の左手を、右手で自分のレディーの右手をとる', 'レディーは手をクロスさせることになるが、このときジェント側の手を下から出す'], type: 'nested-repeat' },
        { bar: 16, subject: 'Tops', summary: 'Three & One', caption: ['列になった3人は Advance, Retire, Advance する(6 bar)', 'その間、Leading Gent は一緒に Retire, Advance, Retire する', '3人が2回目に Advance したあと、Leading Gent はレディーを Turn し、反転させる', 'レディーは Leading Gent のそばへ移動する(2 bar)', 'これらの動作は手は握ったままで行う', 'これらの動作を二度行ったら4人で円になり、Little Christmas の構えになる', '手は隣の人の背中に回して、向かい合った人と手をつなぐ'], type: 'nested-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'nested-repeat' },
        { bar: 48, subject: '2nd Top Leading', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 104, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Gallop',
      rythmn: 'Jig',
      description: 'Gallop, Double Ladies Chain は Leading Ladies がいるカップルから始める。レディーは反時計回りに一つずつ隣のジェントへずれていく。PlainSet フィガー#5からSwingを抜いたもの',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rUtRzGMaOV0',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Gallop', caption: ['すべてのカップルは waltz hold になる', 'Leading Lady がいるカップルからセットの中心を横切るようにして opposite へ行く(2 bar)。このとき、ジェンツが背中合わせになるように移動する', 'その後、Leading Lady がいないカップルも Gallop する(2 bar)', '同じ動作を繰り返して元の位置へ戻る(4 bar)', '戻るときはレディーが背中合わせになるように移動する'], type: 'repeat' },
        { bar: 8, subject: 'Top Ladies Leading', summary: 'Double Ladies Chain', caption: ['Leading Lady は右手→左手で Ladies Chain する', 'Leading Lady が opposite Gent と Chain してセットの中心へ戻ろうとするとき、Leading でないレディーも Ladies Chain を始める', 'ジェントは opposite のレディーが来たときはレディーが腕の下を通るように左手で時計回りに Turn させながら自分の左側のジェントのもとへ促す。このとき、自身も反時計回りに Turn する', 'ジェンツは右側のジェントのところからレディーが来たときは右手で反時計回りに Turn させる', 'すべてのレディーは元いた位置から一つ右のジェントのところへ行くことになる'], type: 'repeat' },
        { bar: 72, subject: 'Top Ladies Leading', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: 'Top LadiesがいるカップルからGallop, Double Ladies Chainする' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 6,
      summary: 'The Labasheeda',
      rythmn: 'Fling',
      description: '120 barsのバージョン',
      youtube: {
        url: 'https://www.youtube.com/watch?v=q9F_SNEoYm0',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', caption: 'Slide in, Slide out, double Home & Slide in, Slide out, double House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', type: 'repeat' },
        { bar: 4, subject: 'Tops', summary: 'Turn w/opposites', caption: '中央に集まり、向かいのパートナーと左腕をつかんで Turnして元の位置へ戻る(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Double', caption: 'Leading Couples は House し(6 bar)、最後の 2 bar は Double する', type: 'repeat' },
        { bar: 84, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'The Labasheeda',
      rythmn: 'Fling',
      description: '136 barsのバージョン',
      youtube: {
        url: 'https://www.youtube.com/watch?v=q9F_SNEoYm0',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', caption: 'Slide in, Slide out, double Home & Slide in, Slide out, double House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', type: 'repeat' },
        { bar: 4, subject: 'Tops', summary: 'Turn w/opposites', caption: '中央に集まり、向かいのパートナーと左腕をつかんで Turnして元の位置へ戻る(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Double', caption: 'Leading Couples は House し(6 bar)、最後の 2 bar は Double する', type: 'repeat' },
        { bar: 84, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'The Labasheeda',
      rythmn: 'Fling',
      description: '168 barsのバージョン。Labasheeda Setのフィガー#6と一緒',
      youtube: {
        url: 'https://www.youtube.com/watch?v=q9F_SNEoYm0',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', caption: 'Slide in, Slide out, double Home & Slide in, Slide out, double House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Home, Slide & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Turn w/opposites, Slide & Home', caption: ['中央に集まり、向かいのパートナーと左腕をつかんで Turnして元の位置へ戻る', 'その後 double Home'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House & Double', caption: 'Leading Couples は House し(6 bar)、最後の 2 bar は Double する', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 7,
      summary: 'Changeover',
      rythmn: 'Hornpipe',
      description: 'レディーは反時計回りに一つずつ隣のジェントへずれていく。自分のパートナーと出会うまで繰り返す。Labasheedaと一緒。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=HCwghkmSwNE',
        start: 42
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Changeover', caption: ['Hop-in-two-three, Hop-out-two-three(2 bar)', 'レディーは Turn しながら中央に集まって一つ右側へ移動', 'ジェンツは Turn してその場で待つ'], type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' }
      ]
    }]
  },
  'Rahan':
  {
    name: 'Rahan',
    jpCaption: 'ラハン',
    level: 'advanced',
    notices: 'Rahanはオファリー州のタラモアからおよそ8kmほど離れたClodagh川の河畔に位置する。すぐ近くに修道院を設立したSt Carthageと歴史的に関わりがある。このセットはComhaltas Ceoltóirí Éireann(CCÉ)のRahan支部の創立20周年を記念してBarbara Gaffeyにより作られた。Rahan CCÉはCCÉが設立されてすぐの1950年から活動しており、1995年11月にRahanのGAAホールで再設立された。Swingはすべてwaltz holdで行う。〜"Come West Along the Road", Pat Murphyより抜粋。',
    county: ['Offaly'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/rahans'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Ladies move',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=6Icewep_8ug',
        start: 37
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Adv-Ret & Move', caption: ['すべてのレディーはセットの中心に向かってAdvance & Retireする(4 bars)', 'その後もう一度Advanceし、時計回りにTurnして元いた位置の一つ右隣のジェントに向き合う(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['自分のパートナーのところへ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Gents move',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Gents; Adv-Ret & Move', caption: ['すべてのジェンツはセットの中心に向かってAdvance & Retireする(4 bars)', 'その後もう一度Advanceし、反時計回りにTurnして元いた位置の一つ左隣のレディーに向き合う(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['自分のパートナーのところへ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Change Partners',
      rythmn: 'Slide',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Adv-Ret, Gents; Move', caption: ['すべてのカップルはセットの中心に向かってAdvanceし、時計回りに90度Turnし、セットの外側に向かってAdvanceし、Homeする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['元いた位置へ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Both move',
      rythmn: 'Reel',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Adv-Ret & Move', caption: ['すべてのレディーはセットの中心に向かってAdvance & Retireする(4 bars)', 'その後もう一度Advanceし、時計回りにTurnして元いた位置へ戻る(4 bars)', '最後の4 barsで、ジェンツは元いた位置の一つ左隣へ移動し、時計回りにTurnして新しいパートナーと向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['自分のパートナーのところへ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Rinkinstown':
  {
    name: 'Rinkinstown',
    jpCaption: 'リンキンスタウン',
    level: 'advanced',
    county: ['Louth'],
    notices: 'John McEvoy（動画左のジェント）さんが奥さまのSheilaさんやシャンノースダンサーのMairéad Devane（動画右のレディー）さんと2012年に創作した4つのFiguresで成るセット。Johnさんは2017年にはRinkinstownの近くのTermonfeckinのセット（Termonfeckin Lancers）も作った「カウンティ・ラウズ地元愛」にあふれたダンサーです。このセットは現在ではアイルランド東部のケーリーで定番セットです。コツをつかむまではややこしいThe Duck（アヒル）の動きが面白いですね。〜Comhaltas Japanメーリスより',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/rinkin'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Steal the Gent',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Top - Sides の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=HeiighReebc',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House across' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House across' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Couples', summary: 'Do-se-do & Turn', caption: 'Leading Couples はそれぞれ右肩ですれ違い、後ろ向きに左肩ですれ違って元の位置へ戻る。元の位置へ戻ったら自分のパートナーと右手をつないで Turn する', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Dance Circle & Chirstmas', caption: 'Leading Couplesは中央で 4 bar 時計回りで回り、残りの 4 bar を Little Christmas する', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain & Steal the Gent', caption: 'レディーは Ladies Chain で opposite のジェンツのところへ行き、そのままジェンツを連れて元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Flirtation',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=JLvJD53UJjo',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House across' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House across' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain & Steal the Gent', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain & Steal the Gent', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Flirtation', caption: 'Leading Gent とその opposite の Lady は互いに向き合いながら時計回りに1周する', type: 'nested-repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing', type: 'nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Lead over', caption: 'Leading Couples は Advance & Retire を一度した後、レディーはジェンツを opposite へ連れて行く', type: 'nested-repeat' },
        { bar: 24, subject: '2nd Top Gent Leading', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'The Ducks',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Tops - 1st Sides - 2nd Top - 2nd Sides の順で Leading Couple が入れ替わる。2nd Top Lady / 2nd Side LadyはDuckを一度もLeadingしない',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Ug8RXgGfvMk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Couples', summary: 'Pass through', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lines Adv-Ret', caption: ['Leading Couplesでないカップルは別れ、それぞれ近くのLeading Couplesの隣へ移動し、ライン状になる', 'Advance & Retireを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ducks', caption: ['Leading Couplesの男女はそれぞれ近くの Side Couples の方へ向かい、Sides Couples がいる場所で4人のグループを2つ作る', 'Leading Gentがいる側の4人は反時計回りに、Leading Ladyがいる側の4人は時計回りにDuckする', '各グループの残りの3人はLeading Gent/Ladyについて行く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: '2 Christmas & take Ladies', caption: ['4人のグループでそれぞれ Little Christmas を 6 bar する', '最後の 2 bar で、Leading Gentsは元いた位置の opposite のレディーを連れて元の位置へ戻る'], type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Steal the Lady',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=AC6UYPEMF2k',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (shoulder)', caption: ['左手はつながない'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv & L; moves→R & Steal the Lady', caption: 'すべてのカップルは Advance し、各ジェンツは自分の左隣のレディーを右手で引きよせる。ジェンツはそのまま右手をレディーの肩にかけて opposite の位置まで Lead Around する', type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Clover Leaf', caption: 'Tops は自分たちの左側のカップルに向き合い、Sides は自分たちの右側のカップルに向き合う。各カップルは自分のパートナーと右手をとって Advance & Retire を1回する。その後 Ladies Chain をするようにレディーは向かい合っているジェントの方へ向かう。向き合っていたジェントと出会ったら左手をつないで Turn し元の位置へは戻らない', type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: 'Tops は左右左右、Sides は右左右左の順番で繰り返す' },
        { bar: 8, subject: 'Everyone', summary: 'Sevens halfway', caption: 'すべてのカップルは中央に向かって Sevens in Sevens out を行い、Sevens across して opposite の位置へ移動する' },
        { bar: 8, subject: 'Everyone', summary: 'Sevens halfway' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Roscommon Lancers':
  {
    name: 'Roscommon Lancers',
    jpCaption: 'ロスコモン・ランサーズ',
    level: 'advanced',
    county: ['Roscommon'],
    notices: 'このLancer SetはMartin BolgerとFrancis Bolgerにより教えられた。Houseを除くすべての動きで、ロスコモン・リール・ステップとロスコモン・ジグ・ステップを用いる。〜"Toss The Feathers", Pat Murphyより抜粋。自分を中心に左側のカップルを 1st Corner Couple、右側のカップルを 2nd Corner Couple と呼ぶ。',
    referenceSite: {
      irishSetDancing: 'http://setdanceteacher.ie/roscommonlanc.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Side Swings',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top Gent - 2nd Top Gent - 1st Side Gent - 2nd Side Gent の順で Leading Gent が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=A2SAwpAtp3c',
        start: 0
      },
      movements: [
        { bar: 8, subject: '1st Top Gent & opposite Lady', summary: 'Back to back', caption: 'Leading Top Gent とその opposite Lady は右肩→左肩で Back to Back する', type: 'repeat' },
        { bar: 8, subject: '1st Top Gent & opposite Lady', summary: 'Swing (céilí)', caption: 'Leading Top Gent とその opposite Lady は céilí hold で Swing する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Half diamond', caption: 'Leading Couples は cross hand で Adcance & Retire を1回する(4 bar)。その後、1st Corner Couple の方へ Advance し、opposite へ Retire する(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Half diamond', caption: '2度目の Adv-Ret & Half diamond のときは 2nd Corner Couple の方へ向かう', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House w/Corners', caption: 'すべてのレディーは House をする直前に、2nd Couple のジェンツのところへ行く。House をする際、レディーは 8 bar 目のときに元の位置へ戻れるようにジェントから途中で離れる', type: 'repeat' },
        { bar: 120, subject: '2nd Top Gent - 1st Side Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Single Four Swings',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret', caption: 'Leading Couples は cross hand で Advance & Retire をする(6 bar)。その後、ジェンツは自分の右手を opposite のジェントの左手、自分の左手を opposite のジェントの右手とつなぎ、レディーの頭上を通して背中に回す。レディーは両手をジェンツの肩の上に置いて Basket になる', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Christmas', caption: 'Leading Couples は最後の 2 bar で Little Christmas を終えて、近くの Side Couple の方へ行き列をつくる', type: 'repeat' },
        { bar: 8, subject: 'Tops & Sides', summary: 'Adv-Ret (line)', caption: '列になって Advance & Retre する(6 bar)。Leading Couples は最後の 2 bar は Retire せずその場に残る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'Change Partners',
      rythmn: 'Jig',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle', caption: '全員で円状になって手をつなぎ、その場でステップする' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Circle', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House w/Corners', type: 'repeat' },
        { bar: '' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Bringing Her In',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=A2SAwpAtp3c',
        start: 151
      },
      movements: [
        { bar: 8, subject: '1st Top', summary: 'Bring her in', caption: 'Leading Couple は右手を握り、前に進む(2 bar)。ジェントは反時計回りにレディーを回しながら、進んできた方向と逆側を向く。再び前へ進み(2 bar)、先ほどと同じようにしてレディーを反時計回りに Turn させて元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone except Leading Couple', summary: 'The horseshoe', caption: 'Leading Couple 以外のすべてのカップルは互いに手をとってその場でステップする', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Grand chain', caption: 'すべてのカップルは互いに向き合い、右手→左手で Chain する。すれ違うときは前後のパートナーと手をとってその場でステップし、すれ違う(2 bar)。元の位置へ戻ったら waltz hold になる', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'The T',
      rythmn: 'Reel',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=LhP9XHOM5mQ',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Tops', summary: 'Dance the T', caption: 'Leading Couple は右手同士(R hand in R)で手をつなぎ、その場でステップしている opposite のカップルに近づく(3 bar)。Leading Gent は opposite のレディーの左手をとり、自分の隣に来るように Turn させる(4 bar)。Leading Gent はレディーの外側の肩に手を置く。このとき Leading Gent の opposite のジェントはレディーの内側の手をとる(上からみたときにT字の形になる)。4人は Leading Gent の方向へ Retire する(7 bar)。その後、Leading Gent の opposite のジェントはレディーの手を引き、自分のそばに寄せる(先ほどとは逆のT字型になる, 8 bar)。4人は今度は Leading Couple の opposite の方へ向かい(12 bar)、セットの中心へ向かう(14 bar)。それぞれ手を離してから、ジェンツ同士で手をとり、レディーの頭上を通す(15 bar)。レディーは両手をジェンツの肩の上に置いて Basket になる(16 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Christmas', caption: 'Leading Couples は Christmas する(6 bar)。その後、Leading Couples は元の位置へ戻り、その他のカップルはその場でステップする(2 bar)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', caption: '自分のパートナーと向き合い、ステップする', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'Advance and Retire',
      rythmn: 'Jig',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (R-in-R)', caption: 'Leading Couples は right hand in right, 右手で手をつないで Advance & Retire を2回する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Half diamond left', caption: 'Leading Couples は 1st Corner Couple の方へ Advance し、opposite へ Retire する(4 bar)。opposite の位置へ着いたら Step it out する(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 7,
      summary: 'Double Four Swings',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Tops', summary: 'Adv-Ret (R-in-R)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Diamond right', caption: 'Leading Couples は 2nd Corner Couple の方へ Advance し、opposite へ Retire する(4 bar)。その後、同じ動作を繰り返して元の位置へ戻る(4 bar)。戻るときは 1st Corner Couple の方へ Advance する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Star (R→L)', caption: 'Leading Couples は向き合って Right hands Star する(4 bar)。その後、反転して Left hands Star する(4 bar)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 120, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 8,
      summary: 'Ladies Chain',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=qEsb4NGZRTA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (center)', caption: 'Leading Lady は opposite のレディーと右手、opposite のパートナー と左手で Chain し、opposite のレディーと右肩ですれ違い、自分のパートナーと左手で Chain する。opposite のパートナーと Chain するとき、ジェンツはその場でステップしながら左手でレディーを半周させる。レディーはジェンツの腕の下で時計回りに反転し、セットの中央に体を向けてからジェンツの後ろ側を回る', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Dance around', caption: 'Leading Couples はセットの中心で互いに手をとり、時計回りに Dance し、元の位置へ戻る', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 120, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 9,
      summary: 'Change Places',
      rythmn: 'Jig',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Crossover', caption: ['Leading Ladies は右肩ですれ違い(4 bar) opposite へ向かう(4 bar)', 'その後 Leading Gents は左肩ですれ違い opposite へ向かう(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Step it out', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Seit Bliain na Gaeilge':
  {
    name: 'Seit Bliain na Gaeilge',
    jpCaption: 'セイト・ブリーア・ナ・ゲール',
    level: 'advanced',
    county: ['Laois'],
    notices: '"This Set is dedicated to the Irish Language in this special year of it\'s celebration. Swings in waltz hold." by Maureen Culleton. アイルランド語で「ゲール語のセット」という意味。ゲール語復興125周年を祝福して2018年につくられたセット。',
    referenceSite: '',
    needsSet: false,
    figures: [{
      order: 1,
      summary: 'Tús maith leath na hoibre',
      rythmn: 'Polka',
      description: '"Tús maith leath na hoibre" (a good start is half the work). アイルランドの古いことわざ。「始めうまくいったものは半分できたも同然」',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SJ4SpTJS-KM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', caption: ['turn lady anti clockwise right hand in right hand when half way and at end of chain', 'ジェンツは7 bars目と15 bars目でパートナーと出会ったら右手で反時計回りにレディーをTurnさせる'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Square Chain', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House each other', caption: ['Tops face left, sides face right, house around each other', 'Topsは左側のカップルと、Sidesは右側のカップルと向き合ってHouse aroundする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Arch each other', caption: ['Tops arch, holding nearest hand, sides pass under.', 'All turn towards partner on the other side and change hand, sides arch on way back.', 'Topsはパートナーと隣合って手をつないでアーチをつくる', 'Sidesはそのアーチの下を通る', 'oppositeまで行ったら振り返り、再び近い方の手をつなぐ', '帰りはSidesがアーチをつくり、Topsはその下を通る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies Chain', caption: ['hands to everyone', '出逢う人とすべて手をつなぐ'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', caption: ['Lead around with hands held on ladies right hip, right in right, and left hands in front.', 'ジェンツは右手をレディーの後ろに回し、右手同士・左手同士で手を繋いでLead Aroudする', 'レディーは右手を後ろに回す'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 40, subject: 'Everyone', summary: '<<Repeat>>', caption: ['Tops arch facing right', '2回目はTopsは右側のカップルと、Sidesは左側のカップルと向き合う'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Gioríonn beirt bóthar',
      rythmn: 'Jig',
      description: '"Gioríonn beirt bóthar" (company shortens the journey). ドイツのことわざ。「仲間との旅はあっという間に過ぎる」',
      youtube: {
        url: 'https://www.youtube.com/watch?v=exg2_G_zjfw',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Show the Lady', caption: ['both top couples turn the lady four times clockwise inside the set back to place.', 'Leading Couplesはレディーを4回Turnさせながらセットの中を歩く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide to center', caption: ['All slide to the centre and back twice.', 'セットの中央へ向かってSlide in, Slide backを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Rising step w/Corner', caption: ['All turn to nearest corner position and hold right hand in right hand with new person.', 'All using right foot to begin dance rising jig step twice (up back, back 2, 3, 4, right foot leading, up back, back 2, 3, 4 left foot leading)', 'コーナー・パートナーと向き合って右手同士で手を繋ぐ', 'ジェンツ・レディーともに右足からriging jig stepを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Rising step w/Partner', caption: ['All turn back into set', 'take partners right hand and repeat rising step.', 'パートナーと向き合い、riging jig stepを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 40, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'common' }

      ]
    },
    {
      order: 3,
      summary: 'Uisce faoi dhroichead',
      rythmn: 'Hornpipe',
      description: '"Uisce faoi dhroichead" (water under the bridge). 英語のことわざ。「覆水盆に返らず」',
      youtube: {
        url: 'https://www.youtube.com/watch?v=12EVedH5IuU',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', caption: ['All dance diamond sevens around the outside of the set.', 'すべてのカップルはDiamond Sevensする'] },
        { bar: 8, subject: 'Everyone', summary: 'Sevens to centre', caption: ['All dance sevens to centre and back, then hop in 2, 3, out 2, 3, double in place.', 'すべてのカップルはセットの中央へ向かってSevens In, Outする(4 bars)', 'その後、hop in 2, 3, out 2, 3してDouble Homeする(4 bars)'] },
        { bar: 8, subject: 'Everyone', summary: 'Turn the Ladies', caption: ['All take right hand in right and turn the lady fours times clockwise around the outside of the set.', 'パートナーと手を繋ぎ、レディーを4回Turnしながらセットを1周する'] },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret & Line of three', caption: ['All circle, adcance and retire once(dance hop in 2, 3, hop in 2, 3, hop out 2, 3, hop out 2, 3).', 'All ladies dance forward, (no hands) hop 1, 2, 3, hop 1, 2, 3, then side ladies retire to place, (2 steps).', 'Top ladies turn clockwise (2 steps) and join side man to make a line of 3 in sides.', 'Meanwhile all gents dance one turn clockwise in place.', 'hop in 2, 3, hop in 2, 3, hop out 2, 3, hop out 2, 3のリズムでAdvance & Retireする(4 bars)', 'その後、すべてのレディーはAdvanceする(2 bars)', 'LeadingでないレディーはRetireし、Leading Ladiesは時計回りにまわりながら一つ右隣にいるジェントの左隣へ移動しLine of 3になる(2 bars)', 'その間Leading Gentsはその場で時計回りに1周する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Arch / Corn Reeks', caption: ['Side men arch, partner going under first, then vistor, partner.', 'Meanwhile gents who are alone dance, (beginning with the left foot, hop back 2, 3, hop back 2, 3, hop back, hop back, hop 1, 2, 3, repeat the step beginning with the right foot.)', 'Leadingでないジェンツは、パートナー・ビジター・パートナーの順でHigh Gateする(8 bars)', 'その間Leading Gentsはその場でステップする', '"Corn Reeks"とはBurndanceなどに使われるステップで、冬に備えた動物の餌の山を意味する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home', caption: ['All dance at home after the arch movement, top ladies back with own partner', 'Leading Ladiesはパートナーのところへ戻る', 'それぞれのパートナーとHomeする'] },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ni neart go cur le chéile',
      rythmn: 'Reel',
      description: '"Ni neart go cur le chéile" (Togetherness creates strength). アイルランドのことわざ。「繋がっていてこそ強くいられる」',
      youtube: {
        url: 'https://www.youtube.com/watch?v=AWgrnM6Ktes',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Ladies move left', caption: ['All take right hand in right and face into the set.', 'All advance and retire once.', 'All face partner and turn the lady anti clockwise once to the next position, she dances outside the set to the place on her left. While lady is turning gent keep turning clockwise in place.', 'パートナーと右手同士をとってセットの中央を向き、Advance & Retireする(4 bars)', 'パートナーと向き合い、ジェンツは反時計回りにレディーをTurnさせる', 'その後、レディーは一つ左隣のジェンツのもとへ移動する', 'その間ジェンツはその場で時計回りにTurnする'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Home w/new Partner', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Little Christmas', caption: ['Top chiristmas with couple on the right, sides turn left to meet them.', 'Topsは1回目・3回目のときは右隣、と2回目・4回目のときは左隣とLittle Christmasする'], type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['Lady moving left each time until ladies back in place, direction of christmas changing each time.', 'レディーが元の位置へ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Gents', summary: 'Left hand star', caption: ['All face partner and take right hand in right, all dance around partner to place, gents left hand star, dancing three quarter way to meet new partner.', 'パートナーと向き合って右手をつないでその場で1周する(2 bars)', 'ジェンツはセットの中央で3/4 Left Hand Starする(6 bars)', 'その間レディーはその場で時計回りに1周する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['until gents are back in place', 'ジェンツが元の位置に戻るまで繰り返す'], type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Big Christmas' }
      ]
    }]
  },
  'Seit Doire Cholmcille':
  {
    name: 'Seit Doire Cholmcille',
    jpCaption: 'セイト・ドイレ・コルムキル',
    level: 'advanced',
    county: ['Derry'],
    notices: 'Also known as the Derry Set. This set was composed by Frank Roddy of Derry some years ago. Music for the set was recorded by Matt Cunningham during Easter 1999. Thanks to Anne O’Donnell for her help in teaching me the set and to Frank Roddy for his notes and advice.',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/seitdo',
      irishSetDancing: 'https://setdanceteacher.ie/dcholmcille.htm'
    },
    thumbnail: 'https://www.youtube.com/watch?v=JEbgqDx7XXg',
    needsSet: false,
    figures: [{
      order: 1,
      summary: 'Back & Wheel',
      rythmn: 'Reel',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Back to back & Right Hand Star', caption: ['Leading Couplesは左側のカップルと向き合う', 'oppositeのパートナーと反時計回りにBack to backする、その際、行きはレディーを内側に、帰りはジェンツを内側にする(4 bars)', 'その後、向き合ったカップルでRight Hand Starしてもとの位置へ戻る(4 bars)', 'Leading couples face the side couple on their left.', 'All pass through, with ladies in the centre, and reverse back with gents in the centre (4b),', 'then the four dancers join right hands and dance a full turn clockwise back to their own places (4b).'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 72, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Arch & High Gates',
      rythmn: 'Reel',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Arch', caption: ['Leading Couplesは近い方の手をつないでAdvance & Retireを1回する(4 bars)', 'その後、Leading Coupleはアーチを作り、Leading Coupleのoppositeのカップルはアーチをくぐり抜ける(4 bars)、', 'その際、Leading Ladyでないレディーはジェントの前を歩き、Leading Gentの右手を左手でとる', 'advance and retire once, holding inside hands (4b),', 'then the leading couple form an arch and the second gent crosses under the arch to the leading gent’s position while the second lady moves forward, giving her right hand to the leading gent’s left (4b).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'High Gates', caption: ['Labasheedaと同じ', '最後の2 barsで3人はLeading Gentでないジェントと向き合い、セットの中央でLittle Christmasの構えになる', 'Leading gent and the two ladies dance the arches or high gates. The leading lady passes under the arch first, then the second lady and, finally, the leading lady again. During the last two bars, the three of them face the second gent and form a group of four in the centre.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Little Christmas', caption: ['Swingして(6 bars)、もとの位置へ戻る(2 bars)', 'Couples swing in four in the centre (6b) and reverse to place (2b).'], type: 'repeat' },
        { bar: '' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Adv-Ret & Arch across',
      rythmn: 'Reel',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain', caption: ['Leading Ladiesはセットの中央でoppositeのレディーと右手でChainし、', 'oppositeのジェントと左腕でChainし、', 'oppositeのレディーともう一度右手でChainしてもとの位置へ戻る', 'Ladies chain with right hands in the centre, turn with left arms around the opposite gent and chain with right hands as they dance back to place.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret & Arch across', caption: ['Leading Couplesは左側のカップルと向き合う', '近い方の手をつないでAdvance & Retireを1回する(4 bars)', 'その後、Leading Couplesはアーチを作り、Leading Couplesのoppositeのカップルはアーチをくぐり抜ける(4 bars)、', 'その際、Leading Ladyでないレディーはジェントの前を歩き、Leading Gentの右手を左手でとる', 'Top couples face the side couple on their left, all holding inside hands.', 'They advance and retire once (4b),', 'then change places, top couples forming an arch and side couples passing under the arch (4b). '], type: 'nested-repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 56, subject: 'Sides - Tops - Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ladies on',
      rythmn: 'Jig',
      description: '',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (crossed)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'normal' },
        { bar: 8, subject: 'Gents & Ladies', summary: 'Gents; Adv-Ret, Ladies; Move to right', caption: ['すべてのジェンツはAdvance & Retireする(4 bars)', 'その間、レディーはその場でステップし(2 bars)、一つ右へ移動し、時計回りにTurnして新しいジェントと向き合う(2 bars)', 'すべてのカップルはoppositeの位置まで移動する(4 bars)', 'All gents advance (1 2 3, 1 2 3) and retire once while ladies dance on the spot (1 2 3,1 2 3),', 'ladies then dance to the position on the right and turn clockwise to face the next gent (4b).', 'All couples, with new partners, dance halfway around the set from where they are (4b).'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Home & Double',
      rythmn: 'Hornpipe',
      description: '',
      youtube: 'https://www.youtube.com/watch?v=JEbgqDx7XXg',
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret & Home', caption: ['最後の2 barsで、ジェンツは左手でレディーを時計回りにTurnさせ、一つ右のジェントのところへ送る', 'Taking hands in a circle, all couples advance and retire once', 'then dance at home, turning once.', 'During the last two bars, ladies turn clockwise under their partner’s left hand and move to join the next gent on their left.'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Home & Double', caption: ['新しいパートナーとHomeする(2 bars)', 'その後、Doubleで一つ右へ行く(2 bars)', '同じ動きを3回繰り返す(12 bars)', 'All dance on the spot with their new partners (2b),', 'then double to the next position on their right (2b).', 'They repeat this movement (dance on the spot & double on) three times until back in the gents’ original position (12b)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret & Home', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  },
  'Skibbereen':
  {
    name: 'Skibbereen',
    jpCaption: 'スキバリーン',
    level: 'advanced',
    county: ['Cork'],
    notices: 'このポルカ・セットはコーク州のSkibbereenのセットで、smooth easy style（スムース・ステップ？）で踊られる。コークのダンスマスターのJoe O\'Donovanにより広く教えられた。SwingはすべてWaltzホールドで行う。 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/skibse'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: '',
      rythmn: 'Polka',
      description: 'Leading は 反時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順（諸説あり）。繰り返し部分は 1st Top Gent - 2nd Top Gent - 1st Side Gent - 2nd Side Gent の順で Leading Gent が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=4Tlpu3WZuHU',
        start: 0
      },
      movements: [
        { bar: 32, subject: 'Everyone', summary: 'Body (Double)', caption: 'すべてのカップルは waltz hold になり、中央へ向かって Slide In, Slide Out する(4 bar)。その後、時計回りに2回 Turn しながら一つ右の位置へ移動する(4 bar)。この動作を4回繰り返し、元の位置へ戻る' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret', caption: 'Leading Couples は右手同士、左手同士をつなぎ、Advance & Retire する。ジェンツは右手を女性の腰の方に回して手をつなぐ', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', caption: 'Ladies Chain のとき、Leading Gent は opposite のレディーを左手で時計回りに回しながら自分も反時計回りに Turn する。レディーは opposite と Chain するとき、ジェントの腕の下を通る', type: 'repeat' },
        { bar: 16, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Leading Gent & opposite Lady', summary: 'Swing', caption: 'Leading Gent とその opposite Lady は前に進み出て Swing する', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Lead across (shoulder)', caption: 'Leading Couples のジェントは右手を女性の方に回し、レディーの右手をにぎり、手前側でレディーの左手をにぎり、Lead Around の構えをする。右斜め前方に進み、ステップし(4 bar)、opposite へ行き、レディーを Turn させる(4 bar)', type: 'repeat' },
        { bar: 48, subject: '2nd Top Gent - 1st Side Gent - 2nd Side Gent', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: '',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Slide In, Out & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide In, Out & Change', type: 'repeat' },
        { bar: 48, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing & Dance', caption: 'すべてのカップルは Swing し(6 bar)、中央に向かってステップする(2 bar)' }
      ]
    },
    {
      order: 3,
      summary: '',
      rythmn: 'Polka',
      description: 'Leading は 反時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順（諸説あり）。繰り返し部分は 1st Tops - 1st Sides - 2nd Tops - 2nd Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=2o8u20sNngY',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Slide In, Out, into Three & One ', caption: 'Leading Couple は Slide In, Slide Out を一度する。その後時計回りに一周し、ジェントはレディーを時計回りに回しながら opposite のジェントの左側へ送り出す', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Three & One ', caption: 'Leading Couple は Three & One  を一度する。その後、Leading Gent は腕を回して4人で円上になる', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (lasso)', type: 'repeat' },
        { bar: 144, subject: '1st Sides - 2nd Tops - 2nd Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing & Dance' }
      ]
    },
    {
      order: 4,
      summary: '',
      rythmn: 'Slide',
      youtube: null,
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (waist)', caption: 'すべてのカップルは右手同士、左手同士をつなぎ、Long Lead Around する。ジェンツは右手を女性の腰の方に回して手をつなぐ', type: 'repeat' },
        { bar: 12, subject: 'Tops', summary: 'Gallop & House', caption: 'Leading Couples はジェンツを内側に Gallop し(8 bar)、House で opposite の位置へ行く(4 bar)', type: 'repeat' },
        { bar: 12, subject: 'Tops', summary: 'Gallop & House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Turn the Lady & Turn into Lead Around', caption: 'ジェンツは左手でレディーの右手をとり、時計回りに1回転 Turn させて互いに向き合う(2 bar)。その後、ジェンツはレディーのそばに付きながらゆっくり反時計回りに Turn して Lead Around の構えになる(6 bar)', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (waist)' }
      ]
    },
    {
      order: 5,
      summary: '',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Atk1y3LUpNo',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; moves →3/4L', caption: 'レディーはパートナーと右肩ですれ違い、中央で時計回りに 3/4 歩き、元いた位置の一つ右側のジェントのところへ行く', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/n P.', caption: '新しいパートナーと Swing する', type: 'repeat' },
        { bar: 48, subject: 'Sides Leading', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 32, subject: 'Everyone', summary: 'Body (Double)' }
      ]
    }]
  },
  'Sliabh Luachra':
  {
    name: 'Sliabh Luachra',
    jpCaption: 'シュリーブ・ルクラ',
    level: 'basic',
    county: [
      'Cork',
      'Kerry',
      'Limerick'
    ],
    notices: 'この人気のあるセットはケリー州・コーク州・リムリック州の間にあるシュリーブ・ルクラのセットで、地方により様々なバリエーションがあります。また、地方によっては別の名前が付けられていることもあります。〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/slialu',
      irishSetDancing: 'http://setdanceteacher.ie/sliabhluachra.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Chain',
      rythmn: 'Polka',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 225
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain (arm, twice)', caption: 'Leading Couples のレディーは opposite のレディーと右手で Chain し、opposite のジェントと左腕を掴んで2周し、元の位置へ戻る。これらは新しいバリエーションで、古くはレディー同士が右手で Chain、opposite のジェントがレディーを追いかけながら左手でレディーを2周させ、レディーは元の位置へ戻るとき opposite のレディーと右手で Chain していた', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Swing', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'House In',
      rythmn: 'Polka',
      description: 'Leading は 時計回りに 1st Tops - 1st Side - 2nd Top - 2nd Side の順',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 368
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'House inside', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Slide In, Out & Home', type: 'repeat' },
        { bar: 96, subject: '1st Side - 2nd Top - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Slide & Change',
      rythmn: 'Slide/Jig',
      description: '繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 541
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ladies Wheel',
      rythmn: 'Polka',
      description: 'Lead Around - Turn the Lady の流れを3回繰り返したらおしまい。レディーはフィガーの間ずっと回ることになるので注意',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 715
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは cross hold で Lead Around する', '一周して元の位置へ戻るとき、ジェンツはレディーを Turn させない'], type: 'repeat' },
        { bar: 8, subject: 'Every Gent & Every Lady', summary: 'Turn the Lady (cw / l.h. / ×4)', caption: 'ジェンツとレディーは左手を握り、ジェンツはレディーを時計回りにその場で4回転させる', type: 'repeat' },
        { bar: 16, subject: 'Ladies & Gents', summary: 'L; Wheel & turn(arm, 2), Swing', caption: ['レディーはセットの中央へ進み、右手を出して時計回りに Wheel し、opposite のジェントのところへ向かう(2 bar)', 'レディーは opposite のジェントと左腕を掴んで2周する(6 bar)', 'レディーは再び右手を出して中央で時計回りに Wheel する(2 bar)', 'レディーは自分のジェントと出会ったら Swing する(8 bar)'], type: 'repeat' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)' },
        { bar: 8, subject: 'Everyone', summary: 'Turn the Lady' }
      ]
    },
    {
      order: 5,
      summary: 'Slide, Hook, House',
      rythmn: 'Slide',
      description: 'Slide & Change のバージョン。繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=hACqymDYI2A&index=5&list=PLXAQwgkR89SW4N7P4K-Z4UrLjjT6d_P4O',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Square, Hook, House',
      rythmn: 'Slide',
      description: 'Square & House のバージョン。繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 820
      },
      movements: [
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
        { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'Slow Circle',
      rythmn: 'Hornpipe',
      description: '自分のパートナーと出会うまで繰り返す',
      youtube: {
        url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
        start: 1030
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Body' },
        { bar: 8, subject: 'Everyone', summary: 'House' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; moves→1/4R', caption: ['レディーは一つ右隣のジェントのところへ移動する。8バーズあるのでゆっくりでOK', '以下バリエーション', 'Circle Advance & Retire を一度行う(4 bars)', 'ジェンツは左手でレディーの手を握ったまま反時計回りに2回Turnさせてwaltz holdになる(4 bars)'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' }
      ]
    }]
  },
  'Sliabh Fraoch':
  {
    name: 'Sliabh Fraoch',
    jpCaption: 'シュリーブ・フローク',
    level: 'advanced',
    county: ['Cork'],
    notices: 'このセットはコーク州のロックシャペルのセットで2006年にFrank Keenanがイビサで教えた。This set from around Rockchapel in Cork, was taught by Frank Keenan in Ibiza in 2006. 〜"Apples in Winter", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/sliafr'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Adv-Ret & Lead Across',
      rythmn: 'Polka',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rJrhB50MuNc',
        start: 220
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルは cross hand で Lead Around する(8 bar)。', '一周して元の位置へ戻ってきたらジェンツは両手でレディーを時計回りにTurnさせる。'], type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Long Square', caption: ['すべてのカップルはLong Squareする', 'Jenny Lind流：スライドで右側へ移動し、時計回りに方向転換し、逆の足からスライドし、元の位置からoppositeへ行き、体の向きを揃える(8 bars)', '同じ動きを繰り返して元の位置へ戻る(8 bars)'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Adv-Ret & Lead Across', caption: ['パートナーとは手を繋がず、セットの中心を向く', 'Advance & Retireし(4 bars)、Lead acrossして、元の位置からoppositeへ行く(4 bars)', 'このときジェンツはレディーの前を歩く', '同じ動きを繰り返して元の位置へ戻る(8 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 40, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Long Square' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Jump, Kick & Square',
      rythmn: 'Polka / Slide',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rJrhB50MuNc',
        start: 334
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 16, subject: 'Everyone', summary: 'Long Square' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Square', caption: ['Leading CouplesはDiamond Squareする', '(1,2, 123)で右隣へ行く(2 bars)', '4回繰り返して元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Jump, Kick & Square', caption: ['Leading CouplesはBorlin SetのようにJump, Kick, Jump, Kickする(4 bars)', 'その後、Diamond Squareでoppositeへ行く(4 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Jump, Kick & Square', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Square', type: 'repeat' },
        { bar: 96, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Long Square' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Square' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Line out & Cross over',
      rythmn: 'Reel',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rJrhB50MuNc',
        start: 556
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Sevens', caption: ['すべてのカップルはDiamond Sevensする', 'Houseのように、各ホームポジションへ移動する'], type: 'repeat' },
        { bar: 16, subject: 'Leading Couples', summary: 'Cross over & Line out', caption: ['Leading Gentsはセットの中心で時計回りにぐるっと一周半歩いて、oppositeへ行く(8 bars)', 'その間、LeadingでないカップルはLine Outする', 'その後、Leading LadiesはGentsと同じようにセットの中心で時計回りにぐるっと一周半歩いて、oppositeへ行く(8 bars)', 'LeadingでないカップルはLine Outするときは、自分のパートナーと向き合い、時計回りにTurnしながら右肩ですれ違うようにして位置を交換する(8 bars)', 'その後、同じ動作を繰り返して元の位置に戻る'], type: 'repeat' },
        { bar: 16, subject: 'Leading Couples', summary: 'Cross over & Line out', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Lead home', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Tops', summary: '<<Repeat>>', caption: ['2回目もTops Leading', 'Cross overするときはレディーがLeadingになる'], type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ring-of-Four',
      rythmn: 'Reel',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rJrhB50MuNc',
        start: 740
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Leading Couples', summary: 'Diamond Sevens', type: 'nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret & Ring-of-Four', caption: ['Leading CouplesはAdvance & Retireする', '2回目にAdvanceしたときレディーは両手を繋ぎ、その手をジェンツの肩にかけ、Little Christmasの形になる'], type: 'nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing in Four', type: 'nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain', caption: ['Leading Ladiesは右肩でoppositeのレディーとすれ違い、', 'oppositeのジェンツと時計回りに回り、', '自分のジェンツと左肩ですれ違うようにして回り、元の位置へ戻る'], type: 'nested-repeat' },
        { bar: 32, subject: 'Leading Couples', summary: '<<Repeat>>', type: 'call-nested-repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing', type: 'repeat' },
        { bar: 72, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Dance in line',
      rythmn: 'Reel / Fling',
      description: '',
      youtube: {
        url: 'https://www.youtube.com/watch?v=rJrhB50MuNc',
        start: 968
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens to center', caption: ['すべてのカップルはセットの中央へ向かってSevnes In, Backする', 'その後、In, Outし、その場でDouble Homeする'], type: 'repeat' },
        { bar: 8, subject: 'Ladies', summary: 'Ladies; Dance in line', caption: ['すべてのレディーはセットの中を時計回りに3/4歩く(8 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Gents', summary: 'Gents; Dance in line', caption: ['すべてのジェンツはセットの中央で時計回りに周る(8 bars)'], type: 'repeat' },
        { bar: 96, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Sevens' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
    // {
    //   order: 5,
    //   summary: 'Square, Hook, House',
    //   rythmn: 'Slide',
    //   description: 'Square & House のバージョン。繰り返し部分は Tops - Sides - Tops - Sides の順で Leading Couples が入れ替わる',
    //   youtube: {
    //     url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
    //     start: 820
    //   },
    //   movements: [
    //     { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'Square & House', type: 'repeat' },
    //     { bar: 8, subject: 'Tops', summary: 'House each other', type: 'repeat' },
    //     { bar: 168, subject: 'Sides - Tops - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' }
    //   ]
    // },
    // {
    //   order: 6,
    //   summary: 'Slow Circle',
    //   rythmn: 'Hornpipe',
    //   description: '自分のパートナーと出会うまで繰り返す',
    //   youtube: {
    //     url: 'https://www.youtube.com/watch?v=SXxcwW6Yy9s',
    //     start: 1030
    //   },
    //   movements: [
    //     { bar: 16, subject: 'Everyone', summary: 'Body', type: 'repeat' },
    //     { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
    //     { bar: 8, subject: 'Everyone', summary: 'Ladies; Moves→R', caption: 'レディーは一つ右隣のジェントのところへ移動する。8バーズあるのでゆっくりでOK。以下バリエーション。Circle Advance & Retire を一度行い、ジェンツは左手でレディーの手を握ったまま反時計回りに2回回転させて waltz ホールドになる', type: 'repeat' },
    //     { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
    //     { bar: '' },
    //     { bar: '' },
    //     { bar: '' },
    //     { bar: 16, subject: 'Everyone', summary: 'Body', type: 'common' },
    //     { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
    //   ]
    // }
  },
  'South Galway Reel':
  {
    name: 'South Galway Reel',
    jpCaption: 'サウス・ゴールウェイ・リール',
    level: 'beginner',
    county: [
      'Galway'
    ],
    notices: 'このセットはゴールウェイ州のGort地方でとても人気があります。バリエーションがいくつかあり、ハーフセットでも踊られることもあります。 〜"Toss The Feathers", Pat Murphyより抜粋。このセットではほとんどor全くバタリングは行わない〜Set Dancing Newsより抜粋',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/soutga',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/SGALWAY.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=sv5eNZs8TaQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Pass through', caption: ['Tops は左隣のカップルと、Sides は右側のカップルと向き合う', '向かい合ったカップルの opposite のパートナーと右肩ですれ違う(2 bar)', 'その後、自分のパートナーと向き合って、左肩ですれ違う(2 bar)', '再び右肩で opposite のパートナーとすれ違い(2 bar)、左肩で自分のパートナーとすれ違い、元の位置へ戻る(2 bar)', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Advance & Retire',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=RU-XgY40Bzk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Pass through', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Pass back', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 32, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 3,
      summary: 'House to opposite',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=NYlMO3IS-Fk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House', caption: ['すべてのカップルは waltz hold になり Advance & Retire を一度行う(4 bar)', 'その後、House across し、opposite の位置へ行く(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 40, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'House',
      rythmn: 'Rising Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=60Y4q-50vNE',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 40, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Ladies cross',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=Lmt0e27bCdA',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Ladies; Changeover', caption: ['Tops は左隣のカップルと、Sides は右側のカップルと向き合う', 'すべてのカップルは waltz hold になり Advance & Retire を一度行う(4 bar)', 'その後、レディーは右肩同士ですれ違い、位置を交換する(4 bar)', 'このとき、ジェンツはその場で時計回りに Turn する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (waltz) & Ladies; Changeover', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing / Big Christmas', caption: 'Sides Leading のときは Bascket form になって Big Christmas', type: 'repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    }]
  },
  'South Kerry':
  {
    name: 'South Kerry',
    jpCaption: 'サウス・ケリー',
    level: 'advanced',
    county: [
      'Galway'
    ],
    notices: 'このセットはMuiris O\' Brienという南ケリー州のバリンズケリグス出身の方が教えてくれました。彼はこのセットを自分の家で家族と一緒に踊っていたそうです。This set was shared with us by Muiris O\' Brien. Muiris comes from Baile an Sceilg or Ballinskelligs in south counry Kerry and he danced this in his own home with his family. 〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/soutke',
      irishSetDancing: 'http://www.setdancingnews.net/teacher/SKERRY.HTM'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Gents Chain',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ZKJz9DIRm00',
        start: 7
      },
      movements: [
        { bar: 16, subject: 'Leading Gents, then Tops', summary: 'Gents Chain & Swing', caption: ['Leading Gentsはセットの中央で右手をとってChainし、もとの位置へ戻る(6 bars)', 'その間、Leading Ladyは少し左に寄る', 'その後、Leading Couplesはその場でSwingする(10 bars)', 'Top gents chain around each other with right hands in the centre (6b) while the ladies move left to the gents’ positions. Then both couples swing in place (10b).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Cross', caption: ['Leading Ladiesは左肩ですれ違ってoppositeへ行く', 'その間、Leading Gentsは少し右へ寄る', 'opposite Gentと左手でChainし、もとの位置へ戻ってパートナーと向き合う', 'Top ladies cross left shoulder to left shoulder, turn with left hands around the opposite gent and dance back to face their partners. who have moved across to face in on the ladies side.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & Home', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 40, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 2,
      summary: 'Ladies Chain',
      rythmn: 'Polka or Slide',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IE3i8l0Gmqo',
        start: 268
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', caption: ['すべてのカップルはwaltz holdになる', 'すべてのカップルはReverse Houseする(6 bars)', 'このとき、レディーはセットの内側、ジェンツはセットの外側を向くようにしてReverse Houseを終える', 'すべてのカップルは角に向かってSlideし、Gentsがセットの内側を向くように時計回りに90度まわる(2 bars)', 'その後、ホームポジションへ向かってSlideし(2 bars)、Homeをする(4 bars)', 'All reverse the lady to her corner (2b) then house three-quarter way around (6b) to end with the gents’ backs towards the centre. All couples slide to the corner, turn clockwise slightly on the last step so that the gents are facing in then slide across to their own position and turn once in place.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & Home', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & Home', type: 'repeat' },
        { bar: '' },
        { bar: '' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'normal' }
      ]
    },
    {
      order: 3,
      summary: 'Ladies Chain',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ZKJz9DIRm00',
        start: 83
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'normal' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Cross', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Seing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open waltz)', caption: ['All lead around to home with each gent’s right arm around his partner’s waist and her left hand on his shoulder.'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'repeat' },
        { bar: 40, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 4,
      summary: 'Drag the Lady',
      rythmn: 'Jig or Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ZKJz9DIRm00',
        start: 230
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Drag the Lady', caption: ['Leading Couplesは右手をとってAdvance & Retireする(4 bars)', 'その後、Leading Gentsはレディーを連れて時計回りにLead acrossする(4 bars)', 'Top couples take partner’s right hand, advance and retire once then cross on the left with gents leading. Advance and retire again on the other side and lead back to place.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Drag the Lady', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: '' },
        { bar: 72, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open waltz)', type: 'normal' },
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'normal' }
      ]
    },
    {
      order: 5,
      summary: 'Slide & Crossover',
      rythmn: 'Slide',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IE3i8l0Gmqo',
        start: 745
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'normal' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & House across', caption: ['Slide in and back then house to the opposite side. They slide in and back again there and dance back to place.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & House across', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & Ladies cross', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Reverse House', caption: ['House around with new partners.'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Slide In, Out & Ladies cross', caption: ['Leading CouplesはSlide in, outする(4 bars)', 'Leading Ladiesは左肩ですれ違ってoppositeへ向かい、opposite Gentと左手でChainし、もとの位置へ戻る(4 bars)', 'Slide in again with new partners then ladies cross left shoulder to left and chain with left hands around opposite gent (their own partner) (8 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', caption: ['Leading Ladiesはセットの中央で右手でChainし、opposite Gentと左手でChainし、右肩ですれ違ってホームポジションへ戻り、パートナーとwaltz holdになる', 'From here they dance a full ladies’ chain, right hands in the centre, left around the opposite gent and pass back, right shoulder to right, to face their own partners (8 bars).'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Reverse House', type: 'repeat' },
        { bar: 56, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' }
      ]
    },
    {
      order: 6,
      summary: 'Change Partners',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=IE3i8l0Gmqo',
        start: 891
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Gents; Right Hand Star', caption: ['すべてのGentsはセットの中央でRight Hand Starする(8 bars)', 'その間、レディーは少し左に寄ってジェンツを出迎える', 'The four gents join right hands in the centre and dance around clockwise until back facing their partners. While the gents are in the centre, each lady moves left to her partner’s position, so that he finishes back in her position facing her.'], type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', type: 'normal' },
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', caption: ['ラストフィガーはReverse Houseしない'], type: 'normal' },
        { bar: 8, subject: 'Everyone', summary: 'Wheel', caption: ['レディーは一つ右へ移動し、新しいジェントとSwingする', 'The gents join hands and dance around the centre again. This time, the ladies move on to the right and swing the next gent.'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around', type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'House & Sqaure the corner', type: 'repeat' },
        { bar: 120, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>>', type: 'call-repeat' }
      ]
    }]
  },
  'Templebeg':
  {
    name: 'Templebeg',
    jpCaption: 'テンプルベグ',
    level: 'advanced',
    county: ['Tipperary'],
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/tembeg'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Pass through',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ShCcu9UY3oM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Top & all Gents', summary: 'Pass through & Star, G; moves→L', caption: 'Top Couples は Pass through で反対側に向かい自分のパートナーと位置を入れ替えたら Star する。すべてのジェンツは元いた位置の一つ左側へ向かい、Star をしたレディーは元いた位置へ戻る', type: 'nested-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'nested-repeat' },
        { bar: 48, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-nested-repeat' },
        { bar: 80, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    },
    {
      order: 2,
      summary: 'The star',
      rythmn: 'Slide',
      youtube: {
        url: 'https://www.youtube.com/watch?v=9pVULMC9Di4',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (waist)', caption: 'ジェンツは右手をレディーの腰に回し、左手を中央で重ねる。レディーは左手をジェンツの右肩に置く', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 16, subject: 'Gents & Ladies', summary: 'Star', caption: 'ジェンツは左隣のレディーと Turn し、中央で Star する。その後元いた位置の一つ右隣のレディーのとこへ向かい Turn する。再び中央で Star した後に元いた位置の opposite のレディーと Turn する。もう一度中央で Star した後に最初の位置へ戻り、自分のパートナーと Turn する。レディーは自分へ向かってくるジェンツと Star する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Long Lead Around (waist)' },
        { bar: 8, subject: 'Everyone', summary: 'House' }

      ]
    },
    {
      order: 3,
      summary: 'Pass through',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=xFbu9Xql3rI',
        start: 0
      },
      movements: [
        { bar: 16, subject: 'Everyone', summary: 'Half Chain', caption: 'Chain で元の位置の opposite で自分のパートナーと出会ったら時計回りに Turn。その後再び Chain で元の位置へ戻る' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 16, subject: 'Tops', summary: 'Pass through', caption: 'Leading Couples は左隣 → opposite → 右隣 → opposite の順で4回 Pass through する。この時自分のパートナーとは位置を入れ替えない。その他のカップルは、右隣のカップルとPass through → 自分のパートナーと位置を交換 → 左隣のカップルとPass through → 自分のパートナーと位置を交換する', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Little Christmas', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Half Chain' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    },
    {
      order: 4,
      summary: 'Cashel doubles',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=x1ownRLuWvg',
        start: 0
      },
      movements: [
        { bar: 32, subject: 'Everyone', summary: 'House & D. & G;moves→R & clap & stamp', caption: '1/4 House、1/4 Double で opposite へ向かい、ジェンツはさらに一つ右へ向かい新しいレディーと合流し、clap & stamp する' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double (L)', caption: 'Tops は左隣のカップルと、Sides は右隣のカップルと 1/2 House, 1/2 Double する。ジェンツは Double の後 House をした向かいのカップルのレディーのところへ向かい、clap & stamp する' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double (L)' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double (R)' },
        { bar: 8, subject: 'Everyone', summary: 'House & Double (R)', caption: 'Tops は右隣のカップルと、Sides は左隣のカップルと 1/2 House, 1/2 Double する。ジェンツは Double の後 House をした向かいのカップルのレディーのところへ向かい、clap & stamp する' },
        { bar: 32, subject: 'Everyone', summary: 'House & D. & G;moves→R & clap & stamp' },
        { bar: 8, subject: 'Everyone', summary: 'House, Double' }
      ]
    },
    {
      order: 5,
      summary: 'Fast wheels',
      rythmn: 'Jig',
      youtube: {
        url: 'https://www.youtube.com/watch?v=6sEor92ax98',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' },
        { bar: 8, subject: 'Ladies & Gents', summary: 'L; Star, G; 3/4 R', caption: 'レディーは左手 → 右手で Star する。ジェンツは反時計回りに 3/4周して新しい女性と waltz ホールドになる', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Diamond Slide', caption: 'waltz ホールドで前向きに Slide in, 後ろ向きに Slide out を2回繰り返して元の位置へ一周する', type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 8, subject: 'Everyone', summary: 'Swing' }
      ]
    }]
  },
  'Termonfeckin Lancers':
  {
    name: 'Termonfeckin Lancers',
    jpCaption: 'ターモンフェキン・ランサーズ',
    level: 'advanced',
    county: ['Louth'],
    referenceSite: {
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Back to back',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=P5HSWfPYyMQ',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (open) & Home' },
        { bar: 8, subject: 'Tops', summary: 'Ladies; Turn, Back to back', caption: ['Leading Ladiesはセットの中央へ進み、右手同士をつないで一周する(4 bar)', 'このとき腕は上げてChainする', 'その後、元の位置へ戻り自分のパートナと右肩ですれ違うようにしてBack to backする(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret & Steal the Lady', caption: ['Leading CouplesはAdvance and Retireする(4 bar)', 'このときパートナーとは手を繋がない', 'もう一度Advanceした後、ジェンツは元の位置へ戻るときに、oppositeのレディーの右手をとって引きよせてTurnさせる(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 24, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Tops', summary: 'Adv-Ret (R-in-R) & Ladies; Back to home', caption: ['Leading CouplesはRight hand in right、右手をとってAdvance and Retireする(4 bar)', 'もう一度Advanceした後、レディーはoppositeのジェンツの前へ出る(4 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Duck', caption: ['Leading Couplesはセットの中央を1周する'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies; Turn, Back to back', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing', type: 'repeat' },
        { bar: 32, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }

      ]
    },
    {
      order: 2,
      summary: 'Square & Pass back',
      rythmn: 'Reel',
      description: 'レディーは一つずつ右へずれる。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=9mW0UkCSaWk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (open) & Home' },
        { bar: 8, subject: 'Tops', summary: 'House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Square (waltz) & Pass back', caption: ['Leading Couplesはwaltz holdになり、右側のカップルの方へ進み(2 bar)、90度時計回りに反転し後ろ向きに opposite の位置へ向かう(2 bar)', 'その後、再び右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違い、元の位置へ戻る(4 bar)', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く', '元の位置へは戻らずコーナー・パートナの隣へ行く'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Line Adv-Ret, Circle', caption: ['Leading Couplesは左右に分かれ、2列のライン状になってAdvance and Retireする', '2回目にAdvanceしたとき、レディーは右隣にいるジェンツが左側に来るように、セットの内側を通って回り込み、Christmasの構えになる'], type: 'repeat' },
        { bar: 8, subject: 'Tops Leading', summary: 'Little Christmas', caption: ['ブレイクするとき、ジェンツは自分の右隣にいるレディーを連れて戻る'], type: 'repeat' },
        { bar: 96, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', caption: ['レディーが元の位置へ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Square Chain',
      rythmn: 'Fling',
      youtube: {
        url: 'https://www.youtube.com/watch?v=gpSh6PY3hrM',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Balance In, Out & Double Home', caption: ['すべてのカップルはwaltz holdになり、Balance In, Balance Outし(2 bar)、Double Homeする(2 bar)', '同じ動作を繰り返す(4 bar)', '"Balance"とは相手に近づいて離れること'] },
        { bar: 8, subject: 'Tops', summary: 'Square Chain', caption: ['Leading Couples は右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違う(4 bar)', 'その後、再び右肩で opposite のパートナーとすれ違い、左肩で自分のパートナーとすれ違い、元の位置へ戻る(4 bar)', 'すれ違うとき、対面する相手と右手-左手-右手-左手の順でChainする', 'ジェンツは時計回り、レディーは反時計回りに四角形を描くように動く', 'ジェンツは元の位置へ戻るとき、反時計回りにTurnする'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Leadies; One Half Chain (under)', caption: ['Leading Ladiesはセットの中央へ進みでて、右手をつないで1と1/2周し、oppositeのジェントのところへ行く', 'その間、ジェンツはその場で反時計回りにTurnする'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Diamond Sevens', caption: ['Leading Couplesはwaltz holdになり、右側のカップルの方へ進み(2 bar)、90度時計回りに反転し後ろ向きに opposite の位置へ向かう(2 bar)', '同じ動作を繰り返して元の位置へ戻る'], type: 'repeat' },
        { bar: 72, subject: 'Sides - Top - Sides', summary: '<<Repeat ×3>>', caption: ['レディーが元の位置へ戻るまで繰り返す'], type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret' },
        { bar: 16, subject: 'Everyone', summary: 'Chain', caption: ['ジェンツは反時計回りに、レディーは時計回りに Chain する', 'ジェンツは7 bars目、15 bars目に自分のパートナーと出会ったら右手で反時計回りにレディーを回す'] },
        { bar: 8, subject: 'Everyone', summary: 'Balance In, Out & Double Home' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Ladies Star',
      rythmn: 'Slide',
      description: 'フィガー4から最初のLead Aroundがcross handで始まる。',
      youtube: {
        url: 'https://www.youtube.com/watch?v=KQRXSlSj6dk',
        start: 0
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross) & Turn', caption: ['すべてのカップルは cross hand で Lead Around する', '1周して元の位置へ戻ったらレディーを時計回りに Turn させる'] },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: '元の位置へ戻ったときにジェンツはレディーを Turn させない', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide around', caption: ['すべてのカップルは Slide in, Slide back で opposite へ移動し、同じ動作を繰り返して元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide to the center', caption: ['すべてのカップルはセットの中央へ向かってSlide In, Slide Outを2回する'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; Star & Turn (arm), Move→R', caption: ['レディーは中央で右手を出して時計回りにStarし、opposite のジェントのところへ向かう(2 bar)', 'レディーはoppositeのジェントと左腕を掴んで1周する(4 bar)', 'レディーはそこから一つ左隣のジェントのところへ移動する（元いた位置の一つ右側の位置）', 'ジェンツはレディーが来たら右手で反時計回りにTurnさせる'], type: 'repeat' },
        { bar: 96, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross) & Turn' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)' }
      ]
    }]
  },
  'West Kerry':
  {
    name: 'West Kerry',
    jpCaption: 'ウェスト・ケリー',
    level: 'basic',
    county: ['Kerry'],
    notices: 'ケリー州のDingle Peninsulaのセット。〜"Toss The Feathers", Pat Murphyより抜粋。',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/westke',
      irishSetDancing: 'http://setdanceteacher.ie/wkerry.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Wheel & Chain',
      rythmn: 'Polka',
      youtube: {
        url: 'https://www.youtube.com/watch?v=mYYEZB-n2gA',
        start: 51
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', caption: ['waltz hold になる', 'ジェンツは最初の2 bars はレディーを後ろ向きにした状態で一つ右側の位置へ行く', '残りの 6 bars は House をして元の位置へ戻る'], type: 'repeat', image: 'ReverseHouse.gif' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', caption: ['すべてのカップルはopen holdでLead Aroundする'], type: 'repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Ladies; Wheel & Swing', caption: ['すべてのレディーは中央で時計回りに Wheel する(4 bar)', '各レディーは自分のパートナーのところへ戻り Swing する(12 bar)'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain', caption: ['Leading Couples のレディーは opposite のレディーと右手、opposite のジェントと左腕または左手、再び opposite のレディーと右手で Chain する', 'ジェントは Chain するとき肘をつかむ、または手をつなぐ'], type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Reverse House', type: 'repeat' },
        { bar: 56, subject: 'Sides Leading', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open), clap & stamp', caption: ['すべてのカップルは Lead Around する', '8 bar 目に clap & stamp する'] }
      ]
    },
    {
      order: 2,
      summary: 'House inside',
      rythmn: 'Polka',
      description: 'Leadingは時計回り。1st Top - 2nd Top - 1st Side - 2nd Side の順で Reverse House する。最後にLead Aroundがないバージョンもある',
      youtube: {
        url: 'https://www.youtube.com/watch?v=WxP_os4oMSw',
        start: 314
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Leading Couple', summary: 'Reverse House', type: 'repeat' },
        { bar: 120, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat', caption: '1st Top - 2nd Top - 1st Side - 2nd Side の順で繰り返す' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open), clap & stamp' }

      ]
    },
    {
      order: 3,
      summary: 'Slide, Lead Around & Chain',
      rythmn: 'Slide',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=mYYEZB-n2gA',
        start: 224
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Ladies Chain', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Reverse House', type: 'repeat' },
        { bar: 120, subject: 'Tops - Sides - Sides', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change' },
        { bar: 8, subject: 'Everyone', summary: 'Slide & Change' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open), clap & stamp' }
      ]
    },
    {
      order: 4,
      summary: 'Slide & House',
      rythmn: 'Slide or Polka',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=WxP_os4oMSw',
        start: 701
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross) & Turn', caption: ['すべてのカップルは cross hand で Lead Around する', '1周して元の位置へ戻ったらレディーを時計回りに Turn させる'] },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: '元の位置へ戻ったときにジェンツはレディーを Turn させない' },
        { bar: 8, subject: '1st Top', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: '1st Top', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 8, subject: 'Tops', summary: 'Slide & Change', type: 'repeat' },
        { bar: 96, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', caption: '2nd Side Leading で最後に Slide & Change をした後、全員で Clap する', type: 'call-repeat' }
      ]
    },
    {
      order: 5,
      summary: 'Meet your neighbor',
      rythmn: 'Slide',
      youtube: {
        url: 'https://www.youtube.com/watch?v=WxP_os4oMSw',
        start: 897
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open)', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'L; Wheel(3/4R), G; Wheel', caption: ['レディーは右手を出して時計回りに3/4周 Wheel する(4 bar)', 'その後ジェンツは左手を出して1周 Wheel する(4 bar)', 'レディーは元いた位置の一つ右側のジェンツのところへ移動することになる'], type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Swing w/new Partner', caption: '各自新しく出会ったパートナーと Swing する', type: 'repeat' },
        { bar: 144, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (open), clap & stamp' }
      ]
    },
    {
      order: 6,
      summary: 'Doubles <Short>',
      rythmn: 'Hornpipe',
      youtube: null,
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Double' }
      ]
    },
    {
      order: 6,
      summary: 'Doubles <Long>',
      rythmn: 'Hornpipe',
      youtube: {
        url: 'https://www.youtube.com/watch?v=WxP_os4oMSw',
        start: 1105
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Reverse House', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Double', type: 'repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Ladies; walk on', caption: ['すべてのレディーは自分の一つ右側のジェンツのところへ移動する', '移動するときはジェンツの外側を通っていく'], type: 'repeat' },
        { bar: 72, subject: 'Everyone', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Reverse House' },
        { bar: 8, subject: 'Everyone', summary: 'Double' }
      ]
    }]
  },
  'Williamstown':
  {
    name: 'Williamstown',
    jpCaption: 'ウィリアムズタウン',
    level: 'advanced',
    county: ['Galway'],
    notices: 'This set comes from the Roscommon Galway border area. It has been revived by Mary Whyte, who grew up in Lowberry. Mary has dedicated the set, which was originally danced at crossroads and house dances in the Lowberry and Williamstown areas, to the dancers of previous generations who kept it alive. Recently she has taught it to the Williamstown Set Dancers. My thanks to Mary for giving me the set and also to P. J. Gorevan, who originally told me about it and put me in contact with her. Notes from The Flowing Tide by Pat Murphy.',
    referenceSite: {
      danceminder: 'https://danceminder.com/dance/show/willse',
      irishSetDancing: 'https://setdanceteacher.ie/williamstown.htm'
    },
    needsSet: true,
    figures: [{
      order: 1,
      summary: 'Slow Chain',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=BG5TbRkQ78o',
        start: 2
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', caption: ['すべてのカップルはcross handで反時計回りにLead Aroundする', '最後の2小節はパートナーと向き合ってその場でステップする'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 16, subject: 'Leading Couples', summary: 'Slow Chain', caption: ['Leading Ladiesはセットの中央に集まり、互いに右手をとって一周する(4 bars)', 'その後、oppositeのジェンツと左手をとって一周する(4 bars)', '同じ動作を繰り返して元の位置へ戻る(8 bars)'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 24, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 16, subject: 'Everyone', summary: 'Turn the Ladies', caption: ['すべてのジェンツはセットの中央に左手を出して、自分のパートナーとRight hand in right、右手をとる', '反時計回りに一つ右隣へ移動したら、ジェンツはレディーを時計回りにTurnさせる(4 bars)', '同じ動作を繰り返して元の位置へ戻る(12 bars)'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (open) & House across', caption: ['すべてのカップルはopen waltz holdになる', 'セットの中央に向かってAdvance & Retireし、その後House acrossする(4 bars)', '同じ動作を繰り返して元の位置へ戻る(4 bars)'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (open) & House across' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 2,
      summary: 'Arches',
      rythmn: 'Reel',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=p5kdpid4ehY',
        start: 123
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing with your Corner', caption: ['コーナーパートナーと向き合い、waltz holdになってSwingする'] },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R)', caption: ['パートナーと右手をとって、セットの中央に向かってAdcance & Retireを2回する'] },
        { bar: 8, subject: 'Everyone', summary: 'Turn the Ladies', caption: ['ジェンツは右手でレディーを時計回りに2回Turnさせる'] },
        { bar: 8, subject: 'Everyone', summary: 'Pass & Swing (waltz)', caption: ['パートナーと右肩ですれ違いホームポジションへ戻る(2 bars)', 'その後、元のパートナーとSwingする(6 bars)'] },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (R-in-R) & Arches', caption: ['Leading CouplesはRight hand in right、右手をとってAdvance & Retireする(4 bars)', 'その後、Leading Couplesは右手をとったままアーチを作り、oppositeのカップルはその下を通る。このとき、レディーが先導する', 'oppositeのカップルは反対側へ移動したら、レディーは反時計回り、ジェンツは時計回りに半周してセットの中央を向く', 'Leading Coupleは手をつないだまま時計回りにTurnしてセットの中央を向く'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Adv-Ret (R-in-R) & Arches', caption: ['Leadingを逆にして元の位置へ戻る'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 24, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 3,
      summary: 'Chain',
      rythmn: 'Reel',
      youtube: {
        url: 'https://www.youtube.com/watch?v=p5kdpid4ehY',
        start: 230
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'Ladies Chain (under)', caption: ['Leading Ladiesはセットの中央で右手をとってその場で2周する', 'その後、ホームポジションへ戻りパートナーと向き合う'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'Swing (waltz)', type: 'repeat' },
        { bar: 16, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: 8, subject: 'Everyone', summary: 'Back to back', caption: ['パートナーと向き合ってBack to backする', '右肩ですれ違い、右側へ移動し、後退しながら左肩ですれ違う(6 bars)', 'パートナーと向き合ってその場でステップする(2 bars)'] },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)' },
        { bar: 8, subject: 'Everyone', summary: 'Adv-Ret (R-in-R) & Pass through', caption: ['Right hand in right、パートナーと右手をとる', 'Leading Couplesは左側のカップルと、そうでないカップルは右側のカップルと向き合う', 'すべてのカップルはAdvance & Retireする(4 bars)', 'その後、Pass throughで位置を入れ替える', 'その際、レディーは内側、ジェンツは外側になるように動く'], type: 'repeat' },
        { bar: 24, subject: 'Everyone', summary: '<<Repeat ×3>>', caption: ['同じ動作を繰り返してホームポジションまで戻る'], type: 'call-repeat' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 4,
      summary: 'Swing with opposites',
      rythmn: 'Jig',
      description: '繰り返し部分は Tops - Tops - Sides - Sides の順で Leading Couples が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=ebzF_RXPq5o',
        start: 572
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Lead Around (cross)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Gents', summary: 'Swing with opposites', caption: ['Leading Gentsはオポジットのレディーと右肩ですれ違い、oppositeのレディーとSwingする'], type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 8, subject: 'Leading Gents', summary: 'Swing with partners', type: 'repeat' },
        { bar: 8, subject: 'Leading Couples', summary: 'House each other', type: 'repeat' },
        { bar: 40, subject: 'Sides', summary: '<<Repeat>>', type: 'call-repeat' },
        { bar: '' },
        { bar: 16, subject: 'Everyone', summary: 'Chain & Swing', caption: ['パートナーと向き合い右手をとる', 'ジェンツは反時計回りに、レディーは時計回りにChainする(12 bars)', 'ホームポジションへ戻ったらSwingする(4 bars)'], type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    },
    {
      order: 5,
      summary: 'Strip the Willow',
      rythmn: 'Polka',
      description: '繰り返し部分は 1st Top - 2nd Top - 1st Side - 2nd Side の順で Leading Couple が入れ替わる',
      youtube: {
        url: 'https://www.youtube.com/watch?v=p5kdpid4ehY',
        start: 437
      },
      movements: [
        { bar: 8, subject: 'Everyone', summary: 'Circle, Adv-Ret', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Leading Couple', summary: 'House inside', type: 'repeat' },
        { bar: 16, subject: 'Leading Couple', summary: 'Strip the Willow', caption: ['Leading CoupleがHouseを終えるとき、oppositeのカップルはパートナーと離れ、左右のカップルと手をつなぎ、ライン状になる', 'Leading Coupleはパートナーと向き合って右手をとり、右肩ですれ違う', 'Leading Ladyは左側のラインの一番近い人と左手をとり、反時計回りに1周する(2 bars), その間、Leading Gentは右側のラインの一番近い人と左手をとり、反時計回りに1周する', 'その後、セットの中央で互いに右手をとり、時計回りに1周する(2 bars)', '同じ動作をラインの中央にいる人と繰り返し、セットの中央でも1周する(4 bars)', 'もう一度、セットの奥にいる人と左手をとり反時計回りに1周し、パートナーとwaltz holdになり、Houseでホームポジションへ戻り、パートナーと別れてライン上になる(4 bars)'], type: 'repeat' },
        { bar: 72, subject: '2nd Top - 1st Side - 2nd Side', summary: '<<Repeat ×3>>', type: 'call-repeat' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: '' },
        { bar: 8, subject: 'Everyone', summary: 'Swing (waltz)', type: 'common' },
        { bar: 8, subject: 'Everyone', summary: 'House', type: 'common' }
      ]
    }]
  }
}

// https://www.youtube.com/results?search_query=antrim+square

// ログイン機能
// https://ja.onsen.io/vue/
// mode:history
// https://router.vuejs.org/ja/essentials/history-mode.html

// 「はじめに」（基礎的な動きについて、フィガー表で使われている略称、リズムについて）
// 別アプリから戻ったときにトップページに飛ばされる（iPhone）
// FBページサムネイル取得
// コール機能
// Nuxt, SSR

// clere plain set, alias

// アニメーションをつくる
// Advance & Retire
// Circle Advance & Retire
// Lead Around
// Ladies Chain
// Swing
// Home
// House
// Slide In, Slide Out
// Antrim Square
// Pass through
// Square (type 1)
// Square (type 2)
// Little Christmas
// Big Christmas
// Swing Corners
// Star
// Lead Around & Back
// Crossover
// Chain
// Half Chain
// Sevens
// Ladies Chain and Chase the Lady
// Pass through*
// House (D)
// House & Double
// Long Lead Around
// House(céilí)
// Wheel
// Adv-Ret, Swing
// Set & Swing
// Three & One
// Body
// High Gates
// House inside

// セットを足す
// East Galway Set
// Clare Orange & Green Set
// Caragh Lake Jig Set
// Carrowbeg Set
// Fermanagh Set
// Fermanagh Quadrilles Set

export default sets



// WEBPACK FOOTER //
// ./src/assets/sets.js